// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- THEME VARIABLES ------------------------------------------------ */
:root {
  --primary: #0a4ea1;
  --primary-light: #1a6bc8;
  --bg: #f7fafc;
  --text: #1a202c;
  --card-bg: #ffffff;
}

/* --- RESET & BASE --------------------------------------------------- */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background: var(--bg);
  color: var(--text);
}

.skeleton-table-placeholder {
  display: block;
  max-width: 100%;
}

.skeleton-table-placeholder .ant-skeleton,
.skeleton-table-placeholder .ant-skeleton-input {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
}

/* ---------- LOGIN PAGE ---------- */
#loginPage {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #3182ce 0%, #63b3ed 100%);
}

.login-card {
  background: #fff;
  padding: 2.5rem 3rem;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.login-card h1 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 2rem;
  color: #2d3748;
  white-space: nowrap;
}

.login-card label {
  display: block;
  font-size: 14px;
  margin-bottom: 0.25rem;
  text-align: left;
}

.login-card input {
  width: 100%;
  padding: 0.65rem 0.75rem;
  /* margin-bottom: 1.25rem; */
  border: 1px solid #cbd5e0;
  border-radius: 4px;
  font-size: 14px;
}

.remember-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 1.5rem;
  font-size: 13px;
}

.remember-wrapper input {
  accent-color: #3182ce;
}

.login-card button {
  width: 100%;
  padding: 0.75rem;
  background: #3182ce;
  color: #fff;
  font-size: 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}

.login-card button:hover {
  background: var(--primary);
}

/* --- MENU PAGE ------------------------------------------------------ */
.menu-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 32px 0;
  min-height: 100vh;
}

.container {
  width: 100%;
  max-width: 840px;
}

.card {
  background: var(--card-bg);
  border-radius: 12px;
  padding: 2.5rem 2rem 3rem;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  max-width: 700px;
  margin: 0 auto;
}

.menu-container h1 {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 2rem;
  letter-spacing: -0.5px;
  color: var(--primary);
}

.menu-container h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #4a5568;
}

/* --- MENU BUTTONS --------------------------------------------------- */
.btn-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

/* Wrapper for button + description */
.btn-item {
  flex: 1 1 240px;
  display: flex;
  flex-direction: column;
}

.btn-item-half {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc((100% - 1.5rem) / 2);
}

.btn-item .btn-menu {
  flex: none;
}

.contract-active-menu {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.contract-active-menu .btn-item {
  min-width: 0;
}

.contract-active-menu .btn-menu {
  width: 100%;
  min-height: 46px;
}

@media (max-width: 768px) {
  .contract-active-menu {
    grid-template-columns: 1fr;
  }

  .btn-item-half {
    flex-basis: 100%;
  }
}

.account-menu-spacer {
  visibility: hidden;
}

.btn-item .btn-desc,
.btn-desc {
  margin-top: 0.5rem;
  font-size: 14px;
  color: #718096;
  text-align: center;
  line-height: 1.4;
}

.btn-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 240px;
  background: var(--primary);
  color: #fff;
  font-size: 17px;
  font-weight: 600;
  padding: 0.6rem 1.25rem;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease;
}

.btn-menu:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  background: var(--primary-light);
}

.btn-menu:active {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.btn-menu.logout-btn {
  background: #e53e3e;
}

.btn-menu.logout-btn:hover {
  background: #c53030;
}

.btn-menu.change-password-btn {
  background: #e7eaec;
  color: #4a5568;
}

.btn-menu.change-password-btn:hover {
  background-color: #ccd1d6;
}

.btn-menu-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
}

.btn-menu-inline-badge .ant-badge-count {
  box-shadow: none;
}

.settings-panel {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 24px;
}

.contracts-list-page.settings-page {
  margin: 0 auto;
  max-width: 980px;
}

.settings-panel-header {
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 24px;
  padding-bottom: 16px;
}

.settings-panel-header h3 {
  color: #1a202c;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 6px;
}

.settings-panel-header p {
  color: #718096;
  font-size: 14px;
  margin: 0;
}

.settings-row {
  display: grid;
  gap: 24px;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 420px);
}

.settings-row-copy label {
  color: #2d3748;
  display: block;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 8px;
}

.settings-row-copy p,
.settings-note {
  color: #718096;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

.settings-row-control {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: flex-start;
}

.settings-row-control span {
  color: #2d3748;
  font-size: 14px;
  line-height: 1.5;
}

.settings-note {
  margin-top: 20px;
}

.settings-actions {
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 20px;
}

.broker-basic-info-form {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.broker-basic-info-alert {
  margin-bottom: 2px;
}

.broker-basic-info-section h3 {
  color: #1a202c;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 14px;
}

.broker-basic-info-section-note {
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
  margin: -6px 0 14px;
}

.broker-basic-info-grid {
  display: grid;
  gap: 4px 18px;
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.broker-basic-info-grid > .ant-form-item {
  grid-column: span 6;
}

.broker-basic-info-address-grid {
  grid-template-columns: 240px 260px;
  max-width: 518px;
}

.broker-basic-info-address-grid > .broker-basic-info-field--postcode {
  grid-column: 1;
  grid-row: 1;
  max-width: 240px;
}

.broker-basic-info-address-grid > .broker-basic-info-field--pref {
  grid-column: 1;
  grid-row: 2;
}

.broker-basic-info-address-grid > .broker-basic-info-field--district {
  grid-column: 2;
  grid-row: 2;
}

.broker-basic-info-address-grid > .broker-basic-info-field--address {
  grid-column: 1 / span 2;
  grid-row: 3;
}

.broker-basic-info-address-grid > .broker-basic-info-field--building {
  grid-column: 1 / span 2;
  grid-row: 4;
}

.broker-basic-info-form .ant-form-item {
  margin-bottom: 16px;
}

.broker-basic-info-actions {
  margin-top: 2px;
}

.broker-profile-setup-page {
  background: #f5f7fb;
  min-height: 100vh;
  padding: 40px 20px;
}

.broker-profile-setup-shell {
  margin: 0 auto;
  max-width: 980px;
}

.broker-profile-setup-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
}

.broker-profile-setup-header p {
  color: #718096;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  margin: 0 0 4px;
}

.broker-profile-setup-header h1 {
  color: #1a202c;
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}

.broker-profile-setup-panel {
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
}

@media (max-width: 768px) {
  .settings-panel {
    padding: 18px;
  }

  .settings-row {
    grid-template-columns: 1fr;
  }

  .settings-row-control {
    align-items: flex-start;
    flex-direction: column;
  }

  .settings-actions {
    justify-content: stretch;
  }

  .settings-actions .ant-btn {
    width: 100%;
  }

  .broker-basic-info-grid {
    grid-template-columns: 1fr;
  }

  .broker-basic-info-grid > .ant-form-item,
  .broker-basic-info-address-grid > .broker-basic-info-field--postcode,
  .broker-basic-info-address-grid > .broker-basic-info-field--pref,
  .broker-basic-info-address-grid > .broker-basic-info-field--district,
  .broker-basic-info-address-grid > .broker-basic-info-field--address,
  .broker-basic-info-address-grid > .broker-basic-info-field--building {
    grid-column: 1;
    grid-row: auto;
    max-width: none;
  }

  .broker-profile-setup-page {
    padding: 22px 14px;
  }

  .broker-profile-setup-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .account-menu-spacer {
    display: none;
  }
}

.broker-fee-radio {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
}

.broker-fee-radio .ant-radio-button-wrapper {
  min-width: 150px;
  height: 36px;
  line-height: 34px;
  text-align: center;
  white-space: nowrap;
}

.broker-fee-recipient-row {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
}

.broker-access-fee-requirement-text {
  color: #b45309;
  font-size: 12px;
  line-height: 1.5;
}

.broker-access-modal-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.broker-access-create-modal .ant-modal-content {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 160px);
}

.broker-access-create-modal .ant-modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
}

.broker-access-guidance {
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #1e3a8a;
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 14px;
  line-height: 1.55;
}

.broker-access-guidance p {
  margin-top: 4px;
}

.broker-access-step {
  border: 1px solid #d8dee9;
  border-radius: 6px;
  background: #fff;
}

.broker-access-step-header {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px 16px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.broker-access-step-number {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: var(--primary);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
}

.broker-access-step-header h3 {
  margin: 0;
  color: #1f2937;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
}

.broker-access-step-header p {
  margin: 3px 0 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
}

.broker-access-step-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
}

.broker-access-field-row {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  gap: 14px;
  align-items: start;
}

.broker-access-field-row > label {
  padding-top: 7px;
  color: #374151;
  font-size: 14px;
  font-weight: 700;
}

.broker-access-status-text {
  margin-top: 8px;
  color: #1d4ed8;
  font-size: 13px;
}

.broker-access-selected-broker {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  background: #eff6ff;
  padding: 10px 12px;
  margin-top: 12px;
}

.broker-access-selected-broker span {
  display: block;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 2px;
}

.broker-access-selected-broker strong {
  display: block;
  color: #111827;
  font-size: 14px;
  line-height: 1.4;
}

.broker-access-selected-broker p {
  color: #475569;
  font-size: 13px;
  margin-top: 2px;
}

.broker-access-new-broker-box {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
  padding: 12px;
  margin-top: 12px;
}

.broker-access-help-text {
  margin-top: 8px;
  color: #64748b;
  font-size: 13px;
}

.broker-access-warning-text {
  margin-top: 6px;
  color: #b45309;
  font-size: 13px;
}

.broker-access-selection-table,
.broker-access-room-fee-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.broker-access-selection-table th,
.broker-access-selection-table td,
.broker-access-room-fee-table th,
.broker-access-room-fee-table td {
  border: 1px solid #d1d5db;
  padding: 9px 10px;
  vertical-align: middle;
}

.broker-access-selection-table th,
.broker-access-room-fee-table th {
  background: #f3f4f6;
  color: #374151;
  font-weight: 700;
}

.broker-access-selection-table tbody tr,
.broker-access-selection-table tbody td {
  background: #fff;
}

.broker-access-selection-table tbody tr:hover {
  background: #eff6ff;
}

.broker-access-selection-table tbody tr:hover td {
  background: #eff6ff;
}

.broker-access-room-tag-input {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  padding: 5px 8px;
}

.broker-access-room-tag-input:focus-within {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
}

.broker-access-room-tag-input .ant-tag {
  display: inline-flex;
  align-items: center;
  margin: 0;
  border-radius: 999px;
  padding: 3px 9px;
  font-size: 13px;
}

.broker-access-room-tag-input input {
  flex: 1 1 140px;
  min-width: 120px;
  border: 0;
  outline: 0;
  padding: 4px 0;
  font-size: 14px;
  line-height: 1.5;
}

.broker-access-note {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
  color: #4b5563;
  padding: 10px 12px;
  font-size: 13px;
}

.broker-access-permission-draft {
  display: flex;
  flex-direction: column;
  gap: 14px;
  border: 1px solid #d8dee9;
  border-radius: 6px;
  background: #f8fafc;
  padding: 14px;
}

.broker-access-permission-draft > .broker-access-subheading {
  margin-bottom: 0;
}

.broker-access-draft-actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
}

.broker-access-property-draft {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  background: #eff6ff;
  padding: 10px 12px;
}

.broker-access-property-draft span,
.broker-access-property-card-header span {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 2px;
}

.broker-access-property-title {
  min-width: 0;
}

.broker-access-property-title-line {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
  align-items: baseline;
  min-width: 0;
}

.broker-access-property-draft strong,
.broker-access-property-card-header strong {
  color: #111827;
  font-size: 14px;
  line-height: 1.45;
}

.broker-access-property-draft p,
.broker-access-property-card-header p {
  color: #64748b;
  font-size: 13px;
  line-height: 1.45;
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.broker-access-property-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.broker-access-property-card {
  border: 1px solid #d8dee9;
  border-radius: 6px;
  background: #fff;
}

.broker-access-property-card-header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  padding: 9px 12px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.broker-access-property-card-header > div {
  min-width: 0;
}

.broker-access-property-card-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 14px;
}

.broker-access-property-setting-row {
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}

.broker-access-property-setting-row > label {
  padding-top: 7px;
  color: #374151;
  font-size: 13px;
  font-weight: 700;
}

.broker-access-subheading {
  margin-bottom: 8px;
  color: #374151;
  font-size: 14px;
  font-weight: 700;
}

.broker-access-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.broker-access-summary > div {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
  padding: 10px 12px;
  min-width: 0;
}

.broker-access-summary span {
  display: block;
  color: #6b7280;
  font-size: 12px;
  margin-bottom: 3px;
}

.broker-access-summary strong {
  display: block;
  color: #111827;
  font-size: 14px;
  line-height: 1.45;
  overflow-wrap: break-word;
}

.table-wrapper.broker-access-table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.review-table.broker-access-list-table {
  width: 100%;
  min-width: 1248px;
  table-layout: fixed;
}

.review-table.broker-access-list-table td {
  font-weight: 400;
}

.review-table.broker-access-list-table .broker-access-list-col-broker {
  width: 210px;
}

.review-table.broker-access-list-table .broker-access-list-col-room {
  width: 130px;
}

.review-table.broker-access-list-table .broker-access-list-col-fee {
  width: 128px;
}

.review-table.broker-access-list-table .broker-access-list-col-delegation {
  width: 112px;
}

.review-table.broker-access-list-table .broker-access-list-col-contract {
  width: 82px;
}

.review-table.broker-access-list-table .broker-access-list-col-status {
  width: 78px;
}

.review-table.broker-access-list-table .broker-access-list-col-operation {
  width: 72px;
}

.review-table.broker-access-list-table th:nth-child(1),
.review-table.broker-access-list-table td:nth-child(1) {
  width: 210px;
}

.review-table.broker-access-list-table th:nth-child(2),
.review-table.broker-access-list-table td:nth-child(2) {
  width: auto;
}

.review-table.broker-access-list-table th:nth-child(3),
.review-table.broker-access-list-table td:nth-child(3) {
  width: 130px;
}

.review-table.broker-access-list-table th:nth-child(4),
.review-table.broker-access-list-table td:nth-child(4) {
  width: 128px;
  text-align: center;
  white-space: nowrap;
}

.review-table.broker-access-list-table th:nth-child(4) {
  line-height: 1.35;
  white-space: normal;
}

.review-table.broker-access-list-table th:nth-child(5),
.review-table.broker-access-list-table td:nth-child(5) {
  width: 112px;
  text-align: center;
  white-space: nowrap;
}

.review-table.broker-access-list-table th:nth-child(6),
.review-table.broker-access-list-table td:nth-child(6) {
  width: 82px;
  text-align: center;
  white-space: nowrap;
}

.review-table.broker-access-list-table th:nth-child(7),
.review-table.broker-access-list-table td:nth-child(7) {
  width: 78px;
  text-align: center;
  white-space: nowrap;
}

.review-table.broker-access-list-table th:nth-child(8),
.review-table.broker-access-list-table td:nth-child(8) {
  width: 72px;
  min-width: 72px;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  text-align: center;
  white-space: nowrap;
}

.broker-access-list-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.broker-access-page-title {
  text-wrap: balance;
}

.broker-access-property-cell {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.broker-access-property-count {
  flex: 0 0 auto;
  white-space: nowrap;
}

.broker-access-property-names {
  min-width: 0;
  overflow: hidden;
  color: #4b5563;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.broker-access-list-actions {
  display: flex;
  justify-content: center;
}

.broker-access-detail {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.broker-access-detail-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px 20px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
  padding: 14px 16px;
  font-size: 14px;
}

.broker-access-detail-summary > div {
  min-width: 0;
}

.broker-access-detail-summary .font-semibold,
.broker-access-detail-summary .text-gray-500 + div {
  overflow-wrap: break-word;
}

.broker-access-detail-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #d1d5db;
  font-size: 13px;
  table-layout: fixed;
}

.broker-access-detail-table th,
.broker-access-detail-table td {
  border: 1px solid #d1d5db;
  padding: 8px 10px;
  text-align: left;
  vertical-align: middle;
}

.broker-access-detail-table th {
  background: #f8fafc;
  color: #374151;
  font-weight: 700;
}

.broker-access-detail-table th:nth-child(3),
.broker-access-detail-table td:nth-child(3),
.broker-access-detail-table th:nth-child(4),
.broker-access-detail-table td:nth-child(4),
.broker-access-detail-table th:nth-child(5),
.broker-access-detail-table td:nth-child(5) {
  width: 110px;
  text-align: center;
  white-space: nowrap;
}

.broker-access-detail-table th:last-child,
.broker-access-detail-table td:last-child {
  width: 112px;
  text-align: center;
  white-space: nowrap;
}

.broker-access-room-list {
  max-width: 280px;
  overflow-wrap: break-word;
  line-height: 1.45;
}

.broker-access-room-delegation-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.broker-access-room-delegation-list > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.broker-access-room-delegation-list span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .broker-access-field-row,
  .broker-access-summary {
    grid-template-columns: 1fr;
  }

  .broker-access-detail-summary {
    grid-template-columns: 1fr;
  }

  .broker-access-property-draft,
  .broker-access-property-card-header {
    align-items: stretch;
    flex-direction: column;
  }

  .broker-access-property-setting-row {
    grid-template-columns: 1fr;
  }

  .broker-access-new-broker-box .grid,
  .broker-access-permission-draft .grid {
    grid-template-columns: 1fr;
  }

  .broker-access-draft-actions {
    justify-content: stretch;
  }

  .broker-access-draft-actions .ant-btn {
    width: 100%;
  }
}

/* --- BUSINESS MENU TABS --------------------------------------------- */
.business-menu-tabs .ant-tabs-nav {
  margin-bottom: 1.5rem;
}

.business-menu-tabs .ant-tabs-tab {
  font-size: 16px;
  font-weight: 600;
  padding: 12px 24px;
}

.business-menu-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: var(--primary);
}

.business-menu-tabs .ant-tabs-ink-bar {
  background: var(--primary);
}

.tab-content {
  min-height: 300px;
}

/* --- FLOW CHART STYLES ---------------------------------------------- */
.flow-container-full {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}

.flow-section {
  padding: 1rem 0;
  border-bottom: 1px solid #e2e8f0;
}

.flow-section:last-child {
  border-bottom: none;
}

.flow-section-label {
  font-size: 18px;
  font-weight: 700;
  color: var(--primary);
  margin-bottom: 1rem;
  padding-left: 0.5rem;
  border-left: 4px solid var(--primary);
}

/* 横並びレイアウト（番号+ボタン左、説明右） */
.flow-step-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.flow-step-row:last-child {
  margin-bottom: 0;
}

.flow-step-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 280px;
  flex-shrink: 0;
}

.flow-step-number {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  flex-shrink: 0;
}

.flow-step-number-placeholder {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.flow-step-left .btn-menu.flow-btn {
  flex: 1 1;
}

.flow-step-right {
  flex: 1 1;
}

.flow-step-desc {
  margin: 0;
  font-size: 14px;
  color: #718096;
  line-height: 1.4;
}

.btn-icon {
  display: inline-flex;
  align-items: center;
  margin-right: 0.5rem;
}

.flow-arrow-down {
  display: none;
}

/* 横並び2ボタン */
.flow-step-dual-row {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.flow-step-dual-row:last-child {
  margin-bottom: 0;
}

.flow-step-dual-content {
  display: flex;
  gap: 1rem;
  flex: 1 1;
}

.flow-dual-item {
  flex: 1 1;
  max-width: 240px;
}

.flow-dual-item .btn-menu.flow-btn {
  width: 100%;
}

.flow-dual-item .flow-step-desc {
  margin-top: 0.5rem;
  text-align: center;
}

/* --- FOOTER --------------------------------------------------------- */
footer {
  text-align: center;
  font-size: 13px;
  color: #718096;
  margin-top: 2rem;
}

footer a {
  color: var(--primary);
  text-decoration: none;
}

/* --- PAGE LAYOUT ---------------------------------------------------- */
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-header {
  background: var(--primary);
  color: white;
  padding: 1rem 2rem;
  display: grid;
  grid-template-columns: minmax(160px, 220px) minmax(0, 1fr) minmax(280px, auto);
  column-gap: 16px;
  align-items: center;
  min-height: 72px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-width: 0;
}

.header-logo-main {
  height: auto;
  max-height: 60px;
  margin: -16px 0;
  object-fit: contain;
}

.header-logo {
  width: 50px;
  height: auto;
  object-fit: contain;
}

.page-header h1 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
}

.header-actions {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  min-width: 0;
}

.header-account-badge {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #374151;
  font-size: 14px;
  line-height: 1.4;
  max-width: 320px;
  overflow: hidden;
  padding: 6px 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.back-btn,
.logout-btn-header {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
  white-space: nowrap;
}

.back-btn:hover,
.logout-btn-header:hover {
  background: rgba(255, 255, 255, 0.3);
}

.logout-btn-header {
  flex: 0 0 auto;
  justify-self: end;
}

.page-main {
  flex: 1 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

@media (max-width: 640px) {
  .page-header {
    grid-template-columns: 1fr 1fr;
    padding: 10px 16px;
    row-gap: 8px;
  }

  .header-content {
    gap: 8px;
    grid-column: 1 / -1;
    grid-row: 1;
    max-width: 100%;
  }

  .header-logo-main {
    max-height: 34px;
    max-width: 170px;
    margin: 0;
  }

  .page-header h1 {
    font-size: 16px;
  }

  .back-btn {
    grid-column: 1;
    grid-row: 2;
    justify-self: start;
  }

  .header-actions {
    display: contents;
  }

  .header-account-badge {
    display: block;
    grid-column: 1 / -1;
    grid-row: 3;
    justify-self: stretch;
    max-width: none;
    text-align: center;
  }

  .logout-btn-header {
    grid-column: 2;
    grid-row: 2;
  }

  .header-actions .logout-btn-header {
    justify-self: end;
  }

  .back-btn,
  .logout-btn-header {
    font-size: 12px;
    padding: 8px 10px;
  }

  .page-main {
    padding: 1rem;
  }
}

.page-content h2 {
  font-size: 28px;
  font-weight: 600;
  color: var(--primary);
  margin-bottom: 1rem;
}

.page-content p {
  font-size: 16px;
  color: #4a5568;
}

/* --- VARIABLE REGISTER PAGE ----------------------------------------- */
.variable-register-page {
  width: 100%;
  max-width: 1400px;
}

.variable-register-page h2 {
  font-size: 28px;
  font-weight: 600;
  color: var(--primary);
  margin-bottom: 2rem;
}

.variable-register-page.variable-cost-register-page {
  width: min(1260px, calc(100vw - 4rem));
  max-width: none;
  margin-left: 50%;
  transform: translateX(-50%);
}

.variable-register-page.subrogation-payment-page {
  width: min(1260px, calc(100vw - 4rem));
  max-width: none;
  margin-left: 50%;
  transform: translateX(-50%);
}

.variable-cost-context-row {
  display: flex;
  align-items: stretch;
  gap: 1rem;
  margin-bottom: 1rem;
}

.variable-cost-register-page .variable-cost-month-navigation {
  flex: 0 0 auto;
  height: 58px;
  min-height: 0;
  border-radius: 12px;
  padding: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.variable-cost-month-navigation .month-display {
  min-width: 16rem;
}

.variable-cost-register-page .variable-cost-deadline-info {
  flex: 1 1 420px;
  margin-bottom: 0;
}

.variable-cost-deadline-info .deadline-card {
  height: 58px;
}

.subrogation-context-row {
  display: flex;
  align-items: stretch;
  gap: 1rem;
  margin-bottom: 1rem;
}

.subrogation-payment-page .subrogation-month-navigation {
  flex: 0 0 auto;
  height: 58px;
  min-height: 0;
  border-radius: 12px;
  padding: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.subrogation-payment-page .subrogation-month-navigation .month-display {
  min-width: 10rem;
}

.subrogation-deadline-summary {
  align-items: stretch;
}

.subrogation-deadline-summary .subrogation-deadline-info {
  flex: 1 1;
  margin-bottom: 0;
  min-width: 0;
}

.subrogation-deadline-summary .subrogation-deadline-card {
  min-height: 58px;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
}

.subrogation-deadline-copy {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.subrogation-deadline-summary .deadline-label,
.subrogation-deadline-summary .deadline-date {
  white-space: nowrap;
}

.subrogation-create-month-navigation {
  flex: 0 0 auto;
  align-self: stretch;
}

.subrogation-create-month-navigation .month-display {
  min-width: 8rem;
  text-align: center;
}

/* FILTERS SECTION */
.filters-section {
  margin-bottom: 1.5rem;
}

.filter-group {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

.search-input,
.month-picker {
  padding: 0.65rem 0.9rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  min-width: 200px;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.search-input:focus,
.month-picker:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(43, 108, 176, 0.1);
}

.search-input::placeholder {
  color: #a0aec0;
}

/* ACTIONS SECTION */
.actions-section {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.variable-cost-actions-section {
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  flex-wrap: nowrap;
}

.variable-cost-register-page .variable-cost-search-input {
  flex: 0 1 360px;
  height: 42px;
  min-width: 280px;
  max-width: 360px;
  padding: 0 1rem;
  border-radius: 8px;
}

.variable-cost-action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-left: auto;
}

.variable-cost-register-page .variable-cost-action-buttons .btn-outline,
.variable-cost-register-page .variable-cost-action-buttons .btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  padding: 0 1.25rem;
  font-size: 14px;
  line-height: 1;
  white-space: nowrap;
}

.variable-cost-target-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: 0 0 1rem;
  padding: 1rem 1.125rem;
  border: 1px solid #dbe7f4;
  border-radius: 12px;
  background: #f8fbff;
}

.variable-cost-target-selector h3 {
  margin: 0 0 0.25rem;
  color: #1f4f82;
  font-size: 16px;
  font-weight: 650;
}

.variable-cost-target-selector p {
  margin: 0;
  color: #4a5c70;
  font-size: 13px;
}

.variable-cost-target-entry {
  flex: 0 0 auto;
  min-height: 42px;
  white-space: nowrap;
}

.variable-cost-target-dialog-backdrop {
  position: fixed;
  z-index: 1200;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 1.25rem;
  background: rgba(20, 42, 68, 0.44);
}

.variable-cost-initial-target-dialog-backdrop {
  width: 100vw;
  min-height: 100vh;
  min-height: 100dvh;
  overflow: auto;
}

.variable-cost-target-dialog {
  width: min(880px, 100%);
  max-height: min(760px, calc(100vh - 2.5rem));
  overflow: auto;
  padding: 1.25rem;
  border: 1px solid #cbdceb;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 18px 48px rgba(19, 46, 76, 0.3);
}

.variable-cost-target-dialog-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.variable-cost-target-dialog h3 {
  margin: 0 0 0.4rem;
  color: #183f67;
  font-size: 20px;
}

.variable-cost-target-dialog p {
  margin: 0;
  color: #526579;
  font-size: 13px;
  line-height: 1.5;
}

.variable-cost-target-search-row {
  display: grid;
  grid-template-columns: auto minmax(220px, 1fr) auto;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.variable-cost-target-search-row label {
  color: #334e68;
  font-size: 14px;
  font-weight: 600;
}

.variable-cost-target-search-row input {
  min-width: 0;
  min-height: 42px;
  padding: 0 0.75rem;
  border: 1px solid #b9cadb;
  border-radius: 8px;
  font-size: 14px;
}

.variable-cost-target-search-row input:focus-visible,
.variable-cost-target-dialog button:focus-visible,
.variable-cost-target-results input:focus-visible {
  outline: 3px solid rgba(38, 121, 205, 0.35);
  outline-offset: 2px;
}

.variable-cost-target-message {
  margin: 0 0 0.75rem !important;
  padding: 0.65rem 0.75rem;
  border: 1px solid #f4b4b4;
  border-radius: 8px;
  background: #fff5f5;
  color: #a12828 !important;
}

.variable-cost-target-selection-summary {
  margin-bottom: 0.5rem;
  color: #234f7d;
  font-size: 14px;
  font-weight: 650;
}

.variable-cost-target-results {
  overflow-x: auto;
  border: 1px solid #dbe3eb;
  border-radius: 8px;
  background: #fff;
}

.variable-cost-target-results > p {
  padding: 1.25rem;
  text-align: center;
}

.variable-cost-target-results table {
  width: 100%;
  min-width: 660px;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 14px;
}

.variable-cost-target-results th,
.variable-cost-target-results td {
  padding: 0.7rem 0.75rem;
  border-bottom: 1px solid #e6edf4;
  color: #283e54;
  text-align: left;
  vertical-align: top;
}

.variable-cost-target-results th {
  background: #f4f8fc;
  color: #365675;
  font-size: 13px;
  font-weight: 650;
  white-space: nowrap;
}

.subrogation-excel-target-dialog .variable-cost-target-results th:first-child,
.subrogation-excel-target-dialog .variable-cost-target-results td:first-child {
  width: 40px;
  padding-right: 0;
  padding-left: 0;
  text-align: center;
  vertical-align: middle;
}

.subrogation-excel-target-dialog .subrogation-excel-selection-checkbox {
  display: block;
  width: 16px;
  height: 16px;
  margin: 0 auto;
}

.variable-cost-initial-target-dialog .variable-cost-target-results th:first-child,
.variable-cost-initial-target-dialog .variable-cost-target-results td:first-child {
  min-width: 96px;
  white-space: nowrap;
}

.variable-cost-initial-target-dialog .variable-cost-initial-target-selection-label {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  white-space: nowrap;
}

.variable-cost-target-results tbody tr:not(.is-already-selected):hover {
  background: #f7fbff;
}

.variable-cost-target-results .is-already-selected {
  background: #f8f8f8;
  color: #718096;
}

.variable-cost-target-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}

/* The Excel selector is portaled to the document body and owns its result scrolling. */
.subrogation-excel-target-dialog-backdrop {
  display: flex;
  align-items: center;
  justify-content: center;
  overscroll-behavior: contain;
}

.subrogation-excel-target-dialog {
  display: flex;
  flex-direction: column;
  max-height: min(760px, calc(100vh - 2.5rem));
  max-height: min(760px, calc(100dvh - 2.5rem));
  overflow: hidden;
}

.subrogation-excel-target-dialog .variable-cost-target-dialog-heading,
.subrogation-excel-target-dialog .variable-cost-target-search-row,
.subrogation-excel-target-dialog .variable-cost-target-selection-summary,
.subrogation-excel-target-dialog .variable-cost-target-dialog-actions {
  flex: 0 0 auto;
}

.subrogation-excel-target-dialog .variable-cost-target-results {
  min-height: 0;
  max-height: min(50vh, 420px);
  overflow: auto;
  overscroll-behavior: contain;
}

.subrogation-excel-claim-type-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1rem;
  margin: 0 0 0.9rem;
  padding: 0.7rem 0.8rem;
  border: 1px solid #dbe7f4;
  border-radius: 8px;
  background: #f8fbff;
}

.subrogation-excel-claim-type-selector legend {
  width: 100%;
  margin-bottom: 0.2rem;
  color: #334e68;
  font-size: 13px;
  font-weight: 650;
}

.subrogation-excel-claim-type-selector label {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #283e54;
  font-size: 13px;
}

.subrogation-evidence-modal-backdrop {
  position: fixed;
  z-index: 1210;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(20, 42, 68, 0.48);
  overscroll-behavior: contain;
}

.subrogation-evidence-modal {
  display: flex;
  flex-direction: column;
  width: min(900px, 100%);
  max-height: min(820px, calc(100dvh - 2rem));
  overflow: hidden;
  border: 1px solid #cbdceb;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 18px 48px rgba(19, 46, 76, 0.3);
}

body.subrogation-evidence-delete-confirm-open .ant-modal-mask {
  z-index: 1300 !important;
}

body.subrogation-evidence-delete-confirm-open .ant-modal-wrap {
  z-index: 1301 !important;
}

.subrogation-evidence-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #dbe3eb;
  background: #f8fbff;
}

.subrogation-evidence-modal-header .btn-outline {
  flex: 0 0 auto;
  white-space: nowrap;
}

.subrogation-evidence-modal-header h3 {
  margin: 0 0 0.25rem;
  color: #183f67;
  font-size: 20px;
}

.subrogation-evidence-modal-header p {
  margin: 0;
  color: #526579;
  font-size: 13px;
}

.subrogation-evidence-modal-body {
  min-height: 0;
  overflow: auto;
  padding: 1rem 1.25rem 1.25rem;
}

.subrogation-evidence-summary,
.subrogation-evidence-guidance,
.subrogation-evidence-upload-section {
  margin-bottom: 1rem;
  padding: 0.8rem;
  border: 1px solid #dbe7f4;
  border-radius: 8px;
  background: #f8fbff;
}

.subrogation-evidence-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem 0.75rem;
  color: #234f7d;
  font-size: 13px;
}

.subrogation-evidence-summary span {
  color: #526579;
}

.subrogation-evidence-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1.25rem;
  background: var(--primary);
  color: white;
}

.subrogation-evidence-section-header h3 {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0 !important;
  background: transparent !important;
  color: inherit !important;
}

.subrogation-evidence-guidance h4,
.subrogation-evidence-upload-section h4,
.subrogation-evidence-section-heading h4,
.subrogation-current-files-heading h4 {
  margin: 0 0 0.4rem;
  color: #334e68;
  font-size: 14px;
}

.subrogation-evidence-guidance ul {
  margin: 0;
  padding-left: 1.25rem;
  color: #526579;
  font-size: 13px;
  line-height: 1.55;
}

.subrogation-evidence-error {
  margin: 0 0 1rem !important;
  padding: 0.65rem 0.75rem;
  border: 1px solid #f4b4b4;
  border-radius: 8px;
  background: #fff5f5;
  color: #a12828 !important;
  white-space: pre-line;
}

.subrogation-evidence-loading,
.subrogation-evidence-empty,
.subrogation-evidence-readonly {
  margin: 0 0 1rem;
  color: #526579;
  font-size: 13px;
}

.subrogation-evidence-file-list-section {
  margin-bottom: 1rem;
}

.subrogation-current-files-container {
  margin: 0;
  padding: 0 1rem 1rem;
}

.subrogation-current-files-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid #e0e8f0;
}

.subrogation-current-files-heading span {
  color: #526579;
  font-size: 12px;
}

.subrogation-current-files-container > .ant-upload-list {
  margin: 0;
}

.subrogation-current-files-container > .subrogation-evidence-empty {
  margin-bottom: 0;
}

.subrogation-detail-contract-search {
  display: block !important;
  margin-bottom: 1rem;
}

.subrogation-detail-contract-search .subrogation-detail-contract-label {
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
}

.subrogation-detail-contract-search .subrogation-detail-contract-input,
.subrogation-detail-contract-search .subrogation-detail-contract-value {
  display: block;
  width: min(520px, 100%);
  max-width: 100%;
}

.subrogation-detail-contract-search .subrogation-detail-contract-helper {
  margin: 8px 0 0;
}

.subrogation-current-file-download-button {
  flex: 0 0 auto;
  padding: 0.3rem 0.55rem;
  font-size: 11px;
  white-space: nowrap;
}

/* Detail-mode evidence rows stay compact while giving the file identity clear priority. */
.subrogation-detail-file-row {
  margin-bottom: 0.5rem;
}

.subrogation-detail-file-row .custom-upload-list.subrogation-detail-file-item {
  min-height: 48px;
  gap: 0.75rem;
  padding: 10px 12px;
  border: 1px solid #dbe7f4;
  border-radius: 8px;
  background: #fff;
}

.subrogation-detail-file-row .custom-upload-list.subrogation-detail-file-item .ant-upload-list-item-name {
  flex: 1 1 auto;
  min-width: 0;
  color: #234f7d;
  font-size: 14px;
  font-weight: 650;
}

.subrogation-detail-file-row .custom-upload-list.subrogation-detail-file-item .subrogation-detail-file-meta {
  flex: 0 1 32%;
  min-width: 0;
  overflow: hidden;
  color: #718096;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subrogation-detail-file-row .custom-upload-list.subrogation-detail-file-item .ant-upload-list-item-actions {
  opacity: 1;
}

.subrogation-detail-file-row .custom-upload-list.subrogation-detail-file-item:focus-within {
  outline: 2px solid rgba(38, 121, 205, 0.45);
  outline-offset: 2px;
}

.subrogation-detail-file-row
  .custom-upload-list.subrogation-detail-file-item:focus-within
  .ant-upload-list-item-actions,
.subrogation-detail-file-row
  .custom-upload-list.subrogation-detail-file-item
  .ant-upload-list-item-actions:focus-within {
  opacity: 1;
}

.subrogation-evidence-section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.subrogation-evidence-section-heading span {
  color: #526579;
  font-size: 12px;
}

.subrogation-evidence-file-list {
  display: grid;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.subrogation-evidence-file-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid #e0e8f0;
  border-radius: 8px;
}

.subrogation-evidence-file-info,
.subrogation-evidence-file-actions,
.subrogation-evidence-pending-row {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 0.45rem;
}

.subrogation-evidence-file-info {
  flex: 1 1 auto;
}

.subrogation-evidence-file-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #234f7d;
  font-size: 13px;
}

.subrogation-evidence-file-meta {
  flex: 0 0 auto;
  color: #718096;
  font-size: 11px;
  white-space: nowrap;
}

.subrogation-evidence-file-actions .btn-small {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
}

.btn-danger-outline {
  border: 1px solid #c97777;
  border-radius: 6px;
  color: #9d3434;
  background: #fff;
}

.btn-danger-outline:hover:not(:disabled) {
  background: #fff5f5;
}

.subrogation-evidence-upload-help {
  margin: 0 0 0.7rem !important;
  color: #526579;
  font-size: 12px;
}

.subrogation-evidence-select-button,
.subrogation-evidence-upload-button {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.subrogation-evidence-pending-list {
  display: grid;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.subrogation-evidence-pending-row {
  padding: 0.5rem 0.65rem;
  border: 1px solid #e0e8f0;
  border-radius: 6px;
}

.subrogation-evidence-pending-row > span {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.subrogation-evidence-pending-row select {
  min-width: 190px;
  max-width: 42%;
  padding: 0.25rem;
  border: 1px solid #b9cadb;
  border-radius: 6px;
  font-size: 12px;
}

.btn-icon-only {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border: 0;
  color: #9d3434;
  background: transparent;
}

.subrogation-evidence-progress {
  position: relative;
  height: 20px;
  overflow: hidden;
  margin-top: 0.5rem;
  border-radius: 999px;
  background: #e5edf5;
  color: #234f7d;
  font-size: 11px;
  line-height: 20px;
  text-align: center;
}

.subrogation-evidence-progress > div {
  position: absolute;
  inset: 0 auto 0 0;
  background: #8ab9df;
  transition: width 0.15s ease;
}

.subrogation-evidence-progress > span {
  position: relative;
}

.variable-cost-remove-target {
  border-color: #c97777;
  color: #9d3434;
  background: #fff;
}

.variable-cost-remove-target:hover:not(:disabled) {
  border-color: #a94444;
  background: #fff5f5;
}

.subrogation-actions-section {
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  flex-wrap: nowrap;
  margin-bottom: 1rem;
}

.subrogation-excel-import-result {
  margin: 0 0 1rem;
  padding: 0.8rem 1rem;
  border: 1px solid #b8d8c4;
  border-radius: 8px;
  background: #f3fbf5;
  color: #285c3a;
  font-size: 13px;
}

.subrogation-excel-import-result.is-error {
  border-color: #f0b4b4;
  background: #fff7f7;
  color: #8f2f2f;
}

.subrogation-excel-import-result-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.subrogation-excel-import-result p {
  margin: 0.35rem 0 0;
}

.subrogation-excel-import-result-counts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 1rem;
  margin-top: 0.45rem;
  font-weight: 650;
}

.subrogation-excel-import-result ul {
  max-height: 8rem;
  overflow: auto;
  margin: 0.45rem 0 0;
  padding-left: 1.25rem;
}

.subrogation-payment-page .subrogation-search-input {
  flex: 0 1 360px;
  height: 42px;
  min-width: 280px;
  max-width: 360px;
  padding: 0 1rem;
  border-radius: 8px;
}

.subrogation-action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-left: auto;
}

.subrogation-payment-page .subrogation-action-buttons .btn-outline,
.subrogation-payment-page .subrogation-action-buttons .btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  padding: 0 1.25rem;
  font-size: 14px;
  line-height: 1;
  white-space: nowrap;
}

.btn-outline {
  background: white;
  color: var(--primary);
  border: 2px solid var(--primary);
  padding: 0.7rem 1.5rem;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-outline:hover {
  background: var(--primary);
  color: white;
  box-shadow: 0 4px 12px rgba(43, 108, 176, 0.2);
}

.btn-outline:disabled {
  background: #e2e8f0;
  color: #a0aec0;
  border-color: #e2e8f0;
  cursor: not-allowed;
  box-shadow: none;
}

.btn-primary {
  background: var(--primary);
  color: white;
  border: none;
  padding: 0.7rem 1.5rem;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover {
  background: var(--primary-light);
  box-shadow: 0 4px 12px rgba(43, 108, 176, 0.2);
}

/* DEADLINE INFO */
.deadline-info {
  margin-bottom: 1.5rem;
}

.deadline-card {
  background: white;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.deadline-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.deadline-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}

.deadline-date {
  font-size: 16px;
  font-weight: 700;
  color: var(--primary);
}

.deadline-countdown {
  font-size: 14px;
  font-weight: 600;
}

.deadline-normal {
  color: #28a745;
  background: #d4edda;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
}

.deadline-warning {
  color: #ffc107;
  background: #fff3cd;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
}

.deadline-urgent {
  color: #dc3545;
  background: #f8d7da;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  animation: pulse 1.5s infinite;
}

.deadline-expired {
  color: #721c24;
  background: #f5c6cb;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }

  100% {
    opacity: 1;
  }
}

/* STATUS FILTER */
.status-filter {
  display: flex;
  gap: 1.5rem;
  margin-top: 0.75rem;
}

.status-filter label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.status-filter input[type="radio"] {
  accent-color: var(--primary);
}

/* MODIFICATION BUTTONS */
.btn-modify {
  background: #ff9500;
  color: white;
  border: none;
  padding: 0.4rem 0.8rem;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-modify:hover {
  background: #e6851f;
  box-shadow: 0 2px 8px rgba(255, 149, 0, 0.3);
}

.btn-history {
  background: #6c757d;
  color: white;
  border: none;
  padding: 0.4rem 0.8rem;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-history:hover {
  background: #5a6268;
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
}

.modification-disabled {
  color: #6c757d;
  font-size: 12px;
  font-weight: 500;
  padding: 0.4rem 0.8rem;
  background: #f8f9fa;
  border-radius: 6px;
}

/* MONTH NAVIGATION */
.month-navigation {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.5rem;
}

.month-nav-btn {
  background: var(--primary);
  color: white;
  border: none;
  width: 2rem;
  height: 2rem;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.2s;
}

.month-nav-btn:hover {
  background: var(--primary-light);
  box-shadow: 0 2px 8px rgba(43, 108, 176, 0.3);
}

.month-display {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
  min-width: 8rem;
  text-align: center;
}

/* TABLE */
.table-wrapper {
  background: white;
  /* border-radius: 12px; */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  /* overflow: auto; */
}

.cost-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;
}

.cost-table thead {
  background: var(--primary);
  color: white;
}

.cost-table th,
.cost-table td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
  white-space: nowrap;
}

.cost-table th {
  font-weight: 600;
  font-size: 14px;
}

.variable-cost-table-wrapper .cost-table thead .table-header-content,
.subrogation-table-wrapper .cost-table thead .table-header-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.variable-cost-table-wrapper .cost-table thead .table-header-content--sortable,
.subrogation-table-wrapper .cost-table thead .table-header-content--sortable {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 17.2px auto auto minmax(0, 1fr);
  align-items: center;
}

.variable-cost-table-wrapper .cost-table thead .table-header-content--sortable::before,
.subrogation-table-wrapper .cost-table thead .table-header-content--sortable::before {
  content: "";
  grid-column: 2;
  width: 17.2px;
}

.variable-cost-table-wrapper .cost-table thead .table-header-content--sortable .table-header-label,
.subrogation-table-wrapper .cost-table thead .table-header-content--sortable .table-header-label {
  grid-column: 3;
}

.variable-cost-table-wrapper .cost-table thead .table-header-content--sortable .sort-indicator,
.subrogation-table-wrapper .cost-table thead .table-header-content--sortable .sort-indicator {
  grid-column: 4;
}

.variable-cost-table-wrapper .cost-table thead .table-header-label,
.subrogation-table-wrapper .cost-table thead .table-header-label {
  display: inline-block;
}

.variable-cost-register-page .cost-table thead th.sticky-status-column.sortable-header {
  position: sticky;
}

.text-right {
  text-align: right !important;
}

.cost-table tbody tr {
  transition: background-color 0.15s;
}

.cost-table tbody tr:hover {
  background: #f7fafc;
}

.cost-table tbody tr.approved-row {
  background: #f0fff4;
}

.cost-table tbody tr.approved-row:hover {
  background: #e6fffa;
}

.subrogation-table-wrapper {
  max-width: 100%;
  overflow: hidden;
}

.subrogation-table-wrapper > .overflow-x-auto {
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.subrogation-table-wrapper .cost-table {
  table-layout: fixed;
  min-width: calc(998px + 120px + 100px + 120px + var(--subrogation-action-width));
  --subrogation-action-width: 132px;
  --subrogation-selection-width: 40px;
}

.subrogation-table-wrapper .cost-table.has-selectable-rows {
  min-width: calc(var(--subrogation-selection-width) + 998px + 120px + 100px + 120px + var(--subrogation-action-width));
}

.subrogation-table-wrapper .cost-table th {
  text-align: center !important;
}

.subrogation-table-wrapper .cost-table .subrogation-col-selection {
  width: var(--subrogation-selection-width);
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-align: center !important;
  vertical-align: middle;
}

.subrogation-table-wrapper .cost-table .subrogation-col-selection input[type="checkbox"] {
  display: block;
  width: 16px;
  height: 16px;
  margin: 0 auto;
}

.subrogation-table-wrapper .cost-table .subrogation-col-product {
  width: 128px;
}

.subrogation-table-wrapper .cost-table .subrogation-col-claim-type {
  width: 160px;
}

.subrogation-table-wrapper .cost-table .subrogation-col-building {
  width: 220px;
}

.subrogation-table-wrapper .cost-table .subrogation-col-room {
  width: 80px;
}

.subrogation-table-wrapper .cost-table .subrogation-col-borrower {
  width: 180px;
}

.subrogation-table-wrapper .cost-table .subrogation-col-request-items {
  width: 230px;
}

.subrogation-table-wrapper .cost-table .subrogation-col-amount {
  width: 120px;
}

.subrogation-table-wrapper .cost-table .subrogation-col-status {
  width: 100px;
}

.subrogation-table-wrapper .cost-table td.subrogation-col-status {
  text-align: center;
}

.subrogation-table-wrapper .cost-table td.subrogation-col-status .status-badge {
  display: block;
  width: fit-content;
  margin-inline: auto;
}

.subrogation-table-wrapper .cost-table .subrogation-col-evidence {
  width: 120px;
}

.subrogation-table-wrapper .cost-table .subrogation-col-actions {
  width: var(--subrogation-action-width);
}

.subrogation-table-wrapper .cost-table .subrogation-action-header,
.subrogation-table-wrapper .cost-table .subrogation-action-cell {
  text-align: center !important;
}

.subrogation-table-wrapper .cost-table .subrogation-action-cell {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.subrogation-row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.subrogation-row-actions .btn-small {
  margin: 0 !important;
}

.subrogation-action-cell .subrogation-detail-action-button {
  width: 100%;
  min-width: 0;
  padding: 0.45rem 0.5rem;
  font-size: 12px;
}

.subrogation-table-wrapper .cost-table td {
  vertical-align: middle;
}

.subrogation-cell-text {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subrogation-unlinked-contract-note,
.subrogation-action-guidance {
  display: block;
  margin-top: 0.25rem;
  color: #976113;
  font-size: 11px;
  line-height: 1.35;
  white-space: normal;
}

.subrogation-evidence-state {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 650;
}

.subrogation-evidence-state-missing {
  color: #a14d0c;
}

.subrogation-evidence-state-ready {
  color: #1f7a4d;
}

.subrogation-evidence-state-not_required,
.subrogation-evidence-state-unknown {
  color: #526579;
}

.subrogation-evidence-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  padding: 0.25rem 0.35rem;
  border: 1px solid transparent;
  border-radius: 5px;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.subrogation-evidence-trigger:hover {
  background: #f1f5f9;
}

.subrogation-evidence-trigger:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.subrogation-table-wrapper .cost-table .subrogation-sticky-action-column {
  position: sticky;
  right: 0;
  background: #fff;
  border-left: 1px solid #cbd5e1;
  z-index: 6;
}

.subrogation-table-wrapper .cost-table thead .subrogation-sticky-action-column {
  z-index: 7;
  background: var(--primary);
}

.subrogation-table-wrapper .cost-table tbody tr:hover .subrogation-sticky-action-column {
  background: #f7fafc;
}

/* ===== VARIABLE COST TABLE - STICKY COLUMNS ===== */
/* Fix operation and status columns to the right side */
.sticky-action-column {
  position: sticky;
  right: 0;
  /* Increased width to prevent overlap */
  background: white;
  z-index: 2;
  /* border-left: 1px solid #e2e8f0; */
  width: 135px;
  min-width: 135px;
  max-width: 135px;
}

.sticky-status-column {
  position: sticky;
  right: 134px;
  background: white;
  z-index: 1;
  /* border-left: 1px solid #e2e8f0; */
  min-width: 80px;
}

/* Header background for sticky columns */
.cost-table thead .sticky-action-column,
.cost-table thead .sticky-status-column {
  background: var(--primary);
}

/* Hover effects for sticky columns */
.cost-table tbody tr:hover .sticky-action-column,
.cost-table tbody tr:hover .sticky-status-column {
  background: #f7fafc;
}

.cost-table tbody tr.approved-row .sticky-action-column,
.cost-table tbody tr.approved-row .sticky-status-column {
  background: #f0fff4;
}

.cost-table tbody tr.approved-row:hover .sticky-action-column,
.cost-table tbody tr.approved-row:hover .sticky-status-column {
  background: #e6fffa;
}

.variable-cost-table-wrapper {
  overflow: hidden;
}

.variable-cost-table-scroll {
  width: 100%;
  overflow-x: auto;
}

.variable-cost-register-page .cost-table {
  table-layout: fixed;
  min-width: 4090px;
}

.variable-cost-register-page .sticky-left-column {
  position: sticky;
  background: white;
  z-index: 3;
}

.variable-cost-register-page .sticky-select-column {
  left: 0;
  width: 52px;
  min-width: 52px;
  max-width: 52px;
}

.variable-cost-register-page .sticky-building-column {
  left: 52px;
  width: 180px;
  min-width: 180px;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.variable-cost-register-page .sticky-room-column {
  left: 232px;
  width: 72px;
  min-width: 72px;
  max-width: 72px;
  box-shadow: 1px 0 0 #e2e8f0;
}

.variable-cost-register-page .cost-table th:nth-child(4),
.variable-cost-register-page .cost-table td:nth-child(4) {
  width: 94px;
}

.variable-cost-register-page .cost-table th:nth-child(5),
.variable-cost-register-page .cost-table td:nth-child(5),
.variable-cost-register-page .cost-table th:nth-child(30),
.variable-cost-register-page .cost-table td:nth-child(30) {
  width: 74px;
}

.variable-cost-register-page .cost-table th:nth-child(6),
.variable-cost-register-page .cost-table td:nth-child(6),
.variable-cost-register-page .cost-table th:nth-child(7),
.variable-cost-register-page .cost-table td:nth-child(7),
.variable-cost-register-page .cost-table th:nth-child(8),
.variable-cost-register-page .cost-table td:nth-child(8) {
  width: 112px;
}

.variable-cost-register-page .cost-table th:nth-child(9),
.variable-cost-register-page .cost-table td:nth-child(9) {
  width: 168px;
}

.variable-cost-register-page .cost-table th:nth-child(2n + 10):nth-child(-n + 28),
.variable-cost-register-page .cost-table td:nth-child(2n + 10):nth-child(-n + 28) {
  width: 132px;
}

.variable-cost-register-page .cost-table th:nth-child(2n + 11):nth-child(-n + 29),
.variable-cost-register-page .cost-table td:nth-child(2n + 11):nth-child(-n + 29) {
  width: 150px;
}

.variable-cost-register-page .cost-table th:nth-child(31),
.variable-cost-register-page .cost-table td:nth-child(31) {
  width: 80px;
}

.variable-cost-register-page .cost-table thead .sticky-left-column {
  background: var(--primary);
  z-index: 5;
}

.variable-cost-register-page .cost-table tbody tr:hover .sticky-left-column {
  background: #f7fafc;
}

.variable-cost-register-page .cost-table tbody tr.approved-row .sticky-left-column {
  background: #f0fff4;
}

.variable-cost-register-page .cost-table tbody tr.approved-row:hover .sticky-left-column {
  background: #e6fffa;
}

.variable-cost-rejection-status-trigger {
  position: relative;
  display: inline-block;
  margin: 0;
  padding: 0;
  color: inherit;
  background: transparent;
  border: 0;
  font: inherit;
  cursor: pointer;
}

.variable-cost-rejection-status-trigger:focus-visible {
  outline: 2px solid #f59e0b;
  outline-offset: 3px;
  border-radius: 9999px;
}

.variable-cost-rejection-status-icon {
  position: absolute;
  top: -8px;
  right: -8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: white;
  background: #facc15;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.variable-cost-rejection-tooltip {
  max-width: min(420px, calc(100vw - 24px)) !important;
}

.variable-cost-rejection-tooltip .ant-tooltip-inner {
  max-height: 12rem;
  overflow-y: auto;
  color: #333;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.16);
}

.variable-cost-rejection-tooltip-title {
  margin-bottom: 0.25rem;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
}

.variable-cost-rejection-tooltip-reason {
  color: #4b5563;
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.variable-cost-rejection-tooltip-reason.is-missing {
  color: #9b2c2c;
  font-style: italic;
}

.variable-cost-rejection-tooltip-guidance {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  color: #9b2c2c;
  border-top: 1px solid #fee2e2;
  font-size: 12px;
  font-weight: 600;
}

/* READONLY CELLS */
.readonly-cell {
  color: #9ca3af;
  font-style: italic;
}

/* INPUT FIELDS */
.cost-input {
  width: 100%;
  padding: 0.4rem 0.6rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 13px;
  text-align: right;
  background: white;
  transition: border-color 0.2s;
}

.cost-input:focus {
  outline: none;
  border-color: var(--primary);
}

.cost-input:disabled {
  background: #f7fafc;
  color: #718096;
  cursor: not-allowed;
}

/* BUTTONS */
.btn-submit {
  background: var(--primary);
  color: white;
  border: none;
  padding: 0.4rem 1rem;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-submit:hover {
  background: var(--primary-light);
  box-shadow: 0 2px 8px rgba(43, 108, 176, 0.2);
}

.submitted-text {
  color: #38a169;
  font-size: 12px;
  font-weight: 600;
}

/* STATUS BADGES */
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-default {
  background-color: #f3f4f6;
  color: #6b7280;
}

.status-pending {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #fecba1;
}

.status-reviewing {
  background-color: #cce5ff;
  color: #0056b3;
  border: 1px solid #a6d4ff;
}

.status-warning {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #fecba1;
}

.status-processing {
  background-color: #a8f1cb;
  color: #048844;
  border: 1px solid #58dc97;
}

.status-approved {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #a3d9a4;
}

.status-rejected {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f1aeb5;
}

.status-cancelled {
  background-color: #4b5563;
  color: #ffffff;
}

/* --- CONTRACTS LIST PAGE -------------------------------------------- */
.contracts-list-page {
  width: 100%;
  max-width: 1400px;
}

.contracts-list-page h2 {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 2rem;
}

.contracts-confirmation-page {
  width: min(1260px, calc(100vw - 4rem));
  max-width: none;
  margin-left: 50%;
  transform: translateX(-50%);
}

.contracts-confirmation-page .filters-section {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.contracts-confirmation-page .contracts-filter-control {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.contracts-confirmation-page .contracts-filter-keyword {
  flex: 1 1 320px;
  max-width: 400px;
}

.contracts-confirmation-page .contracts-filter-label {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
}

.contracts-confirmation-page .search-input {
  width: 100%;
}

.contract-display-status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  padding: 0.22rem 0.55rem;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
}

.contract-display-status-signed {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #047857;
}

.contract-display-status-cancel-requested {
  background: #fffbeb;
  border-color: #fde68a;
  color: #92400e;
}

.contract-display-status-canceled {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #475569;
}

.contract-status-cell {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
}

.contract-guara-update-confirm-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 82px;
  padding: 0.2rem 0.5rem;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
  cursor: pointer;
}

.contract-guara-update-confirm-pending {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #c2410c;
}

.contract-guara-update-confirm-update {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.contract-guara-update-confirm-end {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #475569;
}

.contracts-confirmation-page .contract-display-status-tooltip-trigger {
  position: relative;
  display: inline-flex;
  cursor: help;
}

.contracts-confirmation-page .contract-action-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 112px;
  margin: 0 auto;
}

.contracts-confirmation-page .contract-action-button {
  width: 112px;
  min-height: 30px;
  padding: 0.35rem 0.5rem;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
}

.contracts-confirmation-page .contracts-table th:last-child,
.contracts-confirmation-page .contracts-table td:last-child {
  width: 128px;
  min-width: 128px;
  max-width: 128px;
  padding-right: 8px;
  padding-left: 8px;
  text-align: center;
}

@media (max-width: 1400px) {
  .contracts-confirmation-page {
    width: 100%;
    margin-left: 0;
    transform: none;
  }
}

/* --- NOTICE LIST PAGE -------------------------------------------- */
.notice-list-page {
  width: 100%;
  max-width: 1400px;
}

.notice-list-page h2 {
  font-size: 28px;
  font-weight: 600;
  color: var(--primary);
  margin-bottom: 2rem;
}

.status-select {
  padding: 0.65rem 0.9rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  min-width: 150px;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.status-select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(43, 108, 176, 0.1);
}

.contracts-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1100px;
}

.contracts-confirmation-page .contracts-table {
  table-layout: fixed;
  min-width: 1212px;
}

.contracts-table thead {
  background: var(--primary);
  color: white;
}

.contracts-table th,
.contracts-table td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
  white-space: nowrap;
}

.contracts-confirmation-page .contracts-table th,
.contracts-confirmation-page .contracts-table td {
  padding: 0.65rem 0.6rem;
  vertical-align: middle;
  white-space: normal;
}

.contracts-confirmation-page .contracts-table th:nth-child(1),
.contracts-confirmation-page .contracts-table td:nth-child(1) {
  width: 150px;
}

.contracts-confirmation-page .contracts-table th:nth-child(2),
.contracts-confirmation-page .contracts-table td:nth-child(2) {
  width: 72px;
  white-space: nowrap;
}

.contracts-confirmation-page .contracts-table th:nth-child(3),
.contracts-confirmation-page .contracts-table td:nth-child(3) {
  width: 130px;
}

.contracts-confirmation-page .contracts-table th:nth-child(4),
.contracts-confirmation-page .contracts-table td:nth-child(4) {
  width: 190px;
}

.contracts-confirmation-page .contracts-table th:nth-child(5),
.contracts-confirmation-page .contracts-table td:nth-child(5) {
  width: 100px;
  white-space: nowrap;
}

.contracts-confirmation-page .contracts-table th:nth-child(6),
.contracts-confirmation-page .contracts-table td:nth-child(6) {
  width: 110px;
  white-space: nowrap;
}

.contracts-confirmation-page .contracts-table th:nth-child(7),
.contracts-confirmation-page .contracts-table td:nth-child(7) {
  width: 110px;
  white-space: nowrap;
}

.contracts-confirmation-page .contracts-table th:nth-child(8),
.contracts-confirmation-page .contracts-table td:nth-child(8) {
  width: 100px;
  white-space: nowrap;
}

.contracts-confirmation-page .contracts-table th:nth-child(9),
.contracts-confirmation-page .contracts-table td:nth-child(9) {
  width: 112px;
  text-align: center;
  white-space: nowrap;
}

.contracts-confirmation-page .contracts-table th:nth-child(10),
.contracts-confirmation-page .contracts-table td:nth-child(10) {
  width: 110px;
  text-align: center;
  white-space: nowrap;
}

.contracts-table th {
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
}

.contracts-confirmation-page .contracts-table th {
  text-align: center;
  white-space: nowrap;
}

.contracts-table tbody tr {
  transition: background-color 0.15s;
}

.contracts-confirmation-page .contracts-table tbody tr:nth-child(even):not(.delay-row) {
  background: #f3f4f6;
}

.contracts-table tbody tr:hover {
  background: #f7fafc;
}

.contracts-table tbody tr.cancelled-row {
  background: #fff5f5;
  opacity: 0.8;
}

.contracts-table tbody tr.cancelled-row:hover {
  background: #fed7d7;
}

.guara-update-confirm-page {
  width: min(1260px, calc(100vw - 4rem));
  max-width: none;
  margin-left: 50%;
  transform: translateX(-50%);
}

.guara-update-confirm-filters {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.guara-update-confirm-search-actions {
  display: flex;
  gap: 0.5rem;
}

.guara-update-confirm-table-wrapper {
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}

.guara-update-confirm-table {
  width: 100%;
  min-width: 1160px;
  border-collapse: collapse;
}

.guara-update-confirm-table thead {
  background: var(--primary);
  color: #fff;
}

.guara-update-confirm-table th,
.guara-update-confirm-table td {
  padding: 0.65rem 0.6rem;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
  vertical-align: middle;
}

.guara-update-confirm-table th {
  text-align: center;
  white-space: nowrap;
}

.guara-update-confirm-table tbody tr:nth-child(even) {
  background: #f8fafc;
}

.guara-update-confirm-table tbody tr:hover {
  background: #f7fafc;
}

.guara-update-confirm-subtext {
  margin-top: 0.2rem;
  color: #64748b;
  font-size: 12px;
}

.guara-update-confirm-renewal-badge,
.guara-update-confirm-status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  padding: 0.22rem 0.55rem;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
}

.guara-update-confirm-renewal-own {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.guara-update-confirm-renewal-other {
  background: #f5f3ff;
  border-color: #ddd6fe;
  color: #6d28d9;
}

.guara-update-confirm-status-pending {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #c2410c;
}

.guara-update-confirm-status-update {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #047857;
}

.guara-update-confirm-status-end {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #475569;
}

.guara-update-confirm-row-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  min-width: 132px;
}

.guara-update-confirm-action-button {
  width: 42px;
  min-width: 42px;
  height: 28px;
  min-height: 28px;
  padding: 0;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
}

.guara-update-confirm-modal-content p {
  margin: 0 0 0.35rem;
}

@media (max-width: 1400px) {
  .guara-update-confirm-page {
    width: 100%;
    margin-left: 0;
    transform: none;
  }
}

.notice-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1100px;
}

.notice-table thead {
  background: var(--primary);
  color: white;
}

.notice-table th,
.notice-table td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
  white-space: nowrap;
}

.notice-table th {
  font-weight: 600;
  font-size: 14px;
}

.notice-table tbody tr {
  transition: background-color 0.15s;
}

.notice-table tbody tr:hover {
  background: #f7fafc;
}

.notice-table tbody tr.unread-row {
  background: #fff7ed;
}

.notice-table tbody tr.unread-row:hover {
  background: #ffedd5;
}

.contract-no {
  font-weight: 600;
  color: var(--primary);
}

.building-name {
  font-weight: 500;
  color: var(--text);
}

.tenant-info {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.tenant-name {
  font-weight: 500;
  color: var(--text);
}

.tenant-kana {
  font-size: 11px;
  color: #718096;
}

.plan-info {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.plan-name {
  font-weight: 500;
  color: var(--text);
}

.plan-alias {
  font-size: 11px;
  color: #718096;
  background: #e2e8f0;
  padding: 0.1rem 0.4rem;
  border-radius: 4px;
  display: inline-block;
  width: fit-content;
}

.btn-detail {
  background: var(--primary);
  color: white;
  border: none;
  padding: 0.4rem 1rem;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-detail:hover {
  background: var(--primary-light);
  box-shadow: 0 2px 8px rgba(43, 108, 176, 0.2);
}

/* CONTRACT STATUS BADGES */
.contract-status-1 {
  background: #fff3cd;
  color: #856404;
}

.contract-status-2 {
  background: #cce5ff;
  color: #0056b3;
}

.contract-status-3 {
  background: #ffe5cc;
  color: #cc6600;
}

.contract-status-4 {
  background: #ffcccc;
  color: #cc0000;
}

.contract-status-5 {
  background: #d4edda;
  color: #155724;
}

.contract-status-6.cancelled {
  background: #f8d7da;
  color: #721c24;
}

.no-results {
  text-align: center;
  padding: 2rem;
  color: #718096;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-top: 1rem;
}

/* --- PAYMENT STATUS PAGE -------------------------------------------- */
.payment-status-page {
  width: 100%;
  max-width: 1400px;
}

.payment-status-page h2 {
  font-size: 28px;
  font-weight: 600;
  color: var(--primary);
  margin-bottom: 2rem;
}

/* --- CONTRACT DETAIL PAGE ------------------------------------------- */
.contract-detail-page {
  width: 100%;
  max-width: 1200px;
}

.contract-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e2e8f0;
}

.contract-header-main h2 {
  font-size: 28px;
  font-weight: 600;
  color: var(--primary);
  margin-bottom: 0.5rem;
}

.contract-id-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.contract-id-info .contract-no {
  font-size: 18px;
  font-weight: 600;
  color: var(--primary);
}

.btn-back {
  background: #6c757d;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-back:hover {
  background: #5a6268;
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
}

.contract-detail-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.detail-section-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.detail-section {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.detail-section.full-width {
  grid-column: 1 / -1;
}

.detail-section h3 {
  background: var(--primary);
  color: white;
  padding: 1rem 1.5rem;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.detail-card {
  padding: 1.5rem;
}

.detail-item {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f7fafc;
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-item label {
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
}

.detail-item span {
  font-size: 14px;
  color: var(--text);
}

.detail-item .building-name {
  font-weight: 600;
  color: var(--primary);
}

.detail-item .tenant-name {
  font-weight: 600;
}

.detail-item .tenant-kana {
  color: #718096;
}

.detail-item .amount {
  font-weight: 600;
  color: var(--primary);
}

.plan-badge {
  background: var(--primary);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
}

/* STATUS TIMELINE */
.status-timeline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
}

.status-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  position: relative;
}

.status-indicator {
  margin-bottom: 0.5rem;
}

.status-dot {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 3px solid #e2e8f0;
  background: white;
  transition: all 0.3s;
}

.status-dot.completed {
  background: #38a169;
  border-color: #38a169;
}

.status-dot.current {
  background: #3182ce;
  border-color: #3182ce;
  animation: pulse-status 2s infinite;
}

.status-dot.cancelled {
  background: #e53e3e;
  border-color: #e53e3e;
}

.status-dot.pending {
  background: #f7fafc;
  border-color: #e2e8f0;
}

.status-content {
  text-align: center;
}

.status-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 0.25rem;
}

.status-date {
  font-size: 12px;
  color: #718096;
}

.status-description {
  font-size: 12px;
  color: #718096;
}

.status-connector {
  flex: 1 1;
  height: 2px;
  background: #e2e8f0;
  margin: 0 1rem;
  margin-top: -10px;
}

@keyframes pulse-status {
  0% {
    box-shadow: 0 0 0 0 rgba(49, 130, 206, 0.7);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(49, 130, 206, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(49, 130, 206, 0);
  }
}

/* VARIABLE COST HISTORY */
.variable-cost-history {
  overflow-x: auto;
}

.history-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 700px;
}

.history-table thead {
  background: #f7fafc;
}

.history-table th,
.history-table td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
  white-space: nowrap;
}

.history-table th {
  font-weight: 600;
  font-size: 14px;
  color: #4a5568;
}

.history-table tbody tr {
  transition: background-color 0.15s;
}

.history-table tbody tr:hover {
  background: #f7fafc;
}

.history-table tbody tr.history-approved {
  background: rgba(72, 187, 120, 0.05);
}

.history-table tbody tr.history-pending {
  background: rgba(237, 137, 54, 0.05);
}

.history-month {
  font-weight: 600;
  color: var(--primary);
}

.history-total {
  font-weight: 700;
  color: var(--primary);
  border-left: 2px solid var(--primary);
  background: rgba(43, 108, 176, 0.05);
}

/* SORTABLE TABLE HEADERS */
.sortable-header {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  transition: background-color 0.2s;
}

.sortable-header:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.sort-indicator {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  margin-left: 4px;
  min-width: 1.1em;
  font-size: 12px;
  color: currentColor;
  transition: color 0.2s;
  vertical-align: middle;
  width: 1.1em;
}

.sortable-header.sort-asc .sort-indicator::after {
  content: "▲";
  color: white;
}

.sortable-header.sort-desc .sort-indicator::after {
  content: "▼";
  color: white;
}

/* --- PAYMENT STATUS TABLE ------------------------------------------- */
.payment-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

.payment-table th,
.payment-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.payment-table th {
  background: #f8fafc;
  font-weight: 600;
  color: #4a5568;
}

.payment-row.payment-overdue {
  background: #fef5e7;
}

.payment-row.payment-completed {
  background: #f0fff4;
}

.payment-status-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.payment-status-badge.overdue {
  background: #fed7d7;
  color: #c53030;
}

.payment-status-badge.completed {
  background: #c6f6d5;
  color: #2f855a;
}

/* --- APPLICATION CREATE PAGE ---------------------------------------- */
.application-create-page {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.application-create-page h2 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 1rem;
}

.application-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-section {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.form-section h3 {
  background: var(--primary);
  color: white;
  padding: 0.75rem 1.25rem;
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.form-card {
  padding: 1rem;
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
}

.form-row:last-child {
  margin-bottom: 0;
}

.form-row-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.postcode-row {
  display: flex;
  gap: 0.5rem;
  align-items: end;
}

.postcode-input {
  width: 150px;
  flex-shrink: 0;
}

.address-lookup-btn {
  background: var(--primary);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  height: fit-content;
}

.address-lookup-btn:hover {
  background: var(--primary-light);
  box-shadow: 0 2px 8px rgba(43, 108, 176, 0.2);
}

.address-lookup-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

.form-row label {
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
}

.required {
  color: #e53e3e;
  font-weight: 700;
}

.form-input {
  padding: 0.5rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(43, 108, 176, 0.1);
}

/* Styling for browser's default date input calendar icon */
.form-input[type="date"]::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.7;
}

.form-input[type="date"]::-webkit-calendar-picker-indicator:hover {
  opacity: 1;
}

.form-select {
  padding: 0.5rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.form-select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(43, 108, 176, 0.1);
}

.form-display {
  font-size: 14px;
  color: var(--text);
  padding: 0.5rem 0;
  border-bottom: 1px solid #f7fafc;
}

.form-display.amount {
  font-weight: 600;
  color: var(--primary);
}

.selected-product {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f7fafc;
  border-radius: 8px;
  margin-top: 0.5rem;
}

.product-badge {
  background: var(--primary);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
}

.selected-product p {
  margin: 0;
  font-size: 14px;
  color: var(--text);
}

.subsection-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--primary);
  margin: 1rem 0 0.75rem 0;
  padding-bottom: 0.25rem;
  border-bottom: 1px solid #e2e8f0;
}

.cost-section-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  margin: 1rem 0 0.75rem 0;
  padding-bottom: 0.25rem;
  border-bottom: 1px solid #e2e8f0;
}

.cost-section-header__title {
  margin: 0;
  padding-bottom: 0;
  border-bottom: 0;
  line-height: 1.25;
  flex-shrink: 0;
}

.cost-section-header__note {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.25;
  color: #111827;
  text-align: right;
}

.plan-description {
  margin: 0.5rem 0 0 0 !important;
  font-size: 12px;
  color: #718096;
  font-weight: 500;
}

/* COST BREAKDOWN */
.cost-breakdown {
  margin: 0.75rem 0;
}

.cost-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.375rem 0;
  border-bottom: 1px solid #f7fafc;
}

.cost-item:last-child {
  border-bottom: none;
}

.cost-item.cost-total {
  border-top: 2px solid var(--primary);
  padding-top: 0.75rem;
  margin-top: 0.375rem;
  font-weight: 600;
}

.cost-label {
  font-size: 14px;
  color: #4a5568;
}

.cost-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--primary);
}

.cost-total .cost-label,
.cost-total .cost-value {
  font-size: 16px;
  font-weight: 700;
}

/* RESIDENTS */
.residents-header {
  margin-bottom: 0.75rem;
}

.no-residents {
  color: #718096;
  font-style: italic;
  text-align: center;
  padding: 1.5rem;
  background: #f7fafc;
  border-radius: 8px;
}

.resident-item {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.75rem;
  margin-bottom: 0.75rem;
  background: #fafbfc;
}

.resident-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 0.375rem;
}

.resident-header h5 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.btn-remove {
  background: #e53e3e;
  color: white;
  border: none;
  padding: 0.25rem 0.75rem;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-remove:hover {
  background: #c53030;
  box-shadow: 0 2px 8px rgba(229, 62, 62, 0.3);
}

/* OPTION GROUPS */
.option-group {
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.option-group:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.option-group label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.option-group input[type="checkbox"] {
  accent-color: var(--primary);
}

/* AGREEMENT SECTION */
.agreement-section .form-row label {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 14px;
  cursor: pointer;
}

.agreement-section input[type="checkbox"] {
  accent-color: var(--primary);
  margin-top: 0.2rem;
}

.agreement-section small {
  font-size: 12px;
  color: #718096;
  margin-top: 0.25rem;
  display: block;
}

/* FILE UPLOAD */
.form-row small {
  font-size: 12px;
  color: #718096;
  margin-top: 0.25rem;
  display: block;
}

.file-upload-area {
  border: 2px dashed #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;
  background: #f7fafc;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
}

.file-upload-area:hover {
  border-color: var(--primary);
  background: #ebf8ff;
}

.file-upload-area.drag-active {
  border-color: var(--primary);
  background: #ebf8ff;
  border-style: solid;
}

.file-upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.file-upload-icon {
  font-size: 2rem;
  color: #a0aec0;
}

.file-upload-text {
  font-size: 14px;
  color: #4a5568;
  font-weight: 500;
}

.file-upload-hint {
  font-size: 12px;
  color: #718096;
}

.file-upload-input {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.uploaded-file {
  margin-top: 0.5rem;
  padding: 0.5rem;
  background: #e6fffa;
  border: 1px solid #4fd1c7;
  border-radius: 6px;
  font-size: 12px;
  color: #234e52;
}

.form-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 0;
  border-top: 2px solid #e2e8f0;
  margin-top: 0.75rem;
}

.btn-submit-application {
  background: var(--primary);
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-submit-application:hover {
  background: var(--primary-light);
  box-shadow: 0 4px 12px rgba(43, 108, 176, 0.2);
  transform: translateY(-2px);
}

/* --- APPLICATION REVIEW STATUS PAGE -------------------------------- */
.application-review-page {
  width: min(1480px, calc(100vw - 3rem));
  max-width: none;
  margin-left: 50%;
  transform: translateX(-50%);
}

.application-review-page h2 {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 2rem;
}

/* REVIEW FILTERS */
.review-filters-section {
  margin-bottom: 1.5rem;
}

.review-filter-group {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

.review-search-input,
.status-filter-select {
  padding: 0.65rem 0.9rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  min-width: 200px;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.review-search-input:focus,
.status-filter-select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(43, 108, 176, 0.1);
}

.review-search-input::placeholder {
  color: #a0aec0;
}

/* REVIEW TABLE */
.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.review-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  min-width: 1476px;
}

.review-table thead {
  background: var(--primary);
  color: white;
}

.review-table th,
.review-table td {
  padding: 0.65rem 0.6rem;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
}

/* 列幅の最適化 */
.review-table th:nth-child(1),
.review-table td:nth-child(1) {
  width: 110px;
  white-space: nowrap;
}

.review-table th:nth-child(2),
.review-table td:nth-child(2) {
  width: 138px;
}

.review-table th:nth-child(3),
.review-table td:nth-child(3) {
  width: 180px;
}

.review-table th:nth-child(4),
.review-table td:nth-child(4) {
  width: 78px;
  white-space: nowrap;
}

.review-table th:nth-child(5),
.review-table td:nth-child(5) {
  width: 150px;
}

.review-table th:nth-child(6),
.review-table td:nth-child(6) {
  width: 110px;
  white-space: nowrap;
}

.review-table th:nth-child(7),
.review-table td:nth-child(7) {
  width: 560px;
  min-width: 0;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.review-table th:nth-child(8),
.review-table td:nth-child(8) {
  width: 150px;
  text-align: center;
}

.review-table td:nth-child(8) {
  padding-left: 0.55rem;
  padding-right: 0.55rem;
}

.review-table .review-table-action-column {
  position: sticky;
  right: 0;
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  background: #ffffff;
  box-shadow: -8px 0 12px -8px rgba(15, 23, 42, 0.55);
  border-left: 1px solid #cbd5e1;
  /* Keep horizontally scrolling flow content underneath the fixed action layer. */
  z-index: 20;
}

.review-table thead .review-table-action-column {
  background: var(--primary);
  color: #ffffff;
  z-index: 30;
}

.review-table tbody tr:nth-child(even) .review-table-action-column {
  background: #f3f4f6;
}

.review-table tbody tr:nth-child(odd) .review-table-action-column {
  background: #ffffff;
}

.review-table tbody tr:hover .review-table-action-column {
  background: #f7fafc;
}

.review-table th {
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
}

.review-table tbody tr {
  transition: background-color 0.15s;
  cursor: pointer;
}

.review-table tbody tr:hover {
  background: #f7fafc;
}

.review-applicant-info {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.review-applicant-name {
  font-weight: 500;
  color: var(--text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.review-contract-no {
  white-space: nowrap;
}

.review-applicant-kana {
  font-size: 11px;
  color: #718096;
}

.review-property-info {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.review-building-name {
  font-weight: 500;
  color: var(--text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.review-room-address {
  font-size: 11px;
  color: #718096;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.review-product-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 768px) {
  .application-review-page {
    width: 100%;
    max-width: 100%;
  }

  .application-review-page .table-wrapper {
    overflow-x: auto;
  }

  .review-table {
    min-width: 500px;
    width: 100%;
    table-layout: fixed;
  }

  .review-table th:nth-child(n + 3),
  .review-table td:nth-child(n + 3) {
    display: none;
  }

  .review-table th:nth-child(7),
  .review-table td:nth-child(7) {
    display: table-cell;
    width: 148px;
  }

  .review-table th:nth-child(8),
  .review-table td:nth-child(8) {
    display: table-cell;
    width: 150px;
    min-width: 150px;
    max-width: 150px;
  }

  .review-table th:nth-child(1),
  .review-table td:nth-child(1) {
    width: 96px;
  }

  .review-table th:nth-child(2),
  .review-table td:nth-child(2) {
    width: auto;
  }

  .review-table th,
  .review-table td {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .review-table th {
    white-space: normal;
  }

  .review-flow-diagram {
    grid-template-columns: minmax(0, 1fr) !important;
    grid-template-rows: 1fr !important;
  }

  .review-flow-diagram > .review-flow-step-wrapper:not([data-active="true"]),
  .review-flow-diagram > .review-flow-connector {
    display: none;
  }

  .review-flow-diagram > .review-flow-step-wrapper[data-active="true"] {
    width: 100%;
    max-width: 100%;
  }

  .review-flow-diagram .review-flow-step-wrapper[data-active="true"] .review-flow-step {
    width: 100%;
    max-width: 100%;
    white-space: normal;
  }
}

.review-action-buttons {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.review-action-button {
  width: 100%;
  min-width: 112px;
  max-width: 128px;
  line-height: 1.25;
  white-space: normal;
  word-break: keep-all;
}

.review-action-button-multiline {
  min-height: 48px;
}

@media (max-width: 1400px) {
  .application-review-page {
    width: 100%;
    margin-left: 0;
    transform: none;
  }
}

/* REVIEW STATUS BADGES */
.review-status-badge {
  display: inline-block;
  padding: 0.25rem 0.6rem;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.review-status-submitted {
  background: #fff3cd;
  color: #856404;
}

.review-status-document-review {
  background: #cce5ff;
  color: #0056b3;
}

.review-status-credit-check {
  background: #e5ccff;
  color: #6b46c1;
}

.review-status-income-verification {
  background: #ffcccc;
  color: #cc0000;
}

.review-status-guarantor-review {
  background: #ffe5cc;
  color: #cc6600;
}

.review-status-management-review {
  background: #ccffcc;
  color: #00cc00;
}

.review-status-final-verification {
  background: #ffe5e5;
  color: #ff0000;
}

.review-status-contract-preparation {
  background: #e5ffe5;
  color: #008000;
}

.review-status-contract-sent {
  background: #e5f9ff;
  color: #0080ff;
}

.review-status-signed {
  background: #e5f5ff;
  color: #0066cc;
}

.review-status-payment-confirmed {
  background: #e5ffe5;
  color: #00aa00;
}

.review-status-completed {
  background: #d4edda;
  color: #155724;
}

.review-status-approved {
  background: #d4edda;
  color: #155724;
}

.review-status-rejected {
  background: #f8d7da;
  color: #721c24;
}

/* Extended review status styles */
.review-status-document-incomplete {
  background: #ffe5cc;
  color: #cc6600;
}

.review-status-preliminary-review {
  background: #e5e5ff;
  color: #6666cc;
}

.review-status-final-review {
  background: #e5ffe5;
  color: #00aa00;
}

.review-status-conditional-approval {
  background: #fff3e0;
  color: #e65100;
}

.review-status-on-hold {
  background: #f3e5f5;
  color: #7b1fa2;
}

.review-status-cancelled {
  background: #ffebee;
  color: #c62828;
}

/* REVIEW DETAIL MODAL */
.review-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.review-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.review-modal-header {
  background: var(--primary);
  color: white;
  padding: 1.5rem 2rem;
  border-radius: 12px 12px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.review-modal-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.review-modal-close {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: background 0.2s;
}

.review-modal-close:hover {
  background: rgba(255, 255, 255, 0.2);
}

.review-modal-content {
  padding: 2rem;
}

.review-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

.review-info-grid > * {
  word-break: break-word;
}

.review-info-section {
  background: #f7fafc;
  border-radius: 8px;
  padding: 1.5rem;
}

.review-info-section h4 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 1rem 0;
}

.review-info-item {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e2e8f0;
}

.review-info-item:last-child {
  border-bottom: none;
}

.review-info-label {
  font-size: 14px;
  color: #4a5568;
  font-weight: 500;
}

.review-info-value {
  font-size: 14px;
  color: var(--text);
  font-weight: 600;
}

/* REVIEW TIMELINE */
.review-timeline-section {
  margin-top: 2rem;
}

.review-timeline-section h4 {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 1.5rem 0;
}

.review-timeline {
  position: relative;
}

.review-timeline::before {
  content: "";
  position: absolute;
  left: 20px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #e2e8f0;
}

.review-timeline-item {
  position: relative;
  padding-left: 60px;
  margin-bottom: 1.5rem;
}

.review-timeline-item:last-child {
  margin-bottom: 0;
}

.review-timeline-dot {
  position: absolute;
  left: 10px;
  top: 6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 3px solid #e2e8f0;
  background: white;
}

.review-timeline-dot.completed {
  background: #38a169;
  border-color: #38a169;
}

.review-timeline-dot.current {
  background: #3182ce;
  border-color: #3182ce;
  animation: pulse-timeline 2s infinite;
}

.review-timeline-dot.pending {
  background: #f7fafc;
  border-color: #e2e8f0;
}

.review-timeline-content {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
}

.review-timeline-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
  margin: 0 0 0.5rem 0;
}

.review-timeline-date {
  font-size: 12px;
  color: #718096;
  margin-bottom: 0.5rem;
}

.review-timeline-comment {
  font-size: 13px;
  color: #4a5568;
  margin: 0;
}

.review-timeline-updater {
  font-size: 12px;
  color: #718096;
  font-style: italic;
  margin-top: 0.25rem;
}

@keyframes pulse-timeline {
  0% {
    box-shadow: 0 0 0 0 rgba(49, 130, 206, 0.7);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(49, 130, 206, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(49, 130, 206, 0);
  }
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .variable-register-page.variable-cost-register-page {
    width: 100%;
    margin-left: 0;
    transform: none;
  }

  .variable-register-page.subrogation-payment-page {
    width: 100%;
    margin-left: 0;
    transform: none;
  }

  .variable-cost-context-row {
    flex-direction: column;
  }

  .subrogation-context-row {
    flex-direction: column;
  }

  .variable-cost-month-navigation {
    justify-content: space-between;
  }

  .subrogation-month-navigation {
    justify-content: space-between;
  }

  .variable-cost-month-navigation .month-display {
    flex: 1 1;
    min-width: 0;
  }

  .subrogation-month-navigation .month-display {
    flex: 1 1;
    min-width: 0;
  }

  .subrogation-deadline-summary .subrogation-deadline-card {
    gap: 0.375rem;
    padding: 0.5rem 0.75rem;
  }

  .subrogation-deadline-summary .subrogation-deadline-copy {
    gap: 0.4rem;
  }

  .subrogation-deadline-summary .deadline-label {
    font-size: 13px;
  }

  .subrogation-deadline-summary .deadline-date {
    font-size: 15px;
  }

  .subrogation-deadline-summary .deadline-countdown {
    flex-shrink: 0;
    font-size: 12px;
    white-space: nowrap;
  }

  .subrogation-deadline-summary .deadline-countdown > span {
    padding: 0.2rem 0.5rem;
  }

  .variable-cost-search-input {
    width: 100%;
    max-width: none;
    min-width: 0;
  }

  .variable-cost-actions-section {
    align-items: stretch;
    flex-wrap: wrap;
  }

  .variable-cost-register-page .variable-cost-search-input {
    flex: 1 1 100%;
  }

  .variable-cost-action-buttons {
    width: 100%;
    margin-left: 0;
    flex-wrap: wrap;
  }

  .variable-cost-register-page .variable-cost-action-buttons .btn-outline,
  .variable-cost-register-page .variable-cost-action-buttons .btn-primary {
    flex: 1 1 140px;
    min-width: 0;
  }

  .variable-cost-target-selector {
    align-items: stretch;
    flex-direction: column;
  }

  .variable-cost-target-entry {
    width: 100%;
  }

  .variable-cost-target-dialog-backdrop {
    align-items: end;
    padding: 0.75rem;
  }

  .variable-cost-target-dialog {
    max-height: calc(100vh - 1.5rem);
    padding: 1rem;
  }

  .subrogation-excel-target-dialog-backdrop {
    align-items: center;
    padding: 0.75rem;
  }

  .subrogation-excel-target-dialog {
    max-height: calc(100vh - 1.5rem);
    max-height: calc(100dvh - 1.5rem);
  }

  .subrogation-excel-target-dialog .variable-cost-target-results {
    max-height: 45vh;
  }

  .subrogation-evidence-modal-backdrop {
    align-items: center;
    padding: 0.75rem;
  }

  .subrogation-evidence-modal {
    max-height: calc(100dvh - 1.5rem);
  }

  .subrogation-evidence-modal-header,
  .subrogation-evidence-modal-body {
    padding-right: 0.9rem;
    padding-left: 0.9rem;
  }

  .subrogation-evidence-file-list li {
    align-items: flex-start;
    flex-direction: column;
  }

  .subrogation-evidence-file-actions {
    width: 100%;
  }

  .subrogation-evidence-file-actions .btn-small {
    flex: 1 1;
    justify-content: center;
  }

  .subrogation-evidence-file-meta {
    white-space: normal;
  }

  .subrogation-evidence-pending-row {
    flex-wrap: wrap;
  }

  .subrogation-evidence-pending-row > span {
    flex-basis: calc(100% - 24px);
  }

  .subrogation-evidence-pending-row select {
    min-width: 0;
    max-width: none;
    flex: 1 1 auto;
  }

  .variable-cost-target-dialog-heading,
  .variable-cost-target-search-row {
    align-items: stretch;
    flex-direction: column;
  }

  .variable-cost-target-dialog-heading {
    display: flex;
  }

  .variable-cost-target-search-row {
    display: flex;
  }

  .variable-cost-target-dialog-actions {
    flex-direction: column-reverse;
  }

  .variable-cost-target-dialog-actions .btn-primary,
  .variable-cost-target-dialog-actions .btn-outline {
    width: 100%;
  }

  .variable-cost-register-page .cost-table tbody .sticky-status-column {
    z-index: 4;
  }

  .variable-cost-register-page .cost-table tbody .sticky-action-column {
    z-index: 5;
  }

  .variable-cost-register-page .cost-table thead .sticky-status-column {
    z-index: 6;
  }

  .variable-cost-register-page .cost-table thead .sticky-action-column {
    z-index: 7;
  }

  .variable-cost-rejection-tooltip {
    left: 12px !important;
    right: auto !important;
    width: calc(100vw - 24px) !important;
    max-width: none !important;
  }

  .subrogation-actions-section {
    flex-wrap: wrap;
  }

  .subrogation-payment-page .subrogation-search-input {
    flex: 0 0 42px;
    width: 100%;
    max-width: none;
    min-width: 0;
  }

  .subrogation-table-wrapper .cost-table {
    --subrogation-action-width: 132px;
  }

  .subrogation-action-buttons {
    width: 100%;
    flex-wrap: wrap;
  }

  .filter-group {
    flex-direction: column;
    align-items: stretch;
  }

  .search-input,
  .month-picker,
  .status-select {
    min-width: auto;
  }

  .actions-section {
    flex-direction: column;
  }

  .table-wrapper {
    overflow-x: auto;
  }

  .detail-section-row {
    grid-template-columns: 1fr;
  }

  .contract-header {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .detail-item {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }

  .status-timeline {
    flex-direction: column;
    gap: 1rem;
  }

  .status-connector {
    display: none;
  }

  .form-row-group {
    grid-template-columns: 1fr;
  }

  .form-actions {
    flex-direction: column;
    gap: 1rem;
  }

  .btn-submit-application {
    width: 100%;
  }

  .review-filter-group {
    flex-direction: column;
    align-items: stretch;
  }

  .application-review-page > .flex.justify-between {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .application-review-page > .flex.justify-between > .flex.flex-col-reverse {
    width: 100%;
    margin-bottom: 0;
  }

  .review-search-input,
  .status-filter-select {
    min-width: auto;
  }

  .application-review-page .review-search-input {
    width: 100%;
    min-width: 0 !important;
  }

  .review-info-grid {
    grid-template-columns: 1fr;
  }

  .review-modal {
    width: 95%;
    max-height: 95vh;
  }

  .review-modal-content {
    padding: 1rem;
  }
}

/* --- PRIVACY POLICY & ENHANCED CONSENT STYLES ---------------------- */

/* Privacy Policy Section */
.privacy-policy-section {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1rem 0;
  background: #f8fafc;
}

.privacy-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
}

.privacy-header h4 {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

.btn-view-policy {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #3182ce;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-view-policy:hover {
  background: #2c5282;
}

.privacy-checkboxes {
  margin: 1rem 0;
}

.privacy-checkboxes .form-row {
  margin-bottom: 0.75rem;
}

.privacy-checkboxes label {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 14px;
  line-height: 1.5;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.privacy-checkboxes label.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.privacy-checkboxes input[type="checkbox"] {
  margin-top: 2px;
  accent-color: #3182ce;
}

.privacy-checkboxes input[type="checkbox"]:disabled {
  cursor: not-allowed;
}

.policy-notice {
  background: #fef5e7;
  border: 1px solid #f6ad55;
  border-radius: 6px;
  padding: 0.75rem;
  margin-top: 1rem;
}

.policy-notice p {
  color: #c05621;
  font-size: 13px;
  margin: 0;
  font-weight: 500;
}

/* Privacy Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.privacy-modal {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.modal-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #a0aec0;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: #f7fafc;
  color: #4a5568;
}

.modal-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
}

.privacy-policy-text {
  padding: 1.5rem;
  line-height: 1.6;
  color: #4a5568;
}

.privacy-policy-text h4 {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin: 1.5rem 0 0.75rem 0;
}

.privacy-policy-text h4:first-child {
  margin-top: 0;
}

.privacy-policy-text p {
  margin-bottom: 0.75rem;
}

.privacy-policy-text ul {
  margin: 0.75rem 0 1.5rem 1.5rem;
  padding: 0;
}

.privacy-policy-text li {
  margin-bottom: 0.5rem;
}

.consent-summary {
  background: #f7fafc;
  border-radius: 8px;
  padding: 1.5rem;
  margin-top: 2rem;
}

.consent-summary h4 {
  color: #2d3748;
  margin-bottom: 1rem !important;
}

.consent-items {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.consent-item {
  padding: 1rem;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: white;
}

.consent-item.required {
  border-color: #f56565;
  background: #fef5f5;
}

.consent-item.optional {
  border-color: #4299e1;
  background: #f0f8ff;
}

.consent-item strong {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 14px;
}

.consent-item.required strong {
  color: #c53030;
}

.consent-item.optional strong {
  color: var(--primary);
}

.consent-item p {
  margin: 0;
  font-size: 13px;
  color: #4a5568;
}

.modal-footer {
  padding: 1.5rem;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: center;
}

.modal-footer .btn {
  padding: 0.75rem 2rem;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.modal-footer .btn-primary {
  background: #3182ce;
  color: white;
  border: none;
}

.modal-footer .btn-primary:hover {
  background: #2c5282;
}

/* Enhanced form validation styles */
.form-input:disabled {
  background-color: #f7fafc;
  color: #a0aec0;
  cursor: not-allowed;
}

/* Responsive Design for Privacy Modal */
@media (max-width: 768px) {
  .privacy-modal {
    max-width: 95%;
    max-height: 95vh;
  }

  .modal-header {
    padding: 1rem;
  }

  .privacy-policy-text {
    padding: 1rem;
  }

  .modal-footer {
    padding: 1rem;
  }

  .privacy-header {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .btn-view-policy {
    align-self: center;
  }

  .consent-items {
    gap: 0.75rem;
  }

  .consent-item {
    padding: 0.75rem;
  }
}

/* --- APPLICATION MODIFICATION CONTROL STYLES ---------------------- */

/* Modification Control Notice */
.modification-control-notice {
  margin-bottom: 2rem;
}

.control-status {
  border-radius: 12px;
  padding: 1.5rem;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid;
}

.control-status.modifiable {
  border-color: #f59e0b;
  background: #fefbf2;
}

.control-status.locked {
  border-color: #ef4444;
  background: #fef2f2;
}

.status-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e5e7eb;
}

.status-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.status-modifiable {
  background: #f59e0b;
  color: white;
}

.status-locked {
  background: #ef4444;
  color: white;
}

.status-content p {
  margin: 0.5rem 0;
  font-size: 14px;
  line-height: 1.5;
}

.status-content strong {
  color: #1f2937;
}

.modifiable-notice {
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 6px;
  padding: 1rem;
  margin-top: 1rem;
}

.modifiable-notice p {
  color: #92400e;
  margin: 0.25rem 0;
  font-weight: 500;
}

.locked-notice {
  background: #fee2e2;
  border: 1px solid #f87171;
  border-radius: 6px;
  padding: 1rem;
  margin-top: 1rem;
}

.locked-notice p {
  color: #991b1b;
  margin: 0.25rem 0;
  font-weight: 500;
}

/* Test Control Actions */
.control-test-actions {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.btn-test {
  padding: 0.5rem 1rem;
  border: 1px solid #6b7280;
  border-radius: 6px;
  background: white;
  color: #374151;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-test:hover {
  background: #f9fafb;
  border-color: #4b5563;
}

/* Enhanced Submit Button States */
.btn-submit-application.disabled {
  background: #d1d5db !important;
  color: #9ca3af !important;
  cursor: not-allowed !important;
  border-color: #d1d5db !important;
}

.btn-submit-application.disabled:hover {
  background: #d1d5db !important;
  color: #9ca3af !important;
}

/* Form Field Disabled State Enhancement */
.application-form input:disabled,
.application-form select:disabled,
.application-form textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
  opacity: 0.7;
}

.application-form .form-row.disabled label {
  color: #9ca3af;
}

/* Responsive Design for Modification Control */
@media (max-width: 768px) {
  .modification-control-notice {
    margin-bottom: 1.5rem;
  }

  .control-status {
    padding: 1rem;
  }

  .status-header {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .control-test-actions {
    flex-direction: column;
  }

  .btn-test {
    width: 100%;
    text-align: center;
  }
}

/* --- INPUT AUTO-CONVERSION STYLES ---------------------------------- */

/* Auto-conversion feedback */
.form-input.auto-converted {
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
  transition: all 0.3s ease;
}

.conversion-notice {
  background: #d1fae5;
  border: 1px solid #10b981;
  border-radius: 4px;
  padding: 0.5rem;
  margin-top: 0.5rem;
  font-size: 12px;
  color: #065f46;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.conversion-notice.phone-conversion {
  background: #dbeafe;
  border-color: #3b82f6;
  color: #1e40af;
}

.conversion-notice.address-conversion {
  background: #fef3c7;
  border-color: #f59e0b;
  color: #92400e;
}

.conversion-notice .icon {
  font-size: 14px;
}

/* Auto-conversion help text */
.input-help-text {
  font-size: 11px;
  color: #6b7280;
  margin-top: 0.25rem;
  line-height: 1.4;
}

.input-help-text.conversion-help {
  color: #059669;
  font-weight: 500;
}

/* Visual indicators for different field types */
.form-input.phone-field {
  position: relative;
}

.form-input.address-field {
  position: relative;
}

.form-input.postcode-field {
  position: relative;
}

/* Conversion animation */
@keyframes convertFlash {
  0% {
    background-color: #dcfce7;
  }

  50% {
    background-color: #bbf7d0;
  }

  100% {
    background-color: white;
  }
}

.form-input.converting {
  animation: convertFlash 0.6s ease-in-out;
}

/* Enhanced placeholder text for conversion fields */
.form-input[placeholder*="電話番号"]::placeholder,
.form-input[placeholder*="TEL"]::placeholder {
  color: #a0aec0;
}

.form-input[placeholder*="住所"]::placeholder,
.form-input[placeholder*="番地"]::placeholder {
  color: #a0aec0;
}

.form-input[placeholder*="郵便番号"]::placeholder {
  color: #a0aec0;
}

/* --- ENHANCED VARIABLE COSTS FUNCTIONALITY ----------------------- */

/* Sortable header */
.sortable-header {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
  position: relative;
  padding: 8px 12px;
}

/* .sortable-header:hover {
  background-color: #f7fafc;
} */

.sort-indicator {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  margin-left: 4px;
  min-width: 1.1em;
  font-size: 12px;
  font-weight: normal;
  color: currentColor;
  vertical-align: middle;
  width: 1.1em;
}

/* Previous month data transfer button */
.btn-outline.inherit-data {
  background-color: #e6fffa;
  border-color: #38b2ac;
  color: #38b2ac;
}

.btn-outline.inherit-data:hover {
  background-color: #38b2ac;
  color: white;
}

/* 検索フィールド強化表示 */
.search-input[placeholder*="管理ID"] {
  background-color: #fefefe;
  border-color: #c3dafe;
}

.search-input[placeholder*="管理ID"]:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Lightweight styles for performance improvement */
.table-wrapper {
  contain: layout style;
  will-change: transform;
}

/* パフォーマンス通知 */
.performance-notice {
  background: linear-gradient(45deg, #f0f9ff, #e0f2fe);
  border: 1px solid #0ea5e9;
  border-radius: 6px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 14px;
  color: #0369a1;
  font-weight: 500;
}

.performance-icon {
  font-size: 16px;
  animation: sparkle 2s ease-in-out infinite;
}

@keyframes sparkle {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }
}

/* Agreement section improvements */
.agreement-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.agreement-row label {
  flex: 1 1;
  margin-bottom: 0;
}

.btn-view-policy {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border: none;
  border-radius: 6px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.btn-view-policy:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  transform: translateY(-1px);
}

.btn-disabled {
  background: #e5e7eb !important;
  color: #9ca3af !important;
  cursor: not-allowed !important;
}

.btn-disabled:hover {
  background: #e5e7eb !important;
  transform: none !important;
}

/* Modal content width fix */
.privacy-modal .modal-content {
  max-height: 400px;
  overflow-y: auto;
  width: 100%;
}

.privacy-policy-text {
  width: 100%;
  padding: 0;
}

.privacy-policy-text h4 {
  color: #1f2937;
  font-size: 16px;
  font-weight: 600;
  margin: 1.5rem 0 0.75rem 0;
}

.privacy-policy-text h4:first-child {
  margin-top: 0;
}

.privacy-policy-text p {
  color: #374151;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.privacy-policy-text ul {
  color: #374151;
  line-height: 1.6;
  margin-bottom: 1rem;
  padding-left: 1.5rem;
}

.privacy-policy-text li {
  margin-bottom: 0.5rem;
}

/* Form actions button alignment */
.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
}

.form-actions button {
  height: 48px;
  min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-back {
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  color: #374151;
}

.btn-back:hover {
  background: #e5e7eb;
}

.btn-temp-save {
  background: #fbbf24;
  border: 1px solid #f59e0b;
  color: #92400e;
}

.btn-temp-save:hover {
  background: #f59e0b;
  color: white;
}

.btn-submit-application {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  color: white;
}

.btn-submit-application:hover:not(.disabled) {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
}

.btn-submit-application.disabled {
  background: #e5e7eb !important;
  color: #9ca3af !important;
  cursor: not-allowed !important;
}

.btn-submit-application.disabled:hover {
  transform: none !important;
}

/* Responsive design for form actions */
@media (max-width: 768px) {
  .form-actions {
    flex-direction: column;
  }

  .form-actions button {
    width: 100%;
  }

  .agreement-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .agreement-row label {
    width: 100%;
  }

  .btn-view-policy {
    align-self: flex-start;
  }
}

/* Application Status Page Styles */
.application-status-page {
  padding: 24px;
  background: #f8fafc;
  min-height: 100vh;
}

.application-status-page h2 {
  color: #1f2937;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 32px;
  border-bottom: 3px solid #3b82f6;
  padding-bottom: 12px;
}

.application-status-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Status Summary Card */
.status-summary-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.status-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.status-header h3 {
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.status-modifiable {
  background: #dcfce7;
  color: #16a34a;
  border: 1px solid #bbf7d0;
}

.status-locked {
  background: #fef3c7;
  color: #d97706;
  border: 1px solid #fed7aa;
}

.status-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
}

.status-detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.status-detail-item label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-detail-item span {
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
}

/* Review Progress Card */
.review-progress-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.review-progress-card h3 {
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #3b82f6;
}

/* Progress Tracker in Status Page */
.application-status-page .progress-tracker {
  margin: 0;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
}

.application-status-page .progress-steps {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.application-status-page .progress-step {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.application-status-page .progress-step.completed {
  border-color: #10b981;
  background: #f0fdf4;
}

.application-status-page .progress-step.current {
  border-color: #3b82f6;
  background: #eff6ff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.application-status-page .progress-step.current .step-indicator {
  animation: pulse 2s infinite;
}

.application-status-page .step-indicator {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
}

.application-status-page .step-indicator.completed {
  background: #10b981;
  color: #fff;
}

.application-status-page .step-indicator.current {
  background: #3b82f6;
  color: #fff;
}

.application-status-page .step-indicator.pending {
  background: #f3f4f6;
  color: #6b7280;
  border: 2px solid #d1d5db;
}

.application-status-page .step-content {
  flex: 1 1;
}

.application-status-page .step-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}

.application-status-page .step-description {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.4;
  margin-bottom: 6px;
}

.application-status-page .step-timing {
  font-size: 12px;
  font-weight: 500;
  color: #3b82f6;
}

.application-status-page .step-content.completed .step-title {
  color: #059669;
}

.application-status-page .step-content.current .step-title {
  color: #2563eb;
}

/* Status Actions */
.status-actions {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.modification-available,
.modification-locked {
  margin-bottom: 24px;
}

.modification-notice h4,
.locked-notice h4 {
  color: #1f2937;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.modification-notice p,
.locked-notice p {
  color: #4b5563;
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 20px 0;
}

.action-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

/* Test Controls */
.test-controls {
  border-top: 1px solid #e5e7eb;
  padding-top: 20px;
  margin-top: 20px;
}

.test-controls h4 {
  color: #6b7280;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 12px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* No Application Message */
.no-application-message {
  background: #fff;
  border-radius: 12px;
  padding: 48px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.no-application-message h3 {
  color: #1f2937;
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.no-application-message p {
  color: #6b7280;
  font-size: 16px;
  margin: 0 0 24px 0;
}

/* Responsive Design for Application Status */
@media (max-width: 768px) {
  .application-status-page {
    padding: 16px;
  }

  .application-status-page h2 {
    font-size: 24px;
    margin-bottom: 24px;
  }

  .status-summary-card,
  .review-progress-card,
  .status-actions {
    padding: 16px;
  }

  .status-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .status-details {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .application-status-page .progress-step {
    padding: 12px;
  }

  .application-status-page .step-indicator {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .no-application-message {
    padding: 32px 16px;
  }
}

/* Contract Detail Enhanced Review Status Styles */
.review-progress-summary {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}

.progress-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.progress-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.progress-percentage {
  font-size: 14px;
  font-weight: 600;
  color: #3b82f6;
}

.progress-bar-container {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #1d4ed8);
  border-radius: 4px;
  transition: width 0.5s ease;
}

/* Detailed Status Timeline */
.detailed-status-timeline {
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
}

.detailed-status-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 0;
  position: relative;
}

.detailed-status-item:last-child {
  padding-bottom: 0;
}

.status-step-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex-shrink: 0;
}

.step-number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  z-index: 2;
  position: relative;
}

.step-number.completed {
  background: #10b981;
  color: #fff;
}

.step-number.current {
  background: #3b82f6;
  color: #fff;
  animation: pulse 2s infinite;
}

.step-number.pending {
  background: #f3f4f6;
  color: #6b7280;
  border: 2px solid #d1d5db;
}

.step-connector {
  width: 2px;
  height: 48px;
  background: #e5e7eb;
  margin-top: 8px;
  margin-bottom: -12px;
}

.detailed-status-item.completed .step-connector {
  background: #10b981;
}

.detailed-status-item.current .step-connector {
  background: linear-gradient(to bottom, #10b981, #e5e7eb);
}

.status-step-content {
  flex: 1 1;
  min-width: 0;
}

.step-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 6px;
  flex-wrap: wrap;
}

.step-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.detailed-status-item.completed .step-title {
  color: #059669;
}

.detailed-status-item.current .step-title {
  color: #2563eb;
}

.current-step-badge {
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
}

.step-date {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.step-description {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
  margin: 0 0 8px 0;
}

.step-details {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  padding: 12px;
  margin-top: 8px;
}

.step-note {
  font-size: 13px;
  color: #1e40af;
  margin: 0;
  line-height: 1.4;
}

/* Review Result Section */
.review-result-section {
  border-top: 1px solid #e5e7eb;
  padding-top: 20px;
  margin-top: 20px;
}

.review-result-section h4 {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 12px 0;
}

.review-comment {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
}

.review-comment p {
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  margin: 0;
}

/* Responsive Design for Enhanced Review Status */
@media (max-width: 768px) {
  .progress-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .detailed-status-item {
    padding: 12px 0;
  }

  .step-number {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }

  .step-connector {
    height: 24px;
  }

  .step-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .step-title {
    font-size: 14px;
  }

  .step-description {
    font-size: 13px;
  }
}

/* Complete Review Timeline (審査状況確認モーダル内) */
.complete-review-timeline {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 16px;
}

.complete-timeline-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 12px 0;
  position: relative;
}

.complete-timeline-item:last-child {
  padding-bottom: 0;
}

.timeline-step-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex-shrink: 0;
}

.step-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  z-index: 2;
  position: relative;
}

.step-circle.completed {
  background: #10b981;
  color: #fff;
}

.step-circle.current {
  background: #3b82f6;
  color: #fff;
  /* animation: pulse 2s infinite; */
}

.step-circle.pending {
  background: #f3f4f6;
  color: #6b7280;
  border: 2px solid #d1d5db;
}

.step-line {
  width: 2px;
  height: 40px;
  margin-top: 6px;
  z-index: 1;
}

.step-line.completed {
  background: #10b981;
}

.step-line.current {
  background: linear-gradient(to bottom, #10b981 0%, #10b981 50%, #e5e7eb 50%, #e5e7eb 100%);
}

.step-line.pending {
  background: #e5e7eb;
}

.timeline-step-content {
  flex: 1 1;
  min-width: 0;
}

.step-header-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  flex-wrap: wrap;
}

.step-name {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.complete-timeline-item.completed .step-name {
  color: #059669;
}

.complete-timeline-item.current .step-name {
  color: #2563eb;
}

.current-badge {
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 8px;
}

.step-timestamp {
  font-size: 11px;
  color: #6b7280;
  font-weight: 500;
}

.step-desc {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
  margin: 0 0 6px 0;
}

.step-comment {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 8px;
  margin: 4px 0;
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.comment-icon {
  font-size: 12px;
  flex-shrink: 0;
}

.comment-text {
  font-size: 12px;
  color: #374151;
  line-height: 1.4;
}

.step-updater {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}

.updater-label {
  font-size: 11px;
  color: #6b7280;
}

.updater-name {
  font-size: 11px;
  color: #374151;
  font-weight: 500;
}

/* Responsive Design for Complete Timeline */
@media (max-width: 768px) {
  .complete-timeline-item {
    padding: 10px 0;
  }

  .step-circle {
    width: 28px;
    height: 28px;
    font-size: 11px;
  }

  .step-line {
    height: 32px;
  }

  .step-header-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .step-name {
    font-size: 13px;
  }

  .step-desc {
    font-size: 11px;
  }
}

/* 解約登録ページ */
.cancellation-register-page {
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.cancellation-register-page h2 {
  margin-bottom: 1.5rem;
  color: #2c5282;
  font-size: 1.8rem;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 0.5rem;
}

.page-description {
  background-color: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 2rem;
}

.page-description p {
  margin: 0;
  color: #4a5568;
  line-height: 1.6;
}

.cancellation-form {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.cancellation-form .form-section {
  background-color: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
}

.cancellation-form .form-section h3 {
  margin: 0 0 1rem 0;
  color: #2d3748;
  font-size: 1.2rem;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 0.5rem;
}

.cancellation-form .form-card {
  display: grid;
  gap: 1rem;
}

@media (max-width: 768px) {
  .cancellation-contract-recovery-alert {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    column-gap: 8px;
    row-gap: 8px;
    align-items: start;
  }

  .cancellation-contract-recovery-alert .ant-alert-icon {
    grid-column: 1;
    grid-row: 1;
    margin-inline-end: 0;
  }

  .cancellation-contract-recovery-alert .ant-alert-content {
    grid-column: 2;
    grid-row: 1;
  }

  .cancellation-contract-recovery-alert .ant-alert-action {
    grid-column: 2;
    grid-row: 2;
    margin-inline-start: 0;
  }

  .cancellation-contract-recovery-alert .ant-alert-action .ant-btn {
    height: auto;
    padding-inline: 0;
    white-space: normal;
  }
}

.cancellation-form .form-row {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.cancellation-form .form-row label {
  font-weight: 600;
  color: #2d3748;
}

.cancellation-form .required {
  color: #e53e3e;
  margin-left: 4px;
}

.cancellation-form .form-input,
.cancellation-form .form-select,
.cancellation-form .form-textarea {
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1rem;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.cancellation-form .form-input:focus,
.cancellation-form .form-select:focus,
.cancellation-form .form-textarea:focus {
  outline: none;
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}

.cancellation-form .form-textarea {
  resize: vertical;
  min-height: 100px;
}

.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding-top: 2rem;
  border-top: 1px solid #e2e8f0;
  margin-top: 2rem;
}

/* Cancellation registration confirmation items styles */
.confirmation-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1.5rem 0 1rem 0;
}

.confirmation-items {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.confirmation-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  line-height: 1.6;
}

.confirmation-item .bullet {
  color: #2d3748;
  font-weight: bold;
  margin-top: 0.1rem;
  flex-shrink: 0;
}

.confirmation-checkbox {
  margin-top: 1rem;
}

.btn-primary:disabled {
  background-color: #a0aec0;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-primary:disabled:hover {
  background-color: #a0aec0;
}

.btn-secondary {
  background-color: #f7fafc;
  color: #4a5568;
  border: 1px solid #d1d5db;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-secondary:hover {
  background-color: #edf2f7;
  border-color: #a0aec0;
}

.btn-primary {
  background-color: #3182ce;
  color: white;
  border: 1px solid #3182ce;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover {
  background-color: #2c5282;
  border-color: #2c5282;
}

.btn-primary:disabled {
  background: #e2e8f0;
  color: #a0aec0;
  border-color: #e2e8f0;
  cursor: not-allowed;
  box-shadow: none;
}

.guara-update-confirm-row-actions .guara-update-confirm-action-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 42px;
  width: 42px;
  min-width: 42px;
  height: 28px;
  min-height: 28px;
  padding: 0;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
}

/* レスポンシブ対応 */
@media (max-width: 768px) {
  .cancellation-register-page {
    padding: 1rem;
  }

  .cancellation-form .form-section {
    padding: 1rem;
  }

  .form-actions {
    flex-direction: column;
  }

  .btn-secondary,
  .btn-primary {
    width: 100%;
  }
  .guara-update-confirm-row-actions .guara-update-confirm-action-button {
    flex: 0 0 42px;
    width: 42px;
    min-width: 42px;
  }
}

/* 月額費用セクションの強調表示 */
.monthly-expenses-title {
  background-color: #e53e3e;
  color: white;
  padding: 0.5rem 1rem;
  margin: 1rem -1.5rem 0.5rem -1.5rem;
  border-radius: 4px;
}

.monthly-expenses-breakdown {
  border: 2px solid #e53e3e;
  border-radius: 8px;
  padding: 1rem;
  background-color: #fef5f5;
}

.monthly-expenses-breakdown .cost-item {
  padding: 0.5rem 0;
  border-bottom: 1px solid #fed7d7;
}

.monthly-expenses-breakdown .cost-item:last-child {
  border-bottom: none;
  font-weight: bold;
  background-color: #fed7d7;
  margin: 0.5rem -1rem -1rem -1rem;
  padding: 0.75rem 1rem;
  border-radius: 0 0 6px 6px;
}

/* 物件選択通知 */
.property-selection-notice {
  margin-bottom: 1.5rem;
}

.notice-box {
  background-color: #fff5f5;
  border: 2px solid #fed7d7;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.notice-box p {
  margin: 0.25rem 0;
  color: #742a2a;
  font-size: 0.9rem;
}

.notice-box p:first-child {
  font-weight: 600;
}

/* 一時保存機能 */
.btn-temp-save {
  background-color: #ed8936;
  color: white;
  border: 1px solid #ed8936;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-temp-save:hover {
  background-color: #dd7724;
  border-color: #dd7724;
}

/* Temporary save data notification */
.temp-data-notice {
  margin-bottom: 2rem;
}

.notice-card {
  background-color: #fff3cd;
  border: 2px solid #fdb750;
  border-radius: 8px;
  padding: 1.5rem;
}

.notice-header h3 {
  margin: 0 0 1rem 0;
  color: #996f00;
  font-size: 1.2rem;
}

.notice-content p {
  margin: 0.5rem 0;
  color: #705f0c;
}

.notice-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.btn-restore {
  background-color: #38a169;
  color: white;
  border: 1px solid #38a169;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-restore:hover {
  background-color: #2f855a;
  border-color: #2f855a;
}

.btn-clear {
  background-color: #e53e3e;
  color: white;
  border: 1px solid #e53e3e;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-clear:hover {
  background-color: #c53030;
  border-color: #c53030;
}

/* レスポンシブ対応 */
@media (max-width: 768px) {
  .form-actions {
    flex-direction: column;
  }

  .notice-actions {
    flex-direction: column;
  }

  .btn-temp-save,
  .btn-restore,
  .btn-clear {
    width: 100%;
  }
}

/* Temporary save data display */
.temp-application-message {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.temp-application-message h3 {
  text-align: center;
  margin-bottom: 2rem;
  color: #2d3748;
}

.temp-info-card {
  background-color: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
}

.temp-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.temp-header h4 {
  margin: 0;
  color: #2d3748;
}

.temp-status-badge {
  background-color: #ed8936;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 600;
}

.temp-details {
  margin: 1rem 0;
}

.temp-detail-item {
  display: flex;
  margin-bottom: 0.5rem;
}

.temp-detail-item label {
  font-weight: 600;
  color: #4a5568;
  min-width: 100px;
  margin-right: 1rem;
}

.temp-detail-item span {
  color: #2d3748;
}

.temp-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: center;
}

/* レスポンシブ対応 */
@media (max-width: 768px) {
  .temp-application-message {
    padding: 1rem;
  }

  .temp-actions {
    flex-direction: column;
  }

  .temp-detail-item {
    flex-direction: column;
  }

  .temp-detail-item label {
    min-width: auto;
    margin-right: 0;
    margin-bottom: 0.25rem;
  }
}

/* 入居予定日編集機能 */
.move-in-date-edit {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.move-in-date-display {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.move-in-date-input {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-input-small {
  padding: 0.25rem 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 0.875rem;
  width: 150px;
}

.form-input-small:focus {
  outline: none;
  border-color: #3182ce;
  box-shadow: 0 0 0 2px rgba(49, 130, 206, 0.1);
}

.move-in-date-actions {
  display: flex;
  gap: 0.25rem;
}

.btn-edit-small,
.btn-save-small,
.btn-cancel-small {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid;
}

.btn-edit-small {
  background-color: #f7fafc;
  color: #4a5568;
  border-color: #e2e8f0;
}

.btn-edit-small:hover {
  background-color: #edf2f7;
  border-color: #cbd5e0;
}

.btn-save-small {
  background-color: #38a169;
  color: white;
  border-color: #38a169;
}

.btn-save-small:hover {
  background-color: #2f855a;
  border-color: #2f855a;
}

.btn-cancel-small {
  background-color: #e2e8f0;
  color: #4a5568;
  border-color: #cbd5e0;
}

.btn-cancel-small:hover {
  background-color: #cbd5e0;
  border-color: #a0aec0;
}

/* レスポンシブ対応 */
@media (max-width: 768px) {
  .move-in-date-edit {
    flex-direction: column;
    align-items: flex-start;
  }

  .move-in-date-display,
  .move-in-date-input {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .form-input-small {
    width: 100%;
  }

  .move-in-date-actions {
    width: 100%;
    justify-content: flex-start;
  }
}

/* --- ACTION BUTTONS FOR APPLICATION STATUS ----------------------- */
.step-actions {
  margin-top: 12px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 6px;
  border-left: 3px solid #3b82f6;
}

.action-notice {
  margin-bottom: 8px;
}

.action-notice p {
  font-size: 13px;
  color: #374151;
  margin: 0;
  font-weight: 500;
}

.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  background: white;
}

.btn-action:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-action.btn-add {
  color: #059669;
  border-color: #059669;
}

.btn-action.btn-add:hover {
  background: #ecfdf5;
  border-color: #047857;
  color: #047857;
}

.btn-action.btn-skip {
  color: #dc2626;
  border-color: #dc2626;
}

.btn-action.btn-skip:hover {
  background: #fef2f2;
  border-color: #b91c1c;
  color: #b91c1c;
}

.icon-plus,
.icon-minus {
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
}

/* Responsive adjustments for action buttons */
@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
    gap: 6px;
    align-items: stretch;
  }

  .btn-action {
    justify-content: center;
    width: 100%;
  }
}

/* Form Label Container */
.form-label-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

/* Identity Document Guide Link */
.identity-guide-link {
  background: none;
  border: none;
  color: #dc2626;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font-weight: 500;
}

.identity-guide-link:hover {
  color: #b91c1c;
  text-decoration: none;
}

/* PDF Guide Modal Styles */
.pdf-guide-modal {
  background: white;
  border-radius: 12px;
  width: 95%;
  max-width: 1200px;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

/* Contract Cost Input Styles */
.cost-input-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 16px 20px 8px;
  padding: 0 8px;
}

.cost-input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e5e7eb;
}

.cost-input-row:last-child {
  border-bottom: none;
}

.cost-total-row {
  background-color: #f9fafb;
  padding: 12px 16px;
  margin: 8px -24px 4px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  font-weight: 600;
}

.cost-label {
  font-weight: 500;
  color: #374151;
  min-width: 120px;
  margin-right: 16px;
}

.cost-total-label {
  font-weight: 600;
  color: #1f2937;
}

.cost-input-group {
  display: flex;
  align-items: center;
  gap: 4px;
}

.cost-input {
  width: 120px;
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  text-align: right;
  font-size: 14px;
  background-color: white;
}

.cost-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

.cost-unit {
  font-size: 14px;
  color: #6b7280;
  font-weight: 400;
}

.cost-total-value {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  text-align: right;
  min-width: 120px;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .cost-input-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .cost-label {
    min-width: auto;
    margin-right: 0;
  }

  .cost-input-group {
    align-self: flex-end;
  }

  .cost-total-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .cost-total-value {
    align-self: flex-end;
  }
}

.pdf-guide-modal .modal-content {
  flex: 1 1;
  overflow: hidden;
  padding: 0;
  margin: 0;
  display: flex;
}

.pdf-guide-modal iframe {
  border-radius: 6px;
  width: 100%;
  height: 700px;
  margin: 0;
  padding: 0;
  border: none;
  display: block;
}

@media (max-width: 768px) {
  .pdf-guide-modal {
    width: 98%;
    max-height: 98vh;
  }

  .pdf-guide-modal iframe {
    height: 500px;
  }

  .form-label-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .identity-guide-link {
    align-self: flex-end;
    font-size: 11px;
  }
}

/* ---------- 物件情報簡潔レイアウト ---------- */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1rem;
}

.form-grid:last-child {
  margin-bottom: 0;
}

/* 軽いセクション区切り */
.property-subsection {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.property-subsection:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

/* Lease contract terms section styling */
.rental-conditions-section {
  background-color: white;
  border: none;
  border-radius: 0;
  padding: 0;
  margin-bottom: 16px;
}

.rental-conditions-section h4 {
  color: #000;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}

.rental-conditions-section .form-row {
  border-bottom: 1px solid #e2e8f0;
  padding: 8px 0;
  margin-bottom: 0;
}

.rental-conditions-section .form-row:last-child {
  border-bottom: none;
}

.monthly-costs-header {
  background-color: #dc2626 !important;
  color: white !important;
  margin: 16px -20px 16px;
  padding: 12px 20px;
  border-radius: 0;
  font-weight: 600;
}

.monthly-costs-section {
  background-color: #fef2f2;
  border: 2px solid #dc2626;
  border-radius: 8px;
  padding: 16px;
  margin: 0 0 16px 0;
}

.monthly-costs-section .cost-input-row {
  border-bottom: 1px solid #fca5a5;
}

.monthly-costs-section .cost-total-row {
  background-color: #fee2e2;
  border: 1px solid #dc2626;
  border-radius: 6px;
  margin: 8px 0 0 0;
  padding: 12px 16px;
  font-weight: 700;
}

.other-subsection {
  margin-top: 8px;
  padding-top: 0;
  border-top: none;
}

.other-subsection-title {
  font-weight: 700;
  color: #991b1b;
}

.other-subsection-header {
  padding-top: 0;
  border-bottom: none !important;
}

.other-subsection-body {
  padding-left: 24px;
}

.other-subsection-summary {
  gap: 8px;
  flex: 1 1;
  min-width: 0;
  justify-content: flex-end;
}

.other-subsection-summary-value {
  flex: 1 1;
  min-width: 0;
  box-sizing: border-box;
  padding-right: 8px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.other-custom-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  min-width: 0;
}

.other-custom-label {
  min-width: 90px;
  margin-right: 0;
}

/* ---------- SHOP MANAGEMENT / REGISTRATION ------------------------ */
.shop-management-panel {
  margin-top: 24px;
}

.shop-management-panel-header {
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
}

.shop-management-panel-header .ant-btn {
  flex: 0 0 auto;
}

.shop-management-permission-note,
.shop-management-error {
  margin-bottom: 20px;
}

.shop-management-history-section {
  border-top: 1px solid #e2e8f0;
  margin-top: 24px;
  padding-top: 24px;
}

.shop-management-subsection-header {
  align-items: baseline;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 12px;
}

.shop-management-subsection-header h4 {
  color: #1a202c;
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}

.shop-management-subsection-header span {
  color: #718096;
  font-size: 13px;
}

.shop-management-empty {
  background: #f8fafc;
  border: 1px dashed #cbd5e0;
  border-radius: 6px;
  color: #718096;
  font-size: 14px;
  padding: 20px;
  text-align: center;
}

.shop-management-table-wrapper {
  max-width: 100%;
  overflow-x: auto;
  width: 100%;
}

.shop-management-table {
  border-collapse: collapse;
  min-width: 720px;
  table-layout: fixed;
  width: 100%;
}

.shop-management-table th,
.shop-management-table td {
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
  padding: 11px 10px;
  text-align: left;
  vertical-align: middle;
}

.shop-management-table th {
  background: #f1f5f9;
  color: #334155;
  font-weight: 700;
  white-space: nowrap;
}

.shop-management-table td {
  color: #334155;
  overflow-wrap: anywhere;
}

.shop-management-table tbody tr:hover {
  background: #f8fafc;
}

.shop-management-table th:nth-child(1),
.shop-management-table td:nth-child(1) {
  width: 24%;
}

.shop-management-table th:nth-child(2),
.shop-management-table td:nth-child(2) {
  width: 20%;
}

.shop-management-table th:nth-child(3),
.shop-management-table td:nth-child(3) {
  width: 34%;
}

.shop-management-table th:nth-child(4),
.shop-management-table td:nth-child(4) {
  width: 22%;
}

.shop-management-application-table {
  min-width: 860px;
}

.shop-management-application-table th:nth-child(1),
.shop-management-application-table td:nth-child(1) {
  width: 100px;
}

.shop-management-application-table th:nth-child(2),
.shop-management-application-table td:nth-child(2) {
  width: 170px;
}

.shop-management-application-table th:nth-child(3),
.shop-management-application-table td:nth-child(3) {
  width: 130px;
}

.shop-management-application-table th:nth-child(4),
.shop-management-application-table td:nth-child(4) {
  width: 110px;
}

.shop-management-application-table th:nth-child(5),
.shop-management-application-table td:nth-child(5) {
  width: 250px;
}

.shop-management-application-table th:nth-child(6),
.shop-management-application-table td:nth-child(6) {
  width: 90px;
}

.shop-management-reason-cell {
  max-width: 250px;
  white-space: pre-wrap;
}

.shop-registration-status {
  border-radius: 999px;
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  padding: 3px 9px;
  white-space: nowrap;
}

.shop-registration-status--submitted {
  background: #dbeafe;
  color: #1d4ed8;
}

.shop-registration-status--returned {
  background: #fef3c7;
  color: #92400e;
}

.shop-registration-status--approved {
  background: #dcfce7;
  color: #166534;
}

.shop-registration-status--rejected {
  background: #fee2e2;
  color: #991b1b;
}

.shop-registration-page {
  margin: 0 auto;
  max-width: 980px;
  width: 100%;
}

.shop-registration-page-header {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 20px;
}

.shop-registration-page-header p {
  color: #718096;
  font-size: 13px;
  margin: 0 0 4px;
}

.shop-registration-page-header h2 {
  color: var(--primary);
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}

.shop-registration-status-panel {
  align-items: center;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 16px 20px;
}

.shop-registration-status-panel > div {
  align-items: center;
  display: flex;
  gap: 12px;
}

.shop-registration-status-panel-label,
.shop-registration-status-panel-id {
  color: #475569;
  font-size: 14px;
  font-weight: 600;
}

.shop-registration-status-panel-id {
  color: #64748b;
  font-weight: 400;
}

.shop-registration-reason-alert {
  margin-bottom: 16px;
}

.shop-registration-history-panel {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 18px 20px;
}

.shop-registration-history-panel h3 {
  color: #1a202c;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 12px;
}

.shop-registration-history-panel ul {
  display: grid;
  gap: 10px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.shop-registration-history-panel li {
  align-items: baseline;
  border-bottom: 1px solid #f1f5f9;
  display: grid;
  gap: 8px 14px;
  grid-template-columns: 90px 180px minmax(0, 1fr);
  padding-bottom: 10px;
}

.shop-registration-history-panel li:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.shop-registration-history-panel li > span {
  color: #334155;
  font-size: 13px;
  font-weight: 700;
}

.shop-registration-history-panel time,
.shop-registration-history-panel p {
  color: #64748b;
  font-size: 13px;
  margin: 0;
}

.shop-registration-section,
.shop-registration-review {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 24px;
}

.shop-registration-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.shop-registration-section-heading {
  align-items: flex-start;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 14px;
}

.shop-registration-section-number {
  align-items: center;
  background: var(--primary);
  border-radius: 50%;
  color: white;
  display: inline-flex;
  flex: 0 0 28px;
  font-size: 14px;
  font-weight: 700;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.shop-registration-section-heading h3 {
  color: #1a202c;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 4px;
}

.shop-registration-section-heading p,
.shop-registration-subsection-note,
.shop-registration-form-note p,
.shop-registration-review-lead {
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
  margin: 0;
}

.shop-registration-form-grid {
  display: grid;
  gap: 4px 18px;
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.shop-registration-form-grid > .ant-form-item {
  grid-column: span 6;
  min-width: 0;
}

.shop-registration-form-grid > .shop-registration-field--postcode {
  grid-column: span 4;
}

.shop-registration-form-grid > .shop-registration-field--wide {
  grid-column: 1 / -1;
}

.shop-registration-form .ant-form-item {
  margin-bottom: 16px;
}

.shop-registration-form .ant-form-item-label > label {
  color: #334155;
  font-weight: 600;
}

.shop-registration-bank-fields {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  margin-top: 4px;
  padding: 16px 16px 0;
}

.shop-registration-form-note {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  padding: 12px 16px;
}

.shop-registration-actions {
  align-items: center;
  border-top: 1px solid #e2e8f0;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 4px;
  padding-top: 20px;
}

.shop-registration-review {
  margin-top: 16px;
}

.shop-registration-review-lead {
  margin-bottom: 18px;
}

.shop-registration-review-grid {
  display: grid;
  gap: 0 24px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0;
}

.shop-registration-review-grid > div {
  border-bottom: 1px solid #e2e8f0;
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(150px, 0.4fr) minmax(0, 1fr);
  padding: 10px 0;
}

.shop-registration-review-grid dt {
  color: #64748b;
  font-size: 13px;
}

.shop-registration-review-grid dd {
  color: #1e293b;
  font-size: 14px;
  margin: 0;
  overflow-wrap: anywhere;
}

.shop-registration-forbidden {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 60vh;
}

@media (max-width: 768px) {
  .shop-management-panel-header,
  .shop-registration-page-header {
    align-items: stretch;
    flex-direction: column;
  }

  .shop-management-panel-header .ant-btn,
  .shop-registration-page-header .ant-btn {
    align-self: flex-start;
  }

  .shop-registration-section,
  .shop-registration-review {
    padding: 18px;
  }

  .shop-registration-form-grid {
    display: block;
  }

  .shop-registration-form-grid > .ant-form-item,
  .shop-registration-form-grid > .shop-registration-field--postcode,
  .shop-registration-form-grid > .shop-registration-field--wide {
    width: 100%;
  }

  .shop-registration-bank-fields {
    padding-left: 12px;
    padding-right: 12px;
  }

  .shop-registration-status-panel {
    align-items: flex-start;
    flex-direction: column;
    padding: 14px 16px;
  }

  .shop-registration-status-panel > div {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .shop-registration-history-panel li {
    grid-template-columns: 1fr;
  }

  .shop-registration-review-grid {
    display: block;
  }

  .shop-registration-actions {
    justify-content: stretch;
  }

  .shop-registration-actions .ant-btn {
    flex: 1 1;
  }
}

.other-custom-row {
  align-items: flex-start;
}

.other-custom-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
  align-items: start;
}

.other-custom-inputs__label-col {
  display: flex;
  flex-direction: column;
}

.other-custom-inputs__label-col .other-name-input {
  width: 100%;
}

.other-custom-inputs__amount-col {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.other-name-input {
  width: 180px;
  flex: 0 0 auto;
  min-width: 0;
  max-width: none;
  padding: 6px 8px;
  border: 1px solid #dc2626;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
}

.other-name-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

/* Cost item label style adjustment */
.cost-label {
  font-weight: 500;
  color: #374151;
  text-align: left;
  min-width: 120px;
  margin-right: 12px;
}

.monthly-costs-section .cost-label {
  color: #991b1b;
  font-weight: 600;
}

/* Amount input field style adjustment */
.cost-input-group {
  display: flex;
  align-items: center;
  gap: 4px;
}

.cost-input {
  width: 120px;
  text-align: right;
  font-weight: 500;
}

.monthly-costs-section .cost-input {
  border: 1px solid #dc2626;
  background-color: white;
}

.cost-total-value {
  font-weight: 700;
  color: #374151;
  font-size: 16px;
}

.monthly-costs-section .cost-total-value {
  color: #991b1b;
}

/* レスポンシブ対応 */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .property-subsection {
    margin-bottom: 1rem;
    padding-bottom: 1rem;
  }

  .cost-input-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .cost-label {
    min-width: auto;
    margin-right: 0;
  }

  .monthly-costs-header {
    margin: 16px -16px 0;
    padding: 12px 16px;
  }

  .monthly-costs-section {
    margin: 0 -16px 16px;
    padding: 12px;
  }

  .monthly-costs-section .cost-total-row {
    margin: 8px -12px -12px;
    padding: 12px;
  }

  .cost-input-row-stack-mobile {
    align-items: stretch;
  }

  .other-subsection-body {
    padding-left: 0;
  }

  .other-subsection-summary {
    align-self: flex-end;
  }

  .other-custom-left {
    width: 100%;
  }

  .other-name-input {
    flex: 1 1 auto;
    width: auto;
  }
}

/* Delay status display styles */
.delay-row {
  background-color: #fef2f2 !important;
  /* 薄い赤色背景 */
}

.delay-row:hover {
  background-color: #fecaca !important;
  /* ホバー時は少し濃い赤 */
}

.delay-status {
  padding: 8px;
}

.delay-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.delay-months {
  font-weight: 600;
  color: #dc2626;
}

.delay-tag {
  background-color: #dc2626;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.delay-normal {
  color: #059669;
  font-weight: 600;
}

/* Search and filter UI improvements */
.filters-section {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.search-input {
  flex: 1 1;
  padding: 10px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  min-width: 200px;
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.status-select {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  min-width: 120px;
}

.status-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.search-btn {
  padding: 10px 20px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.search-btn:hover {
  background-color: #2563eb;
}

.clear-btn {
  padding: 10px 16px;
  background-color: #f1f5f9;
  color: #64748b;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.clear-btn:hover {
  background-color: #e2e8f0;
  border-color: #94a3b8;
}

/* Cancel button for review table */
.btn-cancel {
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.btn-cancel:hover {
  background-color: #b91c1c;
}

.bill-section .ant-input-affix-wrapper input.ant-input {
  text-align: right;
}

.custom-upload .ant-upload {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.custom-upload .ant-upload-list {
  margin-left: 2rem;
}

.custom-upload .ant-upload-list-item {
  padding: 0;
  background: none;
  border: none;
  font-size: 13px;
  color: #2563eb;
}

.ag-horizontal-left-scroll {
  height: 0px !important;
  min-height: 0px !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

/* Hide left spacer */
.ag-horizontal-left-spacer {
  height: 0px !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

/* delete padding default Ag Grid */
.no-pad-cell {
  padding: 0 !important;
}
.ag-header-cell-label {
  justify-content: center;
}
.ag-header-cell-text {
  white-space: pre-wrap;
}
.ag-header-cell-label {
  height: fit-content;
}

.inclusive-rooms-grid .ag-header-group-cell-label,
.inclusive-rooms-grid .ag-header-cell-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100% !important;
}

.inclusive-rooms-grid .ag-header-group-cell,
.inclusive-rooms-grid .ag-header-cell {
  border-right: 1px solid #e5e7eb !important;
  border-bottom: 1px solid #e5e7eb !important;
}

.inclusive-rooms-grid .ag-header-group-cell::after,
.inclusive-rooms-grid .ag-header-cell::after,
.inclusive-rooms-grid .ag-header-group-cell-resize,
.inclusive-rooms-grid .ag-header-cell-resize {
  display: none !important;
}

.select-error .ant-select-selector,
.select-error .ant-select {
  background-color: rgb(254 226 226) !important;
}

.select-40 .ant-select-selector,
.select-40 .ant-select-selection-item,
.select-40 .ant-select-selection-search-input {
  height: 40px !important;
  line-height: 40px !important;
}

.select-40 .ant-select-arrow {
  height: 25px !important;
  align-items: center !important;
}

.inclusive-detail-table .ant-table-thead .ant-table-cell {
  background: var(--primary) !important;
  color: white !important;
}

/* Keep the wide inclusive-contract table usable without moving the page itself. */
.inclusive-detail-table {
  max-width: 100%;
  overflow: hidden;
}

.inclusive-detail-table .ant-table-body {
  overscroll-behavior: contain;
  scrollbar-gutter: stable both-edges;
}

.date-40 .ant-picker {
  height: 30px !important;
  padding: 0 12px !important;
  display: flex !important;
  align-items: center !important;
}

/* Input text inside */
.date-40 .ant-picker-input > input {
  height: 30px !important;
  line-height: 30px !important;
}

/* Icon calendar */
.date-40 .ant-picker-suffix {
  height: 30px !important;
  display: flex !important;
  align-items: center !important;
}

/* custom tooltip */
.wrap-tooltip .truncate {
  white-space: wrap;
}

.shop-select .ant-select-selection-item {
  max-width: 100% !important;
  display: inline-block !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.shop-select .ant-select-selector {
  width: 500px !important;
}
.checkbox-custom * {
  cursor: not-allowed !important;

  input {
    cursor: not-allowed;
  }
}

/* inital-guarantee-fee-table */
.received-invoice-table {
  table-layout: fixed;
  min-width: 1180px;
}

.received-invoice-table th,
.received-invoice-table td,
.inital-guarantee-fee-table th,
.inital-guarantee-fee-table td {
  overflow: hidden;
  text-overflow: ellipsis;
}

.received-invoice-table .sortable-header,
.inital-guarantee-fee-table .sortable-header {
  white-space: nowrap;
}

.received-invoice-table th:nth-child(1),
.received-invoice-table td:nth-child(1) {
  width: 150px;
}
.received-invoice-table th:nth-child(2),
.received-invoice-table td:nth-child(2) {
  width: 120px;
}
.received-invoice-table th:nth-child(3),
.received-invoice-table td:nth-child(3) {
  width: 160px;
}
.received-invoice-table th:nth-child(4),
.received-invoice-table td:nth-child(4) {
  width: 260px;
}
.received-invoice-table th:nth-child(5),
.received-invoice-table td:nth-child(5) {
  width: 120px;
}
.received-invoice-table th:nth-child(6),
.received-invoice-table td:nth-child(6) {
  width: 130px;
}
.received-invoice-table th:nth-child(7),
.received-invoice-table td:nth-child(7) {
  width: 130px;
}
.received-invoice-table th:nth-child(8),
.received-invoice-table td:nth-child(8) {
  width: 110px;
}

.inital-guarantee-fee-table {
  table-layout: fixed;
  min-width: 1440px;
}
.inital-guarantee-fee-table th:nth-child(1),
.inital-guarantee-fee-table td:nth-child(1) {
  width: 56px;
}
.inital-guarantee-fee-table th:nth-child(2),
.inital-guarantee-fee-table td:nth-child(2) {
  width: 150px;
}
.inital-guarantee-fee-table th:nth-child(3),
.inital-guarantee-fee-table td:nth-child(3) {
  width: 130px;
}
.inital-guarantee-fee-table th:nth-child(4),
.inital-guarantee-fee-table td:nth-child(4) {
  width: 150px;
}
.inital-guarantee-fee-table th:nth-child(5),
.inital-guarantee-fee-table td:nth-child(5) {
  width: 260px;
}
.inital-guarantee-fee-table th:nth-child(6),
.inital-guarantee-fee-table td:nth-child(6) {
  width: 130px;
}
.inital-guarantee-fee-table th:nth-child(7),
.inital-guarantee-fee-table td:nth-child(7) {
  width: 130px;
}
.inital-guarantee-fee-table th:nth-child(8),
.inital-guarantee-fee-table td:nth-child(8) {
  width: 140px;
}
.inital-guarantee-fee-table th:nth-child(9),
.inital-guarantee-fee-table td:nth-child(9) {
  width: 294px;
}

/* ===============================
   AntD Upload List (Text Mode)
   Custom Rebuild CSS
   =============================== */

/* LIST CONTAINER */
.custom-upload-list .ant-upload-list {
  margin-top: 8px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.88);
}

/* ITEM CONTAINER */
.custom-upload-list .ant-upload-list-item-container {
  position: relative;
}

/* ITEM */
.custom-upload-list .ant-upload-list-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 1px 12px;
  border-radius: 8px;
  min-width: 0;
  transition: background-color 0.2s ease;
}

/* HOVER BACKGROUND */
.custom-upload-list .ant-upload-list-item:hover {
  background-color: #f5f8ff;
}

/* ICON */
.custom-upload-list .ant-upload-icon {
  flex-shrink: 0;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}

/* FILE NAME */
.custom-upload-list .ant-upload-list-item-name {
  flex: 1 1;
  min-width: 0;
  color: rgba(0, 0, 0, 0.88);
  cursor: pointer;
  font-size: 12px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* FILE NAME HOVER */
.custom-upload-list .ant-upload-list-item:hover .ant-upload-list-item-name {
  color: #1677ff;
}

/* ACTIONS (DELETE) */
.custom-upload-list .ant-upload-list-item-actions {
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.2s ease;
  font-size: 12px;
}

/* SHOW ACTION ON HOVER */
.custom-upload-list .ant-upload-list-item:hover .ant-upload-list-item-actions {
  opacity: 1;
}

/* SHOW ACTION WHEN REACHED BY KEYBOARD */
.custom-upload-list .ant-upload-list-item:focus-within .ant-upload-list-item-actions {
  opacity: 1;
}

.custom-upload-list .ant-upload-list-item-actions .ant-btn:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

/* DELETE BUTTON */
.custom-upload-list .ant-upload-list-item-actions .ant-btn {
  color: rgba(0, 0, 0, 0.45);
}

/* DELETE HOVER */
.custom-upload-list .ant-upload-list-item-actions .ant-btn:hover {
  color: #ff4d4f;
}

/* OPTIONAL: divider feeling (very AntD-like) */
.custom-upload-list .ant-upload-list-item-container::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 8px;
  pointer-events: none;
}

.contract-issuance-modal .ant-modal-content {
  overflow: hidden;
}

.contract-issuance-modal .ant-modal-body {
  max-height: min(68vh, 620px);
  overflow-y: auto;
  padding: 0 4px 4px;
}

.contract-issuance-body {
  color: #1f2937;
}

.contract-issuance-body h3 {
  margin: 0 0 16px;
  color: #1f2937;
  font-size: 18px;
  font-weight: 700;
}

.contract-issuance-info-section {
  margin-top: 22px;
}

.contract-issuance-section {
  margin-top: 16px;
  border-top: 1px solid #e5e7eb;
  padding-top: 14px;
}

.contract-issuance-section h4 {
  margin: 0 0 10px;
  color: #374151;
  font-size: 14px;
  font-weight: 700;
}

.contract-issuance-person-grid,
.contract-issuance-bank-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
}

.contract-issuance-bank-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.contract-issuance-field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
  color: #4b5563;
  font-size: 12px;
}

.contract-issuance-label {
  display: inline-flex;
  align-items: baseline;
  max-width: 100%;
  white-space: nowrap;
}

.contract-issuance-radio-group {
  display: flex;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
  gap: 4px 16px;
}

.contract-issuance-radio-group .ant-radio-wrapper {
  flex: 0 0 auto;
  margin-inline-end: 0;
  white-space: nowrap;
}

.contract-issuance-field input {
  min-height: 32px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 5px 8px;
  color: #111827;
  font-size: 13px;
}

.contract-issuance-field input:focus {
  border-color: #1677ff;
  outline: 2px solid rgb(22 119 255 / 15%);
}

.contract-issuance-field input:disabled {
  background: #f3f4f6;
  color: #374151;
  cursor: not-allowed;
  opacity: 1;
}

.contract-issuance-field-error input {
  border-color: #ff4d4f;
}

.contract-issuance-error {
  color: #dc2626;
  font-size: 11px;
}

.contract-issuance-rent,
.contract-issuance-caution,
.contract-issuance-preview-card {
  margin-top: 16px;
  border-radius: 4px;
  padding: 12px;
}

.contract-issuance-rent {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #f9fafb;
  font-size: 13px;
}

.contract-issuance-rent .contract-issuance-radio-group {
  align-items: center;
}

.contract-issuance-caution {
  color: #dc2626;
  background: #fff7ed;
  font-size: 12px;
}

.contract-issuance-caution ul {
  margin: 6px 0 0 18px;
  list-style: disc;
}

.contract-issuance-preview-card {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  background: #eff6ff;
  color: #1e3a8a;
  font-size: 12px;
}

.contract-issuance-hint {
  margin: 10px 0 0;
  color: #4b5563;
  font-size: 12px;
}

.contract-issuance-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 8px 4px;
}

@media (max-width: 1100px) {
  .contract-issuance-modal .ant-modal {
    max-width: calc(100vw - 32px);
  }

  .contract-issuance-bank-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 700px) {
  .contract-issuance-person-grid,
  .contract-issuance-bank-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAmC;EAAnC,cAAmC;EAAnC,qCAAmC;AACrC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf;;;yBAGuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;;;IAME,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;;EAIE,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;EAME,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,yEAAyE;AACzE;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,yEAAyE;AACzE;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8EAA8E;EAC9E,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB;;mBAEiB;AACnB;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,uFAAuF;AACvF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2CAA2C;EAC3C,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;;;;EAIE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA,0FAA0F;AAC1F;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,yBAAyB;EACzB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,qEAAqE;EACrE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gFAAgF;EAChF,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,qHAAqH;AACvH;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD,uDAAuD;AACvD;EACE,gBAAgB;EAChB,QAAQ;EACR,uCAAuC;EACvC,iBAAiB;EACjB,UAAU;EACV,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,oCAAoC;EACpC,eAAe;AACjB;;AAEA,yCAAyC;AACzC;;EAEE,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;;;EAME,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,sEAAsE;AACtE;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB;;mBAEiB;AACnB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;EAEE,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,wBAAwB;EACxB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB;;mBAEiB;AACnB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB;;mBAEiB;AACnB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,wEAAwE;AACxE;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB;;mBAEiB;AACnB;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;AACjB;;AAEA,WAAW;AACX;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mDAAmD;EACnD,8BAA8B;EAC9B,gFAAgF;EAChF,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gDAAgD;IAChD,kCAAkC;EACpC;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;;IAEE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,oCAAoC;IACpC,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,wEAAwE;;AAExE,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,uEAAuE;;AAEvE,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;;;EAGE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA,wEAAwE;;AAExE,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,oDAAoD;AACpD;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sEAAsE;;AAEtE,oBAAoB;AACpB;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,oDAAoD;EACpD,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;EACE,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,iDAAiD;AACjD;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0FAA0F;AAC5F;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,aAAa;IACb,0CAA0C;IAC1C,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf;;mBAEiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;EAIA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;AAPF;;AAUA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;EAChC,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;EACb;AACF;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;;EAGE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA,sEAAsE;AACtE;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE;IACE,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,SAAS;EACT,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,uEAAuE;AACvE;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,0DAA0D;EAC1D,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAW;EACb;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,aAAa;AACb;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;AACzB;;AAEA;;EAEE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;;EAGE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA,kFAAkF;AAClF;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;;EAE9B;IACE,mBAAmB;EACrB;AACF;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;EAIE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;;AAEA;;;oCAGoC;;AAEpC,mBAAmB;AACnB;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;AACxC;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,SAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,eAAe;;EAEf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,UAAU;EACV,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,UAAU;AACZ;;AAEA,yCAAyC;AACzC;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;;IAEE,qCAAqC;EACvC;AACF","sourcesContent":["/* --- THEME VARIABLES ------------------------------------------------ */\n:root {\n  --primary: #0a4ea1;\n  --primary-light: #1a6bc8;\n  --bg: #f7fafc;\n  --text: #1a202c;\n  --card-bg: #ffffff;\n}\n\n/* --- RESET & BASE --------------------------------------------------- */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  background: var(--bg);\n  color: var(--text);\n}\n\n.skeleton-table-placeholder {\n  display: block;\n  max-width: 100%;\n}\n\n.skeleton-table-placeholder .ant-skeleton,\n.skeleton-table-placeholder .ant-skeleton-input {\n  width: 100% !important;\n  min-width: 0 !important;\n  max-width: 100% !important;\n}\n\n/* ---------- LOGIN PAGE ---------- */\n#loginPage {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #3182ce 0%, #63b3ed 100%);\n}\n\n.login-card {\n  background: #fff;\n  padding: 2.5rem 3rem;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.login-card h1 {\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  color: #2d3748;\n  white-space: nowrap;\n}\n\n.login-card label {\n  display: block;\n  font-size: 14px;\n  margin-bottom: 0.25rem;\n  text-align: left;\n}\n\n.login-card input {\n  width: 100%;\n  padding: 0.65rem 0.75rem;\n  /* margin-bottom: 1.25rem; */\n  border: 1px solid #cbd5e0;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.remember-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 1.5rem;\n  font-size: 13px;\n}\n\n.remember-wrapper input {\n  accent-color: #3182ce;\n}\n\n.login-card button {\n  width: 100%;\n  padding: 0.75rem;\n  background: #3182ce;\n  color: #fff;\n  font-size: 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.login-card button:hover {\n  background: var(--primary);\n}\n\n/* --- MENU PAGE ------------------------------------------------------ */\n.menu-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 32px 0;\n  min-height: 100vh;\n}\n\n.container {\n  width: 100%;\n  max-width: 840px;\n}\n\n.card {\n  background: var(--card-bg);\n  border-radius: 12px;\n  padding: 2.5rem 2rem 3rem;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n.menu-container h1 {\n  text-align: center;\n  font-size: 32px;\n  font-weight: 600;\n  margin-bottom: 2rem;\n  letter-spacing: -0.5px;\n  color: var(--primary);\n}\n\n.menu-container h2 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: #4a5568;\n}\n\n/* --- MENU BUTTONS --------------------------------------------------- */\n.btn-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n}\n\n/* Wrapper for button + description */\n.btn-item {\n  flex: 1 1 240px;\n  display: flex;\n  flex-direction: column;\n}\n\n.btn-item-half {\n  flex: 0 1 calc((100% - 1.5rem) / 2);\n}\n\n.btn-item .btn-menu {\n  flex: none;\n}\n\n.contract-active-menu {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.contract-active-menu .btn-item {\n  min-width: 0;\n}\n\n.contract-active-menu .btn-menu {\n  width: 100%;\n  min-height: 46px;\n}\n\n@media (max-width: 768px) {\n  .contract-active-menu {\n    grid-template-columns: 1fr;\n  }\n\n  .btn-item-half {\n    flex-basis: 100%;\n  }\n}\n\n.account-menu-spacer {\n  visibility: hidden;\n}\n\n.btn-item .btn-desc,\n.btn-desc {\n  margin-top: 0.5rem;\n  font-size: 14px;\n  color: #718096;\n  text-align: center;\n  line-height: 1.4;\n}\n\n.btn-menu {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 240px;\n  background: var(--primary);\n  color: #fff;\n  font-size: 17px;\n  font-weight: 600;\n  padding: 0.6rem 1.25rem;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition:\n    transform 0.15s ease,\n    box-shadow 0.15s ease,\n    background 0.15s ease;\n}\n\n.btn-menu:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  background: var(--primary-light);\n}\n\n.btn-menu:active {\n  transform: translateY(0);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.btn-menu.logout-btn {\n  background: #e53e3e;\n}\n\n.btn-menu.logout-btn:hover {\n  background: #c53030;\n}\n\n.btn-menu.change-password-btn {\n  background: #e7eaec;\n  color: #4a5568;\n}\n\n.btn-menu.change-password-btn:hover {\n  background-color: #ccd1d6;\n}\n\n.btn-menu-content {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n}\n\n.btn-menu-inline-badge .ant-badge-count {\n  box-shadow: none;\n}\n\n.settings-panel {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 24px;\n}\n\n.contracts-list-page.settings-page {\n  margin: 0 auto;\n  max-width: 980px;\n}\n\n.settings-panel-header {\n  border-bottom: 1px solid #e2e8f0;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n}\n\n.settings-panel-header h3 {\n  color: #1a202c;\n  font-size: 18px;\n  font-weight: 700;\n  margin: 0 0 6px;\n}\n\n.settings-panel-header p {\n  color: #718096;\n  font-size: 14px;\n  margin: 0;\n}\n\n.settings-row {\n  display: grid;\n  gap: 24px;\n  grid-template-columns: minmax(0, 1fr) minmax(280px, 420px);\n}\n\n.settings-row-copy label {\n  color: #2d3748;\n  display: block;\n  font-size: 15px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.settings-row-copy p,\n.settings-note {\n  color: #718096;\n  font-size: 14px;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.settings-row-control {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-start;\n}\n\n.settings-row-control span {\n  color: #2d3748;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.settings-note {\n  margin-top: 20px;\n}\n\n.settings-actions {\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n  padding-top: 20px;\n}\n\n.broker-basic-info-form {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n}\n\n.broker-basic-info-alert {\n  margin-bottom: 2px;\n}\n\n.broker-basic-info-section h3 {\n  color: #1a202c;\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0 0 14px;\n}\n\n.broker-basic-info-section-note {\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.6;\n  margin: -6px 0 14px;\n}\n\n.broker-basic-info-grid {\n  display: grid;\n  gap: 4px 18px;\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n}\n\n.broker-basic-info-grid > .ant-form-item {\n  grid-column: span 6;\n}\n\n.broker-basic-info-address-grid {\n  grid-template-columns: 240px 260px;\n  max-width: 518px;\n}\n\n.broker-basic-info-address-grid > .broker-basic-info-field--postcode {\n  grid-column: 1;\n  grid-row: 1;\n  max-width: 240px;\n}\n\n.broker-basic-info-address-grid > .broker-basic-info-field--pref {\n  grid-column: 1;\n  grid-row: 2;\n}\n\n.broker-basic-info-address-grid > .broker-basic-info-field--district {\n  grid-column: 2;\n  grid-row: 2;\n}\n\n.broker-basic-info-address-grid > .broker-basic-info-field--address {\n  grid-column: 1 / span 2;\n  grid-row: 3;\n}\n\n.broker-basic-info-address-grid > .broker-basic-info-field--building {\n  grid-column: 1 / span 2;\n  grid-row: 4;\n}\n\n.broker-basic-info-form .ant-form-item {\n  margin-bottom: 16px;\n}\n\n.broker-basic-info-actions {\n  margin-top: 2px;\n}\n\n.broker-profile-setup-page {\n  background: #f5f7fb;\n  min-height: 100vh;\n  padding: 40px 20px;\n}\n\n.broker-profile-setup-shell {\n  margin: 0 auto;\n  max-width: 980px;\n}\n\n.broker-profile-setup-header {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n\n.broker-profile-setup-header p {\n  color: #718096;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0;\n  margin: 0 0 4px;\n}\n\n.broker-profile-setup-header h1 {\n  color: #1a202c;\n  font-size: 24px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.broker-profile-setup-panel {\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);\n}\n\n@media (max-width: 768px) {\n  .settings-panel {\n    padding: 18px;\n  }\n\n  .settings-row {\n    grid-template-columns: 1fr;\n  }\n\n  .settings-row-control {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .settings-actions {\n    justify-content: stretch;\n  }\n\n  .settings-actions .ant-btn {\n    width: 100%;\n  }\n\n  .broker-basic-info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .broker-basic-info-grid > .ant-form-item,\n  .broker-basic-info-address-grid > .broker-basic-info-field--postcode,\n  .broker-basic-info-address-grid > .broker-basic-info-field--pref,\n  .broker-basic-info-address-grid > .broker-basic-info-field--district,\n  .broker-basic-info-address-grid > .broker-basic-info-field--address,\n  .broker-basic-info-address-grid > .broker-basic-info-field--building {\n    grid-column: 1;\n    grid-row: auto;\n    max-width: none;\n  }\n\n  .broker-profile-setup-page {\n    padding: 22px 14px;\n  }\n\n  .broker-profile-setup-header {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .account-menu-spacer {\n    display: none;\n  }\n}\n\n.broker-fee-radio {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.broker-fee-radio .ant-radio-button-wrapper {\n  min-width: 150px;\n  height: 36px;\n  line-height: 34px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.broker-fee-recipient-row {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px 12px;\n}\n\n.broker-access-fee-requirement-text {\n  color: #b45309;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.broker-access-modal-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.broker-access-create-modal .ant-modal-content {\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 160px);\n}\n\n.broker-access-create-modal .ant-modal-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n}\n\n.broker-access-guidance {\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n  color: #1e3a8a;\n  border-radius: 6px;\n  padding: 12px 14px;\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.broker-access-guidance p {\n  margin-top: 4px;\n}\n\n.broker-access-step {\n  border: 1px solid #d8dee9;\n  border-radius: 6px;\n  background: #fff;\n}\n\n.broker-access-step-header {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 14px 16px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f8fafc;\n}\n\n.broker-access-step-number {\n  flex: 0 0 auto;\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  background: var(--primary);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.broker-access-step-header h3 {\n  margin: 0;\n  color: #1f2937;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.4;\n}\n\n.broker-access-step-header p {\n  margin: 3px 0 0;\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.broker-access-step-body {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 16px;\n}\n\n.broker-access-field-row {\n  display: grid;\n  grid-template-columns: 150px minmax(0, 1fr);\n  gap: 14px;\n  align-items: start;\n}\n\n.broker-access-field-row > label {\n  padding-top: 7px;\n  color: #374151;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.broker-access-status-text {\n  margin-top: 8px;\n  color: #1d4ed8;\n  font-size: 13px;\n}\n\n.broker-access-selected-broker {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: center;\n  border: 1px solid #bfdbfe;\n  border-radius: 6px;\n  background: #eff6ff;\n  padding: 10px 12px;\n  margin-top: 12px;\n}\n\n.broker-access-selected-broker span {\n  display: block;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 2px;\n}\n\n.broker-access-selected-broker strong {\n  display: block;\n  color: #111827;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.broker-access-selected-broker p {\n  color: #475569;\n  font-size: 13px;\n  margin-top: 2px;\n}\n\n.broker-access-new-broker-box {\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #f9fafb;\n  padding: 12px;\n  margin-top: 12px;\n}\n\n.broker-access-help-text {\n  margin-top: 8px;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.broker-access-warning-text {\n  margin-top: 6px;\n  color: #b45309;\n  font-size: 13px;\n}\n\n.broker-access-selection-table,\n.broker-access-room-fee-table table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.broker-access-selection-table th,\n.broker-access-selection-table td,\n.broker-access-room-fee-table th,\n.broker-access-room-fee-table td {\n  border: 1px solid #d1d5db;\n  padding: 9px 10px;\n  vertical-align: middle;\n}\n\n.broker-access-selection-table th,\n.broker-access-room-fee-table th {\n  background: #f3f4f6;\n  color: #374151;\n  font-weight: 700;\n}\n\n.broker-access-selection-table tbody tr,\n.broker-access-selection-table tbody td {\n  background: #fff;\n}\n\n.broker-access-selection-table tbody tr:hover {\n  background: #eff6ff;\n}\n\n.broker-access-selection-table tbody tr:hover td {\n  background: #eff6ff;\n}\n\n.broker-access-room-tag-input {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  min-height: 40px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  padding: 5px 8px;\n}\n\n.broker-access-room-tag-input:focus-within {\n  border-color: #1677ff;\n  box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);\n}\n\n.broker-access-room-tag-input .ant-tag {\n  display: inline-flex;\n  align-items: center;\n  margin: 0;\n  border-radius: 999px;\n  padding: 3px 9px;\n  font-size: 13px;\n}\n\n.broker-access-room-tag-input input {\n  flex: 1 1 140px;\n  min-width: 120px;\n  border: 0;\n  outline: 0;\n  padding: 4px 0;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.broker-access-note {\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #f9fafb;\n  color: #4b5563;\n  padding: 10px 12px;\n  font-size: 13px;\n}\n\n.broker-access-permission-draft {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  border: 1px solid #d8dee9;\n  border-radius: 6px;\n  background: #f8fafc;\n  padding: 14px;\n}\n\n.broker-access-permission-draft > .broker-access-subheading {\n  margin-bottom: 0;\n}\n\n.broker-access-draft-actions {\n  display: flex;\n  justify-content: flex-end;\n  border-top: 1px solid #e5e7eb;\n  padding-top: 12px;\n}\n\n.broker-access-property-draft {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: center;\n  border: 1px solid #bfdbfe;\n  border-radius: 6px;\n  background: #eff6ff;\n  padding: 10px 12px;\n}\n\n.broker-access-property-draft span,\n.broker-access-property-card-header span {\n  display: block;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 2px;\n}\n\n.broker-access-property-title {\n  min-width: 0;\n}\n\n.broker-access-property-title-line {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 10px;\n  align-items: baseline;\n  min-width: 0;\n}\n\n.broker-access-property-draft strong,\n.broker-access-property-card-header strong {\n  color: #111827;\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n.broker-access-property-draft p,\n.broker-access-property-card-header p {\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.45;\n  margin: 0;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.broker-access-property-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.broker-access-property-card {\n  border: 1px solid #d8dee9;\n  border-radius: 6px;\n  background: #fff;\n}\n\n.broker-access-property-card-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: center;\n  padding: 9px 12px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f8fafc;\n}\n\n.broker-access-property-card-header > div {\n  min-width: 0;\n}\n\n.broker-access-property-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 14px;\n}\n\n.broker-access-property-setting-row {\n  display: grid;\n  grid-template-columns: 110px minmax(0, 1fr);\n  gap: 12px;\n  align-items: start;\n}\n\n.broker-access-property-setting-row > label {\n  padding-top: 7px;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.broker-access-subheading {\n  margin-bottom: 8px;\n  color: #374151;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.broker-access-summary {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.broker-access-summary > div {\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #f9fafb;\n  padding: 10px 12px;\n  min-width: 0;\n}\n\n.broker-access-summary span {\n  display: block;\n  color: #6b7280;\n  font-size: 12px;\n  margin-bottom: 3px;\n}\n\n.broker-access-summary strong {\n  display: block;\n  color: #111827;\n  font-size: 14px;\n  line-height: 1.45;\n  overflow-wrap: break-word;\n}\n\n.table-wrapper.broker-access-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.review-table.broker-access-list-table {\n  width: 100%;\n  min-width: 1248px;\n  table-layout: fixed;\n}\n\n.review-table.broker-access-list-table td {\n  font-weight: 400;\n}\n\n.review-table.broker-access-list-table .broker-access-list-col-broker {\n  width: 210px;\n}\n\n.review-table.broker-access-list-table .broker-access-list-col-room {\n  width: 130px;\n}\n\n.review-table.broker-access-list-table .broker-access-list-col-fee {\n  width: 128px;\n}\n\n.review-table.broker-access-list-table .broker-access-list-col-delegation {\n  width: 112px;\n}\n\n.review-table.broker-access-list-table .broker-access-list-col-contract {\n  width: 82px;\n}\n\n.review-table.broker-access-list-table .broker-access-list-col-status {\n  width: 78px;\n}\n\n.review-table.broker-access-list-table .broker-access-list-col-operation {\n  width: 72px;\n}\n\n.review-table.broker-access-list-table th:nth-child(1),\n.review-table.broker-access-list-table td:nth-child(1) {\n  width: 210px;\n}\n\n.review-table.broker-access-list-table th:nth-child(2),\n.review-table.broker-access-list-table td:nth-child(2) {\n  width: auto;\n}\n\n.review-table.broker-access-list-table th:nth-child(3),\n.review-table.broker-access-list-table td:nth-child(3) {\n  width: 130px;\n}\n\n.review-table.broker-access-list-table th:nth-child(4),\n.review-table.broker-access-list-table td:nth-child(4) {\n  width: 128px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.review-table.broker-access-list-table th:nth-child(4) {\n  line-height: 1.35;\n  white-space: normal;\n}\n\n.review-table.broker-access-list-table th:nth-child(5),\n.review-table.broker-access-list-table td:nth-child(5) {\n  width: 112px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.review-table.broker-access-list-table th:nth-child(6),\n.review-table.broker-access-list-table td:nth-child(6) {\n  width: 82px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.review-table.broker-access-list-table th:nth-child(7),\n.review-table.broker-access-list-table td:nth-child(7) {\n  width: 78px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.review-table.broker-access-list-table th:nth-child(8),\n.review-table.broker-access-list-table td:nth-child(8) {\n  width: 72px;\n  min-width: 72px;\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.broker-access-list-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.broker-access-page-title {\n  text-wrap: balance;\n}\n\n.broker-access-property-cell {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n}\n\n.broker-access-property-count {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.broker-access-property-names {\n  min-width: 0;\n  overflow: hidden;\n  color: #4b5563;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.broker-access-list-actions {\n  display: flex;\n  justify-content: center;\n}\n\n.broker-access-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.broker-access-detail-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px 20px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #f9fafb;\n  padding: 14px 16px;\n  font-size: 14px;\n}\n\n.broker-access-detail-summary > div {\n  min-width: 0;\n}\n\n.broker-access-detail-summary .font-semibold,\n.broker-access-detail-summary .text-gray-500 + div {\n  overflow-wrap: break-word;\n}\n\n.broker-access-detail-table {\n  width: 100%;\n  border-collapse: collapse;\n  border: 1px solid #d1d5db;\n  font-size: 13px;\n  table-layout: fixed;\n}\n\n.broker-access-detail-table th,\n.broker-access-detail-table td {\n  border: 1px solid #d1d5db;\n  padding: 8px 10px;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.broker-access-detail-table th {\n  background: #f8fafc;\n  color: #374151;\n  font-weight: 700;\n}\n\n.broker-access-detail-table th:nth-child(3),\n.broker-access-detail-table td:nth-child(3),\n.broker-access-detail-table th:nth-child(4),\n.broker-access-detail-table td:nth-child(4),\n.broker-access-detail-table th:nth-child(5),\n.broker-access-detail-table td:nth-child(5) {\n  width: 110px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.broker-access-detail-table th:last-child,\n.broker-access-detail-table td:last-child {\n  width: 112px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.broker-access-room-list {\n  max-width: 280px;\n  overflow-wrap: break-word;\n  line-height: 1.45;\n}\n\n.broker-access-room-delegation-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.broker-access-room-delegation-list > div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.broker-access-room-delegation-list span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (max-width: 768px) {\n  .broker-access-field-row,\n  .broker-access-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .broker-access-detail-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .broker-access-property-draft,\n  .broker-access-property-card-header {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .broker-access-property-setting-row {\n    grid-template-columns: 1fr;\n  }\n\n  .broker-access-new-broker-box .grid,\n  .broker-access-permission-draft .grid {\n    grid-template-columns: 1fr;\n  }\n\n  .broker-access-draft-actions {\n    justify-content: stretch;\n  }\n\n  .broker-access-draft-actions .ant-btn {\n    width: 100%;\n  }\n}\n\n/* --- BUSINESS MENU TABS --------------------------------------------- */\n.business-menu-tabs .ant-tabs-nav {\n  margin-bottom: 1.5rem;\n}\n\n.business-menu-tabs .ant-tabs-tab {\n  font-size: 16px;\n  font-weight: 600;\n  padding: 12px 24px;\n}\n\n.business-menu-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: var(--primary);\n}\n\n.business-menu-tabs .ant-tabs-ink-bar {\n  background: var(--primary);\n}\n\n.tab-content {\n  min-height: 300px;\n}\n\n/* --- FLOW CHART STYLES ---------------------------------------------- */\n.flow-container-full {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  width: 100%;\n}\n\n.flow-section {\n  padding: 1rem 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.flow-section:last-child {\n  border-bottom: none;\n}\n\n.flow-section-label {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--primary);\n  margin-bottom: 1rem;\n  padding-left: 0.5rem;\n  border-left: 4px solid var(--primary);\n}\n\n/* 横並びレイアウト（番号+ボタン左、説明右） */\n.flow-step-row {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 0.75rem;\n}\n\n.flow-step-row:last-child {\n  margin-bottom: 0;\n}\n\n.flow-step-left {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 280px;\n  flex-shrink: 0;\n}\n\n.flow-step-number {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--primary);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 13px;\n  flex-shrink: 0;\n}\n\n.flow-step-number-placeholder {\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n}\n\n.flow-step-left .btn-menu.flow-btn {\n  flex: 1;\n}\n\n.flow-step-right {\n  flex: 1;\n}\n\n.flow-step-desc {\n  margin: 0;\n  font-size: 14px;\n  color: #718096;\n  line-height: 1.4;\n}\n\n.btn-icon {\n  display: inline-flex;\n  align-items: center;\n  margin-right: 0.5rem;\n}\n\n.flow-arrow-down {\n  display: none;\n}\n\n/* 横並び2ボタン */\n.flow-step-dual-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.flow-step-dual-row:last-child {\n  margin-bottom: 0;\n}\n\n.flow-step-dual-content {\n  display: flex;\n  gap: 1rem;\n  flex: 1;\n}\n\n.flow-dual-item {\n  flex: 1;\n  max-width: 240px;\n}\n\n.flow-dual-item .btn-menu.flow-btn {\n  width: 100%;\n}\n\n.flow-dual-item .flow-step-desc {\n  margin-top: 0.5rem;\n  text-align: center;\n}\n\n/* --- FOOTER --------------------------------------------------------- */\nfooter {\n  text-align: center;\n  font-size: 13px;\n  color: #718096;\n  margin-top: 2rem;\n}\n\nfooter a {\n  color: var(--primary);\n  text-decoration: none;\n}\n\n/* --- PAGE LAYOUT ---------------------------------------------------- */\n.app-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.page-header {\n  background: var(--primary);\n  color: white;\n  padding: 1rem 2rem;\n  display: grid;\n  grid-template-columns: minmax(160px, 220px) minmax(0, 1fr) minmax(280px, auto);\n  column-gap: 16px;\n  align-items: center;\n  min-height: 72px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.header-logo-main {\n  height: auto;\n  max-height: 60px;\n  margin: -16px 0;\n  object-fit: contain;\n}\n\n.header-logo {\n  width: 50px;\n  height: auto;\n  object-fit: contain;\n}\n\n.page-header h1 {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n  white-space: nowrap;\n}\n\n.header-actions {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  min-width: 0;\n}\n\n.header-account-badge {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  color: #374151;\n  font-size: 14px;\n  line-height: 1.4;\n  max-width: 320px;\n  overflow: hidden;\n  padding: 6px 10px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.back-btn,\n.logout-btn-header {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.2s;\n  white-space: nowrap;\n}\n\n.back-btn:hover,\n.logout-btn-header:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.logout-btn-header {\n  flex: 0 0 auto;\n  justify-self: end;\n}\n\n.page-main {\n  flex: 1;\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n@media (max-width: 640px) {\n  .page-header {\n    grid-template-columns: 1fr 1fr;\n    padding: 10px 16px;\n    row-gap: 8px;\n  }\n\n  .header-content {\n    gap: 8px;\n    grid-column: 1 / -1;\n    grid-row: 1;\n    max-width: 100%;\n  }\n\n  .header-logo-main {\n    max-height: 34px;\n    max-width: 170px;\n    margin: 0;\n  }\n\n  .page-header h1 {\n    font-size: 16px;\n  }\n\n  .back-btn {\n    grid-column: 1;\n    grid-row: 2;\n    justify-self: start;\n  }\n\n  .header-actions {\n    display: contents;\n  }\n\n  .header-account-badge {\n    display: block;\n    grid-column: 1 / -1;\n    grid-row: 3;\n    justify-self: stretch;\n    max-width: none;\n    text-align: center;\n  }\n\n  .logout-btn-header {\n    grid-column: 2;\n    grid-row: 2;\n  }\n\n  .header-actions .logout-btn-header {\n    justify-self: end;\n  }\n\n  .back-btn,\n  .logout-btn-header {\n    font-size: 12px;\n    padding: 8px 10px;\n  }\n\n  .page-main {\n    padding: 1rem;\n  }\n}\n\n.page-content h2 {\n  font-size: 28px;\n  font-weight: 600;\n  color: var(--primary);\n  margin-bottom: 1rem;\n}\n\n.page-content p {\n  font-size: 16px;\n  color: #4a5568;\n}\n\n/* --- VARIABLE REGISTER PAGE ----------------------------------------- */\n.variable-register-page {\n  width: 100%;\n  max-width: 1400px;\n}\n\n.variable-register-page h2 {\n  font-size: 28px;\n  font-weight: 600;\n  color: var(--primary);\n  margin-bottom: 2rem;\n}\n\n.variable-register-page.variable-cost-register-page {\n  width: min(1260px, calc(100vw - 4rem));\n  max-width: none;\n  margin-left: 50%;\n  transform: translateX(-50%);\n}\n\n.variable-register-page.subrogation-payment-page {\n  width: min(1260px, calc(100vw - 4rem));\n  max-width: none;\n  margin-left: 50%;\n  transform: translateX(-50%);\n}\n\n.variable-cost-context-row {\n  display: flex;\n  align-items: stretch;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.variable-cost-register-page .variable-cost-month-navigation {\n  flex: 0 0 auto;\n  height: 58px;\n  min-height: 0;\n  border-radius: 12px;\n  padding: 0.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.variable-cost-month-navigation .month-display {\n  min-width: 16rem;\n}\n\n.variable-cost-register-page .variable-cost-deadline-info {\n  flex: 1 1 420px;\n  margin-bottom: 0;\n}\n\n.variable-cost-deadline-info .deadline-card {\n  height: 58px;\n}\n\n.subrogation-context-row {\n  display: flex;\n  align-items: stretch;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.subrogation-payment-page .subrogation-month-navigation {\n  flex: 0 0 auto;\n  height: 58px;\n  min-height: 0;\n  border-radius: 12px;\n  padding: 0.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.subrogation-payment-page .subrogation-month-navigation .month-display {\n  min-width: 10rem;\n}\n\n.subrogation-deadline-summary {\n  align-items: stretch;\n}\n\n.subrogation-deadline-summary .subrogation-deadline-info {\n  flex: 1 1 0;\n  margin-bottom: 0;\n  min-width: 0;\n}\n\n.subrogation-deadline-summary .subrogation-deadline-card {\n  min-height: 58px;\n  gap: 0.75rem;\n  padding: 0.5rem 1rem;\n}\n\n.subrogation-deadline-copy {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.subrogation-deadline-summary .deadline-label,\n.subrogation-deadline-summary .deadline-date {\n  white-space: nowrap;\n}\n\n.subrogation-create-month-navigation {\n  flex: 0 0 auto;\n  align-self: stretch;\n}\n\n.subrogation-create-month-navigation .month-display {\n  min-width: 8rem;\n  text-align: center;\n}\n\n/* FILTERS SECTION */\n.filters-section {\n  margin-bottom: 1.5rem;\n}\n\n.filter-group {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.search-input,\n.month-picker {\n  padding: 0.65rem 0.9rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  background: white;\n  min-width: 200px;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.search-input:focus,\n.month-picker:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(43, 108, 176, 0.1);\n}\n\n.search-input::placeholder {\n  color: #a0aec0;\n}\n\n/* ACTIONS SECTION */\n.actions-section {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.variable-cost-actions-section {\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  flex-wrap: nowrap;\n}\n\n.variable-cost-register-page .variable-cost-search-input {\n  flex: 0 1 360px;\n  height: 42px;\n  min-width: 280px;\n  max-width: 360px;\n  padding: 0 1rem;\n  border-radius: 8px;\n}\n\n.variable-cost-action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-left: auto;\n}\n\n.variable-cost-register-page .variable-cost-action-buttons .btn-outline,\n.variable-cost-register-page .variable-cost-action-buttons .btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 42px;\n  padding: 0 1.25rem;\n  font-size: 14px;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.variable-cost-target-selector {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin: 0 0 1rem;\n  padding: 1rem 1.125rem;\n  border: 1px solid #dbe7f4;\n  border-radius: 12px;\n  background: #f8fbff;\n}\n\n.variable-cost-target-selector h3 {\n  margin: 0 0 0.25rem;\n  color: #1f4f82;\n  font-size: 16px;\n  font-weight: 650;\n}\n\n.variable-cost-target-selector p {\n  margin: 0;\n  color: #4a5c70;\n  font-size: 13px;\n}\n\n.variable-cost-target-entry {\n  flex: 0 0 auto;\n  min-height: 42px;\n  white-space: nowrap;\n}\n\n.variable-cost-target-dialog-backdrop {\n  position: fixed;\n  z-index: 1200;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  padding: 1.25rem;\n  background: rgba(20, 42, 68, 0.44);\n}\n\n.variable-cost-initial-target-dialog-backdrop {\n  width: 100vw;\n  min-height: 100vh;\n  min-height: 100dvh;\n  overflow: auto;\n}\n\n.variable-cost-target-dialog {\n  width: min(880px, 100%);\n  max-height: min(760px, calc(100vh - 2.5rem));\n  overflow: auto;\n  padding: 1.25rem;\n  border: 1px solid #cbdceb;\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 18px 48px rgba(19, 46, 76, 0.3);\n}\n\n.variable-cost-target-dialog-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.variable-cost-target-dialog h3 {\n  margin: 0 0 0.4rem;\n  color: #183f67;\n  font-size: 20px;\n}\n\n.variable-cost-target-dialog p {\n  margin: 0;\n  color: #526579;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.variable-cost-target-search-row {\n  display: grid;\n  grid-template-columns: auto minmax(220px, 1fr) auto;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.variable-cost-target-search-row label {\n  color: #334e68;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.variable-cost-target-search-row input {\n  min-width: 0;\n  min-height: 42px;\n  padding: 0 0.75rem;\n  border: 1px solid #b9cadb;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.variable-cost-target-search-row input:focus-visible,\n.variable-cost-target-dialog button:focus-visible,\n.variable-cost-target-results input:focus-visible {\n  outline: 3px solid rgba(38, 121, 205, 0.35);\n  outline-offset: 2px;\n}\n\n.variable-cost-target-message {\n  margin: 0 0 0.75rem !important;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid #f4b4b4;\n  border-radius: 8px;\n  background: #fff5f5;\n  color: #a12828 !important;\n}\n\n.variable-cost-target-selection-summary {\n  margin-bottom: 0.5rem;\n  color: #234f7d;\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.variable-cost-target-results {\n  overflow-x: auto;\n  border: 1px solid #dbe3eb;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.variable-cost-target-results > p {\n  padding: 1.25rem;\n  text-align: center;\n}\n\n.variable-cost-target-results table {\n  width: 100%;\n  min-width: 660px;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 14px;\n}\n\n.variable-cost-target-results th,\n.variable-cost-target-results td {\n  padding: 0.7rem 0.75rem;\n  border-bottom: 1px solid #e6edf4;\n  color: #283e54;\n  text-align: left;\n  vertical-align: top;\n}\n\n.variable-cost-target-results th {\n  background: #f4f8fc;\n  color: #365675;\n  font-size: 13px;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.subrogation-excel-target-dialog .variable-cost-target-results th:first-child,\n.subrogation-excel-target-dialog .variable-cost-target-results td:first-child {\n  width: 40px;\n  padding-right: 0;\n  padding-left: 0;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.subrogation-excel-target-dialog .subrogation-excel-selection-checkbox {\n  display: block;\n  width: 16px;\n  height: 16px;\n  margin: 0 auto;\n}\n\n.variable-cost-initial-target-dialog .variable-cost-target-results th:first-child,\n.variable-cost-initial-target-dialog .variable-cost-target-results td:first-child {\n  min-width: 96px;\n  white-space: nowrap;\n}\n\n.variable-cost-initial-target-dialog .variable-cost-initial-target-selection-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  white-space: nowrap;\n}\n\n.variable-cost-target-results tbody tr:not(.is-already-selected):hover {\n  background: #f7fbff;\n}\n\n.variable-cost-target-results .is-already-selected {\n  background: #f8f8f8;\n  color: #718096;\n}\n\n.variable-cost-target-dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n/* The Excel selector is portaled to the document body and owns its result scrolling. */\n.subrogation-excel-target-dialog-backdrop {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overscroll-behavior: contain;\n}\n\n.subrogation-excel-target-dialog {\n  display: flex;\n  flex-direction: column;\n  max-height: min(760px, calc(100vh - 2.5rem));\n  max-height: min(760px, calc(100dvh - 2.5rem));\n  overflow: hidden;\n}\n\n.subrogation-excel-target-dialog .variable-cost-target-dialog-heading,\n.subrogation-excel-target-dialog .variable-cost-target-search-row,\n.subrogation-excel-target-dialog .variable-cost-target-selection-summary,\n.subrogation-excel-target-dialog .variable-cost-target-dialog-actions {\n  flex: 0 0 auto;\n}\n\n.subrogation-excel-target-dialog .variable-cost-target-results {\n  min-height: 0;\n  max-height: min(50vh, 420px);\n  overflow: auto;\n  overscroll-behavior: contain;\n}\n\n.subrogation-excel-claim-type-selector {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1rem;\n  margin: 0 0 0.9rem;\n  padding: 0.7rem 0.8rem;\n  border: 1px solid #dbe7f4;\n  border-radius: 8px;\n  background: #f8fbff;\n}\n\n.subrogation-excel-claim-type-selector legend {\n  width: 100%;\n  margin-bottom: 0.2rem;\n  color: #334e68;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.subrogation-excel-claim-type-selector label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  color: #283e54;\n  font-size: 13px;\n}\n\n.subrogation-evidence-modal-backdrop {\n  position: fixed;\n  z-index: 1210;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(20, 42, 68, 0.48);\n  overscroll-behavior: contain;\n}\n\n.subrogation-evidence-modal {\n  display: flex;\n  flex-direction: column;\n  width: min(900px, 100%);\n  max-height: min(820px, calc(100dvh - 2rem));\n  overflow: hidden;\n  border: 1px solid #cbdceb;\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 18px 48px rgba(19, 46, 76, 0.3);\n}\n\nbody.subrogation-evidence-delete-confirm-open .ant-modal-mask {\n  z-index: 1300 !important;\n}\n\nbody.subrogation-evidence-delete-confirm-open .ant-modal-wrap {\n  z-index: 1301 !important;\n}\n\n.subrogation-evidence-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #dbe3eb;\n  background: #f8fbff;\n}\n\n.subrogation-evidence-modal-header .btn-outline {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.subrogation-evidence-modal-header h3 {\n  margin: 0 0 0.25rem;\n  color: #183f67;\n  font-size: 20px;\n}\n\n.subrogation-evidence-modal-header p {\n  margin: 0;\n  color: #526579;\n  font-size: 13px;\n}\n\n.subrogation-evidence-modal-body {\n  min-height: 0;\n  overflow: auto;\n  padding: 1rem 1.25rem 1.25rem;\n}\n\n.subrogation-evidence-summary,\n.subrogation-evidence-guidance,\n.subrogation-evidence-upload-section {\n  margin-bottom: 1rem;\n  padding: 0.8rem;\n  border: 1px solid #dbe7f4;\n  border-radius: 8px;\n  background: #f8fbff;\n}\n\n.subrogation-evidence-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem 0.75rem;\n  color: #234f7d;\n  font-size: 13px;\n}\n\n.subrogation-evidence-summary span {\n  color: #526579;\n}\n\n.subrogation-evidence-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.75rem 1.25rem;\n  background: var(--primary);\n  color: white;\n}\n\n.subrogation-evidence-section-header h3 {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 0 !important;\n  background: transparent !important;\n  color: inherit !important;\n}\n\n.subrogation-evidence-guidance h4,\n.subrogation-evidence-upload-section h4,\n.subrogation-evidence-section-heading h4,\n.subrogation-current-files-heading h4 {\n  margin: 0 0 0.4rem;\n  color: #334e68;\n  font-size: 14px;\n}\n\n.subrogation-evidence-guidance ul {\n  margin: 0;\n  padding-left: 1.25rem;\n  color: #526579;\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.subrogation-evidence-error {\n  margin: 0 0 1rem !important;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid #f4b4b4;\n  border-radius: 8px;\n  background: #fff5f5;\n  color: #a12828 !important;\n  white-space: pre-line;\n}\n\n.subrogation-evidence-loading,\n.subrogation-evidence-empty,\n.subrogation-evidence-readonly {\n  margin: 0 0 1rem;\n  color: #526579;\n  font-size: 13px;\n}\n\n.subrogation-evidence-file-list-section {\n  margin-bottom: 1rem;\n}\n\n.subrogation-current-files-container {\n  margin: 0;\n  padding: 0 1rem 1rem;\n}\n\n.subrogation-current-files-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.35rem;\n  border-bottom: 1px solid #e0e8f0;\n}\n\n.subrogation-current-files-heading span {\n  color: #526579;\n  font-size: 12px;\n}\n\n.subrogation-current-files-container > .ant-upload-list {\n  margin: 0;\n}\n\n.subrogation-current-files-container > .subrogation-evidence-empty {\n  margin-bottom: 0;\n}\n\n.subrogation-detail-contract-search {\n  display: block !important;\n  margin-bottom: 1rem;\n}\n\n.subrogation-detail-contract-search .subrogation-detail-contract-label {\n  display: block;\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n.subrogation-detail-contract-search .subrogation-detail-contract-input,\n.subrogation-detail-contract-search .subrogation-detail-contract-value {\n  display: block;\n  width: min(520px, 100%);\n  max-width: 100%;\n}\n\n.subrogation-detail-contract-search .subrogation-detail-contract-helper {\n  margin: 8px 0 0;\n}\n\n.subrogation-current-file-download-button {\n  flex: 0 0 auto;\n  padding: 0.3rem 0.55rem;\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n/* Detail-mode evidence rows stay compact while giving the file identity clear priority. */\n.subrogation-detail-file-row {\n  margin-bottom: 0.5rem;\n}\n\n.subrogation-detail-file-row .custom-upload-list.subrogation-detail-file-item {\n  min-height: 48px;\n  gap: 0.75rem;\n  padding: 10px 12px;\n  border: 1px solid #dbe7f4;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.subrogation-detail-file-row .custom-upload-list.subrogation-detail-file-item .ant-upload-list-item-name {\n  flex: 1 1 auto;\n  min-width: 0;\n  color: #234f7d;\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.subrogation-detail-file-row .custom-upload-list.subrogation-detail-file-item .subrogation-detail-file-meta {\n  flex: 0 1 32%;\n  min-width: 0;\n  overflow: hidden;\n  color: #718096;\n  font-size: 11px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.subrogation-detail-file-row .custom-upload-list.subrogation-detail-file-item .ant-upload-list-item-actions {\n  opacity: 1;\n}\n\n.subrogation-detail-file-row .custom-upload-list.subrogation-detail-file-item:focus-within {\n  outline: 2px solid rgba(38, 121, 205, 0.45);\n  outline-offset: 2px;\n}\n\n.subrogation-detail-file-row\n  .custom-upload-list.subrogation-detail-file-item:focus-within\n  .ant-upload-list-item-actions,\n.subrogation-detail-file-row\n  .custom-upload-list.subrogation-detail-file-item\n  .ant-upload-list-item-actions:focus-within {\n  opacity: 1;\n}\n\n.subrogation-evidence-section-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.subrogation-evidence-section-heading span {\n  color: #526579;\n  font-size: 12px;\n}\n\n.subrogation-evidence-file-list {\n  display: grid;\n  gap: 0.5rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.subrogation-evidence-file-list li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid #e0e8f0;\n  border-radius: 8px;\n}\n\n.subrogation-evidence-file-info,\n.subrogation-evidence-file-actions,\n.subrogation-evidence-pending-row {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  gap: 0.45rem;\n}\n\n.subrogation-evidence-file-info {\n  flex: 1 1 auto;\n}\n\n.subrogation-evidence-file-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #234f7d;\n  font-size: 13px;\n}\n\n.subrogation-evidence-file-meta {\n  flex: 0 0 auto;\n  color: #718096;\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.subrogation-evidence-file-actions .btn-small {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  white-space: nowrap;\n}\n\n.btn-danger-outline {\n  border: 1px solid #c97777;\n  border-radius: 6px;\n  color: #9d3434;\n  background: #fff;\n}\n\n.btn-danger-outline:hover:not(:disabled) {\n  background: #fff5f5;\n}\n\n.subrogation-evidence-upload-help {\n  margin: 0 0 0.7rem !important;\n  color: #526579;\n  font-size: 12px;\n}\n\n.subrogation-evidence-select-button,\n.subrogation-evidence-upload-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.subrogation-evidence-pending-list {\n  display: grid;\n  gap: 0.5rem;\n  margin-top: 0.75rem;\n}\n\n.subrogation-evidence-pending-row {\n  padding: 0.5rem 0.65rem;\n  border: 1px solid #e0e8f0;\n  border-radius: 6px;\n}\n\n.subrogation-evidence-pending-row > span {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12px;\n}\n\n.subrogation-evidence-pending-row select {\n  min-width: 190px;\n  max-width: 42%;\n  padding: 0.25rem;\n  border: 1px solid #b9cadb;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.btn-icon-only {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.25rem;\n  border: 0;\n  color: #9d3434;\n  background: transparent;\n}\n\n.subrogation-evidence-progress {\n  position: relative;\n  height: 20px;\n  overflow: hidden;\n  margin-top: 0.5rem;\n  border-radius: 999px;\n  background: #e5edf5;\n  color: #234f7d;\n  font-size: 11px;\n  line-height: 20px;\n  text-align: center;\n}\n\n.subrogation-evidence-progress > div {\n  position: absolute;\n  inset: 0 auto 0 0;\n  background: #8ab9df;\n  transition: width 0.15s ease;\n}\n\n.subrogation-evidence-progress > span {\n  position: relative;\n}\n\n.variable-cost-remove-target {\n  border-color: #c97777;\n  color: #9d3434;\n  background: #fff;\n}\n\n.variable-cost-remove-target:hover:not(:disabled) {\n  border-color: #a94444;\n  background: #fff5f5;\n}\n\n.subrogation-actions-section {\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  flex-wrap: nowrap;\n  margin-bottom: 1rem;\n}\n\n.subrogation-excel-import-result {\n  margin: 0 0 1rem;\n  padding: 0.8rem 1rem;\n  border: 1px solid #b8d8c4;\n  border-radius: 8px;\n  background: #f3fbf5;\n  color: #285c3a;\n  font-size: 13px;\n}\n\n.subrogation-excel-import-result.is-error {\n  border-color: #f0b4b4;\n  background: #fff7f7;\n  color: #8f2f2f;\n}\n\n.subrogation-excel-import-result-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.subrogation-excel-import-result p {\n  margin: 0.35rem 0 0;\n}\n\n.subrogation-excel-import-result-counts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem 1rem;\n  margin-top: 0.45rem;\n  font-weight: 650;\n}\n\n.subrogation-excel-import-result ul {\n  max-height: 8rem;\n  overflow: auto;\n  margin: 0.45rem 0 0;\n  padding-left: 1.25rem;\n}\n\n.subrogation-payment-page .subrogation-search-input {\n  flex: 0 1 360px;\n  height: 42px;\n  min-width: 280px;\n  max-width: 360px;\n  padding: 0 1rem;\n  border-radius: 8px;\n}\n\n.subrogation-action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-left: auto;\n}\n\n.subrogation-payment-page .subrogation-action-buttons .btn-outline,\n.subrogation-payment-page .subrogation-action-buttons .btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 42px;\n  padding: 0 1.25rem;\n  font-size: 14px;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.btn-outline {\n  background: white;\n  color: var(--primary);\n  border: 2px solid var(--primary);\n  padding: 0.7rem 1.5rem;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-outline:hover {\n  background: var(--primary);\n  color: white;\n  box-shadow: 0 4px 12px rgba(43, 108, 176, 0.2);\n}\n\n.btn-outline:disabled {\n  background: #e2e8f0;\n  color: #a0aec0;\n  border-color: #e2e8f0;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.btn-primary {\n  background: var(--primary);\n  color: white;\n  border: none;\n  padding: 0.7rem 1.5rem;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-primary:hover {\n  background: var(--primary-light);\n  box-shadow: 0 4px 12px rgba(43, 108, 176, 0.2);\n}\n\n/* DEADLINE INFO */\n.deadline-info {\n  margin-bottom: 1.5rem;\n}\n\n.deadline-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1rem 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.deadline-text {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.deadline-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.deadline-date {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--primary);\n}\n\n.deadline-countdown {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.deadline-normal {\n  color: #28a745;\n  background: #d4edda;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n}\n\n.deadline-warning {\n  color: #ffc107;\n  background: #fff3cd;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n}\n\n.deadline-urgent {\n  color: #dc3545;\n  background: #f8d7da;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  animation: pulse 1.5s infinite;\n}\n\n.deadline-expired {\n  color: #721c24;\n  background: #f5c6cb;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.7;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n/* STATUS FILTER */\n.status-filter {\n  display: flex;\n  gap: 1.5rem;\n  margin-top: 0.75rem;\n}\n\n.status-filter label {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.status-filter input[type=\"radio\"] {\n  accent-color: var(--primary);\n}\n\n/* MODIFICATION BUTTONS */\n.btn-modify {\n  background: #ff9500;\n  color: white;\n  border: none;\n  padding: 0.4rem 0.8rem;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-modify:hover {\n  background: #e6851f;\n  box-shadow: 0 2px 8px rgba(255, 149, 0, 0.3);\n}\n\n.btn-history {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 0.4rem 0.8rem;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-history:hover {\n  background: #5a6268;\n  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);\n}\n\n.modification-disabled {\n  color: #6c757d;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 0.4rem 0.8rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n}\n\n/* MONTH NAVIGATION */\n.month-navigation {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 0.5rem;\n}\n\n.month-nav-btn {\n  background: var(--primary);\n  color: white;\n  border: none;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 600;\n  transition: all 0.2s;\n}\n\n.month-nav-btn:hover {\n  background: var(--primary-light);\n  box-shadow: 0 2px 8px rgba(43, 108, 176, 0.3);\n}\n\n.month-display {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text);\n  min-width: 8rem;\n  text-align: center;\n}\n\n/* TABLE */\n.table-wrapper {\n  background: white;\n  /* border-radius: 12px; */\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  /* overflow: auto; */\n}\n\n.cost-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1000px;\n}\n\n.cost-table thead {\n  background: var(--primary);\n  color: white;\n}\n\n.cost-table th,\n.cost-table td {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.cost-table th {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.variable-cost-table-wrapper .cost-table thead .table-header-content,\n.subrogation-table-wrapper .cost-table thead .table-header-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.variable-cost-table-wrapper .cost-table thead .table-header-content--sortable,\n.subrogation-table-wrapper .cost-table thead .table-header-content--sortable {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 17.2px auto auto minmax(0, 1fr);\n  align-items: center;\n}\n\n.variable-cost-table-wrapper .cost-table thead .table-header-content--sortable::before,\n.subrogation-table-wrapper .cost-table thead .table-header-content--sortable::before {\n  content: \"\";\n  grid-column: 2;\n  width: 17.2px;\n}\n\n.variable-cost-table-wrapper .cost-table thead .table-header-content--sortable .table-header-label,\n.subrogation-table-wrapper .cost-table thead .table-header-content--sortable .table-header-label {\n  grid-column: 3;\n}\n\n.variable-cost-table-wrapper .cost-table thead .table-header-content--sortable .sort-indicator,\n.subrogation-table-wrapper .cost-table thead .table-header-content--sortable .sort-indicator {\n  grid-column: 4;\n}\n\n.variable-cost-table-wrapper .cost-table thead .table-header-label,\n.subrogation-table-wrapper .cost-table thead .table-header-label {\n  display: inline-block;\n}\n\n.variable-cost-register-page .cost-table thead th.sticky-status-column.sortable-header {\n  position: sticky;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.cost-table tbody tr {\n  transition: background-color 0.15s;\n}\n\n.cost-table tbody tr:hover {\n  background: #f7fafc;\n}\n\n.cost-table tbody tr.approved-row {\n  background: #f0fff4;\n}\n\n.cost-table tbody tr.approved-row:hover {\n  background: #e6fffa;\n}\n\n.subrogation-table-wrapper {\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.subrogation-table-wrapper > .overflow-x-auto {\n  max-width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.subrogation-table-wrapper .cost-table {\n  table-layout: fixed;\n  min-width: calc(998px + 120px + 100px + 120px + var(--subrogation-action-width));\n  --subrogation-action-width: 132px;\n  --subrogation-selection-width: 40px;\n}\n\n.subrogation-table-wrapper .cost-table.has-selectable-rows {\n  min-width: calc(var(--subrogation-selection-width) + 998px + 120px + 100px + 120px + var(--subrogation-action-width));\n}\n\n.subrogation-table-wrapper .cost-table th {\n  text-align: center !important;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-col-selection {\n  width: var(--subrogation-selection-width);\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  text-align: center !important;\n  vertical-align: middle;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-col-selection input[type=\"checkbox\"] {\n  display: block;\n  width: 16px;\n  height: 16px;\n  margin: 0 auto;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-col-product {\n  width: 128px;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-col-claim-type {\n  width: 160px;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-col-building {\n  width: 220px;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-col-room {\n  width: 80px;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-col-borrower {\n  width: 180px;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-col-request-items {\n  width: 230px;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-col-amount {\n  width: 120px;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-col-status {\n  width: 100px;\n}\n\n.subrogation-table-wrapper .cost-table td.subrogation-col-status {\n  text-align: center;\n}\n\n.subrogation-table-wrapper .cost-table td.subrogation-col-status .status-badge {\n  display: block;\n  width: fit-content;\n  margin-inline: auto;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-col-evidence {\n  width: 120px;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-col-actions {\n  width: var(--subrogation-action-width);\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-action-header,\n.subrogation-table-wrapper .cost-table .subrogation-action-cell {\n  text-align: center !important;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-action-cell {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.subrogation-row-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.subrogation-row-actions .btn-small {\n  margin: 0 !important;\n}\n\n.subrogation-action-cell .subrogation-detail-action-button {\n  width: 100%;\n  min-width: 0;\n  padding: 0.45rem 0.5rem;\n  font-size: 12px;\n}\n\n.subrogation-table-wrapper .cost-table td {\n  vertical-align: middle;\n}\n\n.subrogation-cell-text {\n  display: block;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.subrogation-unlinked-contract-note,\n.subrogation-action-guidance {\n  display: block;\n  margin-top: 0.25rem;\n  color: #976113;\n  font-size: 11px;\n  line-height: 1.35;\n  white-space: normal;\n}\n\n.subrogation-evidence-state {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n  white-space: nowrap;\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.subrogation-evidence-state-missing {\n  color: #a14d0c;\n}\n\n.subrogation-evidence-state-ready {\n  color: #1f7a4d;\n}\n\n.subrogation-evidence-state-not_required,\n.subrogation-evidence-state-unknown {\n  color: #526579;\n}\n\n.subrogation-evidence-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 100%;\n  padding: 0.25rem 0.35rem;\n  border: 1px solid transparent;\n  border-radius: 5px;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n\n.subrogation-evidence-trigger:hover {\n  background: #f1f5f9;\n}\n\n.subrogation-evidence-trigger:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n.subrogation-table-wrapper .cost-table .subrogation-sticky-action-column {\n  position: sticky;\n  right: 0;\n  background: #fff;\n  border-left: 1px solid #cbd5e1;\n  z-index: 6;\n}\n\n.subrogation-table-wrapper .cost-table thead .subrogation-sticky-action-column {\n  z-index: 7;\n  background: var(--primary);\n}\n\n.subrogation-table-wrapper .cost-table tbody tr:hover .subrogation-sticky-action-column {\n  background: #f7fafc;\n}\n\n/* ===== VARIABLE COST TABLE - STICKY COLUMNS ===== */\n/* Fix operation and status columns to the right side */\n.sticky-action-column {\n  position: sticky;\n  right: 0;\n  /* Increased width to prevent overlap */\n  background: white;\n  z-index: 2;\n  /* border-left: 1px solid #e2e8f0; */\n  width: 135px;\n  min-width: 135px;\n  max-width: 135px;\n}\n\n.sticky-status-column {\n  position: sticky;\n  right: 134px;\n  background: white;\n  z-index: 1;\n  /* border-left: 1px solid #e2e8f0; */\n  min-width: 80px;\n}\n\n/* Header background for sticky columns */\n.cost-table thead .sticky-action-column,\n.cost-table thead .sticky-status-column {\n  background: var(--primary);\n}\n\n/* Hover effects for sticky columns */\n.cost-table tbody tr:hover .sticky-action-column,\n.cost-table tbody tr:hover .sticky-status-column {\n  background: #f7fafc;\n}\n\n.cost-table tbody tr.approved-row .sticky-action-column,\n.cost-table tbody tr.approved-row .sticky-status-column {\n  background: #f0fff4;\n}\n\n.cost-table tbody tr.approved-row:hover .sticky-action-column,\n.cost-table tbody tr.approved-row:hover .sticky-status-column {\n  background: #e6fffa;\n}\n\n.variable-cost-table-wrapper {\n  overflow: hidden;\n}\n\n.variable-cost-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.variable-cost-register-page .cost-table {\n  table-layout: fixed;\n  min-width: 4090px;\n}\n\n.variable-cost-register-page .sticky-left-column {\n  position: sticky;\n  background: white;\n  z-index: 3;\n}\n\n.variable-cost-register-page .sticky-select-column {\n  left: 0;\n  width: 52px;\n  min-width: 52px;\n  max-width: 52px;\n}\n\n.variable-cost-register-page .sticky-building-column {\n  left: 52px;\n  width: 180px;\n  min-width: 180px;\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.variable-cost-register-page .sticky-room-column {\n  left: 232px;\n  width: 72px;\n  min-width: 72px;\n  max-width: 72px;\n  box-shadow: 1px 0 0 #e2e8f0;\n}\n\n.variable-cost-register-page .cost-table th:nth-child(4),\n.variable-cost-register-page .cost-table td:nth-child(4) {\n  width: 94px;\n}\n\n.variable-cost-register-page .cost-table th:nth-child(5),\n.variable-cost-register-page .cost-table td:nth-child(5),\n.variable-cost-register-page .cost-table th:nth-child(30),\n.variable-cost-register-page .cost-table td:nth-child(30) {\n  width: 74px;\n}\n\n.variable-cost-register-page .cost-table th:nth-child(6),\n.variable-cost-register-page .cost-table td:nth-child(6),\n.variable-cost-register-page .cost-table th:nth-child(7),\n.variable-cost-register-page .cost-table td:nth-child(7),\n.variable-cost-register-page .cost-table th:nth-child(8),\n.variable-cost-register-page .cost-table td:nth-child(8) {\n  width: 112px;\n}\n\n.variable-cost-register-page .cost-table th:nth-child(9),\n.variable-cost-register-page .cost-table td:nth-child(9) {\n  width: 168px;\n}\n\n.variable-cost-register-page .cost-table th:nth-child(2n + 10):nth-child(-n + 28),\n.variable-cost-register-page .cost-table td:nth-child(2n + 10):nth-child(-n + 28) {\n  width: 132px;\n}\n\n.variable-cost-register-page .cost-table th:nth-child(2n + 11):nth-child(-n + 29),\n.variable-cost-register-page .cost-table td:nth-child(2n + 11):nth-child(-n + 29) {\n  width: 150px;\n}\n\n.variable-cost-register-page .cost-table th:nth-child(31),\n.variable-cost-register-page .cost-table td:nth-child(31) {\n  width: 80px;\n}\n\n.variable-cost-register-page .cost-table thead .sticky-left-column {\n  background: var(--primary);\n  z-index: 5;\n}\n\n.variable-cost-register-page .cost-table tbody tr:hover .sticky-left-column {\n  background: #f7fafc;\n}\n\n.variable-cost-register-page .cost-table tbody tr.approved-row .sticky-left-column {\n  background: #f0fff4;\n}\n\n.variable-cost-register-page .cost-table tbody tr.approved-row:hover .sticky-left-column {\n  background: #e6fffa;\n}\n\n.variable-cost-rejection-status-trigger {\n  position: relative;\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  color: inherit;\n  background: transparent;\n  border: 0;\n  font: inherit;\n  cursor: pointer;\n}\n\n.variable-cost-rejection-status-trigger:focus-visible {\n  outline: 2px solid #f59e0b;\n  outline-offset: 3px;\n  border-radius: 9999px;\n}\n\n.variable-cost-rejection-status-icon {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  color: white;\n  background: #facc15;\n  border-radius: 50%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.variable-cost-rejection-tooltip {\n  max-width: min(420px, calc(100vw - 24px)) !important;\n}\n\n.variable-cost-rejection-tooltip .ant-tooltip-inner {\n  max-height: 12rem;\n  overflow-y: auto;\n  color: #333;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.16);\n}\n\n.variable-cost-rejection-tooltip-title {\n  margin-bottom: 0.25rem;\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.variable-cost-rejection-tooltip-reason {\n  color: #4b5563;\n  font-size: 12px;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n}\n\n.variable-cost-rejection-tooltip-reason.is-missing {\n  color: #9b2c2c;\n  font-style: italic;\n}\n\n.variable-cost-rejection-tooltip-guidance {\n  margin-top: 0.5rem;\n  padding-top: 0.5rem;\n  color: #9b2c2c;\n  border-top: 1px solid #fee2e2;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* READONLY CELLS */\n.readonly-cell {\n  color: #9ca3af;\n  font-style: italic;\n}\n\n/* INPUT FIELDS */\n.cost-input {\n  width: 100%;\n  padding: 0.4rem 0.6rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 13px;\n  text-align: right;\n  background: white;\n  transition: border-color 0.2s;\n}\n\n.cost-input:focus {\n  outline: none;\n  border-color: var(--primary);\n}\n\n.cost-input:disabled {\n  background: #f7fafc;\n  color: #718096;\n  cursor: not-allowed;\n}\n\n/* BUTTONS */\n.btn-submit {\n  background: var(--primary);\n  color: white;\n  border: none;\n  padding: 0.4rem 1rem;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-submit:hover {\n  background: var(--primary-light);\n  box-shadow: 0 2px 8px rgba(43, 108, 176, 0.2);\n}\n\n.submitted-text {\n  color: #38a169;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* STATUS BADGES */\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-default {\n  background-color: #f3f4f6;\n  color: #6b7280;\n}\n\n.status-pending {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #fecba1;\n}\n\n.status-reviewing {\n  background-color: #cce5ff;\n  color: #0056b3;\n  border: 1px solid #a6d4ff;\n}\n\n.status-warning {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #fecba1;\n}\n\n.status-processing {\n  background-color: #a8f1cb;\n  color: #048844;\n  border: 1px solid #58dc97;\n}\n\n.status-approved {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #a3d9a4;\n}\n\n.status-rejected {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f1aeb5;\n}\n\n.status-cancelled {\n  background-color: #4b5563;\n  color: #ffffff;\n}\n\n/* --- CONTRACTS LIST PAGE -------------------------------------------- */\n.contracts-list-page {\n  width: 100%;\n  max-width: 1400px;\n}\n\n.contracts-list-page h2 {\n  font-size: 28px;\n  font-weight: 600;\n  margin-bottom: 2rem;\n}\n\n.contracts-confirmation-page {\n  width: min(1260px, calc(100vw - 4rem));\n  max-width: none;\n  margin-left: 50%;\n  transform: translateX(-50%);\n}\n\n.contracts-confirmation-page .filters-section {\n  display: flex;\n  align-items: flex-end;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 24px;\n}\n\n.contracts-confirmation-page .contracts-filter-control {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.contracts-confirmation-page .contracts-filter-keyword {\n  flex: 1 1 320px;\n  max-width: 400px;\n}\n\n.contracts-confirmation-page .contracts-filter-label {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.contracts-confirmation-page .search-input {\n  width: 100%;\n}\n\n.contract-display-status-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 72px;\n  padding: 0.22rem 0.55rem;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.3;\n  white-space: nowrap;\n}\n\n.contract-display-status-signed {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n  color: #047857;\n}\n\n.contract-display-status-cancel-requested {\n  background: #fffbeb;\n  border-color: #fde68a;\n  color: #92400e;\n}\n\n.contract-display-status-canceled {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #475569;\n}\n\n.contract-status-cell {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.contract-guara-update-confirm-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 82px;\n  padding: 0.2rem 0.5rem;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.25;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.contract-guara-update-confirm-pending {\n  background: #fff7ed;\n  border-color: #fed7aa;\n  color: #c2410c;\n}\n\n.contract-guara-update-confirm-update {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1d4ed8;\n}\n\n.contract-guara-update-confirm-end {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  color: #475569;\n}\n\n.contracts-confirmation-page .contract-display-status-tooltip-trigger {\n  position: relative;\n  display: inline-flex;\n  cursor: help;\n}\n\n.contracts-confirmation-page .contract-action-buttons {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  width: 112px;\n  margin: 0 auto;\n}\n\n.contracts-confirmation-page .contract-action-button {\n  width: 112px;\n  min-height: 30px;\n  padding: 0.35rem 0.5rem;\n  border-radius: 6px;\n  font-size: 12px;\n  line-height: 1.2;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.contracts-confirmation-page .contracts-table th:last-child,\n.contracts-confirmation-page .contracts-table td:last-child {\n  width: 128px;\n  min-width: 128px;\n  max-width: 128px;\n  padding-right: 8px;\n  padding-left: 8px;\n  text-align: center;\n}\n\n@media (max-width: 1400px) {\n  .contracts-confirmation-page {\n    width: 100%;\n    margin-left: 0;\n    transform: none;\n  }\n}\n\n/* --- NOTICE LIST PAGE -------------------------------------------- */\n.notice-list-page {\n  width: 100%;\n  max-width: 1400px;\n}\n\n.notice-list-page h2 {\n  font-size: 28px;\n  font-weight: 600;\n  color: var(--primary);\n  margin-bottom: 2rem;\n}\n\n.status-select {\n  padding: 0.65rem 0.9rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  background: white;\n  min-width: 150px;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.status-select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(43, 108, 176, 0.1);\n}\n\n.contracts-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1100px;\n}\n\n.contracts-confirmation-page .contracts-table {\n  table-layout: fixed;\n  min-width: 1212px;\n}\n\n.contracts-table thead {\n  background: var(--primary);\n  color: white;\n}\n\n.contracts-table th,\n.contracts-table td {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.contracts-confirmation-page .contracts-table th,\n.contracts-confirmation-page .contracts-table td {\n  padding: 0.65rem 0.6rem;\n  vertical-align: middle;\n  white-space: normal;\n}\n\n.contracts-confirmation-page .contracts-table th:nth-child(1),\n.contracts-confirmation-page .contracts-table td:nth-child(1) {\n  width: 150px;\n}\n\n.contracts-confirmation-page .contracts-table th:nth-child(2),\n.contracts-confirmation-page .contracts-table td:nth-child(2) {\n  width: 72px;\n  white-space: nowrap;\n}\n\n.contracts-confirmation-page .contracts-table th:nth-child(3),\n.contracts-confirmation-page .contracts-table td:nth-child(3) {\n  width: 130px;\n}\n\n.contracts-confirmation-page .contracts-table th:nth-child(4),\n.contracts-confirmation-page .contracts-table td:nth-child(4) {\n  width: 190px;\n}\n\n.contracts-confirmation-page .contracts-table th:nth-child(5),\n.contracts-confirmation-page .contracts-table td:nth-child(5) {\n  width: 100px;\n  white-space: nowrap;\n}\n\n.contracts-confirmation-page .contracts-table th:nth-child(6),\n.contracts-confirmation-page .contracts-table td:nth-child(6) {\n  width: 110px;\n  white-space: nowrap;\n}\n\n.contracts-confirmation-page .contracts-table th:nth-child(7),\n.contracts-confirmation-page .contracts-table td:nth-child(7) {\n  width: 110px;\n  white-space: nowrap;\n}\n\n.contracts-confirmation-page .contracts-table th:nth-child(8),\n.contracts-confirmation-page .contracts-table td:nth-child(8) {\n  width: 100px;\n  white-space: nowrap;\n}\n\n.contracts-confirmation-page .contracts-table th:nth-child(9),\n.contracts-confirmation-page .contracts-table td:nth-child(9) {\n  width: 112px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.contracts-confirmation-page .contracts-table th:nth-child(10),\n.contracts-confirmation-page .contracts-table td:nth-child(10) {\n  width: 110px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.contracts-table th {\n  font-weight: 600;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.contracts-confirmation-page .contracts-table th {\n  text-align: center;\n  white-space: nowrap;\n}\n\n.contracts-table tbody tr {\n  transition: background-color 0.15s;\n}\n\n.contracts-confirmation-page .contracts-table tbody tr:nth-child(even):not(.delay-row) {\n  background: #f3f4f6;\n}\n\n.contracts-table tbody tr:hover {\n  background: #f7fafc;\n}\n\n.contracts-table tbody tr.cancelled-row {\n  background: #fff5f5;\n  opacity: 0.8;\n}\n\n.contracts-table tbody tr.cancelled-row:hover {\n  background: #fed7d7;\n}\n\n.guara-update-confirm-page {\n  width: min(1260px, calc(100vw - 4rem));\n  max-width: none;\n  margin-left: 50%;\n  transform: translateX(-50%);\n}\n\n.guara-update-confirm-filters {\n  display: flex;\n  align-items: flex-end;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 18px;\n}\n\n.guara-update-confirm-search-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.guara-update-confirm-table-wrapper {\n  overflow-x: auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.guara-update-confirm-table {\n  width: 100%;\n  min-width: 1160px;\n  border-collapse: collapse;\n}\n\n.guara-update-confirm-table thead {\n  background: var(--primary);\n  color: #fff;\n}\n\n.guara-update-confirm-table th,\n.guara-update-confirm-table td {\n  padding: 0.65rem 0.6rem;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.guara-update-confirm-table th {\n  text-align: center;\n  white-space: nowrap;\n}\n\n.guara-update-confirm-table tbody tr:nth-child(even) {\n  background: #f8fafc;\n}\n\n.guara-update-confirm-table tbody tr:hover {\n  background: #f7fafc;\n}\n\n.guara-update-confirm-subtext {\n  margin-top: 0.2rem;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.guara-update-confirm-renewal-badge,\n.guara-update-confirm-status-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 80px;\n  padding: 0.22rem 0.55rem;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.3;\n  white-space: nowrap;\n}\n\n.guara-update-confirm-renewal-own {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1d4ed8;\n}\n\n.guara-update-confirm-renewal-other {\n  background: #f5f3ff;\n  border-color: #ddd6fe;\n  color: #6d28d9;\n}\n\n.guara-update-confirm-status-pending {\n  background: #fff7ed;\n  border-color: #fed7aa;\n  color: #c2410c;\n}\n\n.guara-update-confirm-status-update {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n  color: #047857;\n}\n\n.guara-update-confirm-status-end {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #475569;\n}\n\n.guara-update-confirm-row-actions {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  min-width: 132px;\n}\n\n.guara-update-confirm-action-button {\n  width: 42px;\n  min-width: 42px;\n  height: 28px;\n  min-height: 28px;\n  padding: 0;\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.guara-update-confirm-modal-content p {\n  margin: 0 0 0.35rem;\n}\n\n@media (max-width: 1400px) {\n  .guara-update-confirm-page {\n    width: 100%;\n    margin-left: 0;\n    transform: none;\n  }\n}\n\n.notice-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1100px;\n}\n\n.notice-table thead {\n  background: var(--primary);\n  color: white;\n}\n\n.notice-table th,\n.notice-table td {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.notice-table th {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.notice-table tbody tr {\n  transition: background-color 0.15s;\n}\n\n.notice-table tbody tr:hover {\n  background: #f7fafc;\n}\n\n.notice-table tbody tr.unread-row {\n  background: #fff7ed;\n}\n\n.notice-table tbody tr.unread-row:hover {\n  background: #ffedd5;\n}\n\n.contract-no {\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.building-name {\n  font-weight: 500;\n  color: var(--text);\n}\n\n.tenant-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.tenant-name {\n  font-weight: 500;\n  color: var(--text);\n}\n\n.tenant-kana {\n  font-size: 11px;\n  color: #718096;\n}\n\n.plan-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.plan-name {\n  font-weight: 500;\n  color: var(--text);\n}\n\n.plan-alias {\n  font-size: 11px;\n  color: #718096;\n  background: #e2e8f0;\n  padding: 0.1rem 0.4rem;\n  border-radius: 4px;\n  display: inline-block;\n  width: fit-content;\n}\n\n.btn-detail {\n  background: var(--primary);\n  color: white;\n  border: none;\n  padding: 0.4rem 1rem;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-detail:hover {\n  background: var(--primary-light);\n  box-shadow: 0 2px 8px rgba(43, 108, 176, 0.2);\n}\n\n/* CONTRACT STATUS BADGES */\n.contract-status-1 {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.contract-status-2 {\n  background: #cce5ff;\n  color: #0056b3;\n}\n\n.contract-status-3 {\n  background: #ffe5cc;\n  color: #cc6600;\n}\n\n.contract-status-4 {\n  background: #ffcccc;\n  color: #cc0000;\n}\n\n.contract-status-5 {\n  background: #d4edda;\n  color: #155724;\n}\n\n.contract-status-6.cancelled {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.no-results {\n  text-align: center;\n  padding: 2rem;\n  color: #718096;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  margin-top: 1rem;\n}\n\n/* --- PAYMENT STATUS PAGE -------------------------------------------- */\n.payment-status-page {\n  width: 100%;\n  max-width: 1400px;\n}\n\n.payment-status-page h2 {\n  font-size: 28px;\n  font-weight: 600;\n  color: var(--primary);\n  margin-bottom: 2rem;\n}\n\n/* --- CONTRACT DETAIL PAGE ------------------------------------------- */\n.contract-detail-page {\n  width: 100%;\n  max-width: 1200px;\n}\n\n.contract-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.contract-header-main h2 {\n  font-size: 28px;\n  font-weight: 600;\n  color: var(--primary);\n  margin-bottom: 0.5rem;\n}\n\n.contract-id-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.contract-id-info .contract-no {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.btn-back {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 0.6rem 1.2rem;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-back:hover {\n  background: #5a6268;\n  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);\n}\n\n.contract-detail-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.detail-section-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n}\n\n.detail-section {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.detail-section.full-width {\n  grid-column: 1 / -1;\n}\n\n.detail-section h3 {\n  background: var(--primary);\n  color: white;\n  padding: 1rem 1.5rem;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.detail-card {\n  padding: 1.5rem;\n}\n\n.detail-item {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 1rem;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #f7fafc;\n}\n\n.detail-item:last-child {\n  border-bottom: none;\n}\n\n.detail-item label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #4a5568;\n}\n\n.detail-item span {\n  font-size: 14px;\n  color: var(--text);\n}\n\n.detail-item .building-name {\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.detail-item .tenant-name {\n  font-weight: 600;\n}\n\n.detail-item .tenant-kana {\n  color: #718096;\n}\n\n.detail-item .amount {\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.plan-badge {\n  background: var(--primary);\n  color: white;\n  padding: 0.25rem 0.75rem;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  display: inline-block;\n}\n\n/* STATUS TIMELINE */\n.status-timeline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 0;\n}\n\n.status-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  position: relative;\n}\n\n.status-indicator {\n  margin-bottom: 0.5rem;\n}\n\n.status-dot {\n  display: block;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 3px solid #e2e8f0;\n  background: white;\n  transition: all 0.3s;\n}\n\n.status-dot.completed {\n  background: #38a169;\n  border-color: #38a169;\n}\n\n.status-dot.current {\n  background: #3182ce;\n  border-color: #3182ce;\n  animation: pulse-status 2s infinite;\n}\n\n.status-dot.cancelled {\n  background: #e53e3e;\n  border-color: #e53e3e;\n}\n\n.status-dot.pending {\n  background: #f7fafc;\n  border-color: #e2e8f0;\n}\n\n.status-content {\n  text-align: center;\n}\n\n.status-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text);\n  margin-bottom: 0.25rem;\n}\n\n.status-date {\n  font-size: 12px;\n  color: #718096;\n}\n\n.status-description {\n  font-size: 12px;\n  color: #718096;\n}\n\n.status-connector {\n  flex: 1;\n  height: 2px;\n  background: #e2e8f0;\n  margin: 0 1rem;\n  margin-top: -10px;\n}\n\n@keyframes pulse-status {\n  0% {\n    box-shadow: 0 0 0 0 rgba(49, 130, 206, 0.7);\n  }\n\n  70% {\n    box-shadow: 0 0 0 10px rgba(49, 130, 206, 0);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(49, 130, 206, 0);\n  }\n}\n\n/* VARIABLE COST HISTORY */\n.variable-cost-history {\n  overflow-x: auto;\n}\n\n.history-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 700px;\n}\n\n.history-table thead {\n  background: #f7fafc;\n}\n\n.history-table th,\n.history-table td {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.history-table th {\n  font-weight: 600;\n  font-size: 14px;\n  color: #4a5568;\n}\n\n.history-table tbody tr {\n  transition: background-color 0.15s;\n}\n\n.history-table tbody tr:hover {\n  background: #f7fafc;\n}\n\n.history-table tbody tr.history-approved {\n  background: rgba(72, 187, 120, 0.05);\n}\n\n.history-table tbody tr.history-pending {\n  background: rgba(237, 137, 54, 0.05);\n}\n\n.history-month {\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.history-total {\n  font-weight: 700;\n  color: var(--primary);\n  border-left: 2px solid var(--primary);\n  background: rgba(43, 108, 176, 0.05);\n}\n\n/* SORTABLE TABLE HEADERS */\n.sortable-header {\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  transition: background-color 0.2s;\n}\n\n.sortable-header:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.sort-indicator {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  margin-left: 4px;\n  min-width: 1.1em;\n  font-size: 12px;\n  color: currentColor;\n  transition: color 0.2s;\n  vertical-align: middle;\n  width: 1.1em;\n}\n\n.sortable-header.sort-asc .sort-indicator::after {\n  content: \"▲\";\n  color: white;\n}\n\n.sortable-header.sort-desc .sort-indicator::after {\n  content: \"▼\";\n  color: white;\n}\n\n/* --- PAYMENT STATUS TABLE ------------------------------------------- */\n.payment-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n}\n\n.payment-table th,\n.payment-table td {\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.payment-table th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #4a5568;\n}\n\n.payment-row.payment-overdue {\n  background: #fef5e7;\n}\n\n.payment-row.payment-completed {\n  background: #f0fff4;\n}\n\n.payment-status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.payment-status-badge.overdue {\n  background: #fed7d7;\n  color: #c53030;\n}\n\n.payment-status-badge.completed {\n  background: #c6f6d5;\n  color: #2f855a;\n}\n\n/* --- APPLICATION CREATE PAGE ---------------------------------------- */\n.application-create-page {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.application-create-page h2 {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.application-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.form-section {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.form-section h3 {\n  background: var(--primary);\n  color: white;\n  padding: 0.75rem 1.25rem;\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.form-card {\n  padding: 1rem;\n}\n\n.form-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  margin-bottom: 0.75rem;\n}\n\n.form-row:last-child {\n  margin-bottom: 0;\n}\n\n.form-row-group {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.postcode-row {\n  display: flex;\n  gap: 0.5rem;\n  align-items: end;\n}\n\n.postcode-input {\n  width: 150px;\n  flex-shrink: 0;\n}\n\n.address-lookup-btn {\n  background: var(--primary);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n  height: fit-content;\n}\n\n.address-lookup-btn:hover {\n  background: var(--primary-light);\n  box-shadow: 0 2px 8px rgba(43, 108, 176, 0.2);\n}\n\n.address-lookup-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n.form-row label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #4a5568;\n}\n\n.required {\n  color: #e53e3e;\n  font-weight: 700;\n}\n\n.form-input {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px rgba(43, 108, 176, 0.1);\n}\n\n/* Styling for browser's default date input calendar icon */\n.form-input[type=\"date\"]::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n  opacity: 0.7;\n}\n\n.form-input[type=\"date\"]::-webkit-calendar-picker-indicator:hover {\n  opacity: 1;\n}\n\n.form-select {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.form-select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px rgba(43, 108, 176, 0.1);\n}\n\n.form-display {\n  font-size: 14px;\n  color: var(--text);\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #f7fafc;\n}\n\n.form-display.amount {\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.selected-product {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: #f7fafc;\n  border-radius: 8px;\n  margin-top: 0.5rem;\n}\n\n.product-badge {\n  background: var(--primary);\n  color: white;\n  padding: 0.25rem 0.75rem;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.selected-product p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text);\n}\n\n.subsection-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--primary);\n  margin: 1rem 0 0.75rem 0;\n  padding-bottom: 0.25rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.cost-section-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 16px;\n  margin: 1rem 0 0.75rem 0;\n  padding-bottom: 0.25rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.cost-section-header__title {\n  margin: 0;\n  padding-bottom: 0;\n  border-bottom: 0;\n  line-height: 1.25;\n  flex-shrink: 0;\n}\n\n.cost-section-header__note {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #111827;\n  text-align: right;\n}\n\n.plan-description {\n  margin: 0.5rem 0 0 0 !important;\n  font-size: 12px;\n  color: #718096;\n  font-weight: 500;\n}\n\n/* COST BREAKDOWN */\n.cost-breakdown {\n  margin: 0.75rem 0;\n}\n\n.cost-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.375rem 0;\n  border-bottom: 1px solid #f7fafc;\n}\n\n.cost-item:last-child {\n  border-bottom: none;\n}\n\n.cost-item.cost-total {\n  border-top: 2px solid var(--primary);\n  padding-top: 0.75rem;\n  margin-top: 0.375rem;\n  font-weight: 600;\n}\n\n.cost-label {\n  font-size: 14px;\n  color: #4a5568;\n}\n\n.cost-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.cost-total .cost-label,\n.cost-total .cost-value {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n/* RESIDENTS */\n.residents-header {\n  margin-bottom: 0.75rem;\n}\n\n.no-residents {\n  color: #718096;\n  font-style: italic;\n  text-align: center;\n  padding: 1.5rem;\n  background: #f7fafc;\n  border-radius: 8px;\n}\n\n.resident-item {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 0.75rem;\n  margin-bottom: 0.75rem;\n  background: #fafbfc;\n}\n\n.resident-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 0.375rem;\n}\n\n.resident-header h5 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.btn-remove {\n  background: #e53e3e;\n  color: white;\n  border: none;\n  padding: 0.25rem 0.75rem;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-remove:hover {\n  background: #c53030;\n  box-shadow: 0 2px 8px rgba(229, 62, 62, 0.3);\n}\n\n/* OPTION GROUPS */\n.option-group {\n  margin-bottom: 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.option-group:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.option-group label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.option-group input[type=\"checkbox\"] {\n  accent-color: var(--primary);\n}\n\n/* AGREEMENT SECTION */\n.agreement-section .form-row label {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.agreement-section input[type=\"checkbox\"] {\n  accent-color: var(--primary);\n  margin-top: 0.2rem;\n}\n\n.agreement-section small {\n  font-size: 12px;\n  color: #718096;\n  margin-top: 0.25rem;\n  display: block;\n}\n\n/* FILE UPLOAD */\n.form-row small {\n  font-size: 12px;\n  color: #718096;\n  margin-top: 0.25rem;\n  display: block;\n}\n\n.file-upload-area {\n  border: 2px dashed #e2e8f0;\n  border-radius: 8px;\n  padding: 1.5rem;\n  text-align: center;\n  background: #f7fafc;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  position: relative;\n}\n\n.file-upload-area:hover {\n  border-color: var(--primary);\n  background: #ebf8ff;\n}\n\n.file-upload-area.drag-active {\n  border-color: var(--primary);\n  background: #ebf8ff;\n  border-style: solid;\n}\n\n.file-upload-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.file-upload-icon {\n  font-size: 2rem;\n  color: #a0aec0;\n}\n\n.file-upload-text {\n  font-size: 14px;\n  color: #4a5568;\n  font-weight: 500;\n}\n\n.file-upload-hint {\n  font-size: 12px;\n  color: #718096;\n}\n\n.file-upload-input {\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.uploaded-file {\n  margin-top: 0.5rem;\n  padding: 0.5rem;\n  background: #e6fffa;\n  border: 1px solid #4fd1c7;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #234e52;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 0;\n  border-top: 2px solid #e2e8f0;\n  margin-top: 0.75rem;\n}\n\n.btn-submit-application {\n  background: var(--primary);\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-submit-application:hover {\n  background: var(--primary-light);\n  box-shadow: 0 4px 12px rgba(43, 108, 176, 0.2);\n  transform: translateY(-2px);\n}\n\n/* --- APPLICATION REVIEW STATUS PAGE -------------------------------- */\n.application-review-page {\n  width: min(1480px, calc(100vw - 3rem));\n  max-width: none;\n  margin-left: 50%;\n  transform: translateX(-50%);\n}\n\n.application-review-page h2 {\n  font-size: 28px;\n  font-weight: 600;\n  margin-bottom: 2rem;\n}\n\n/* REVIEW FILTERS */\n.review-filters-section {\n  margin-bottom: 1.5rem;\n}\n\n.review-filter-group {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.review-search-input,\n.status-filter-select {\n  padding: 0.65rem 0.9rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  background: white;\n  min-width: 200px;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.review-search-input:focus,\n.status-filter-select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(43, 108, 176, 0.1);\n}\n\n.review-search-input::placeholder {\n  color: #a0aec0;\n}\n\n/* REVIEW TABLE */\n.table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.review-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  min-width: 1476px;\n}\n\n.review-table thead {\n  background: var(--primary);\n  color: white;\n}\n\n.review-table th,\n.review-table td {\n  padding: 0.65rem 0.6rem;\n  text-align: left;\n  vertical-align: middle;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 13px;\n}\n\n/* 列幅の最適化 */\n.review-table th:nth-child(1),\n.review-table td:nth-child(1) {\n  width: 110px;\n  white-space: nowrap;\n}\n\n.review-table th:nth-child(2),\n.review-table td:nth-child(2) {\n  width: 138px;\n}\n\n.review-table th:nth-child(3),\n.review-table td:nth-child(3) {\n  width: 180px;\n}\n\n.review-table th:nth-child(4),\n.review-table td:nth-child(4) {\n  width: 78px;\n  white-space: nowrap;\n}\n\n.review-table th:nth-child(5),\n.review-table td:nth-child(5) {\n  width: 150px;\n}\n\n.review-table th:nth-child(6),\n.review-table td:nth-child(6) {\n  width: 110px;\n  white-space: nowrap;\n}\n\n.review-table th:nth-child(7),\n.review-table td:nth-child(7) {\n  width: 560px;\n  min-width: 0;\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n\n.review-table th:nth-child(8),\n.review-table td:nth-child(8) {\n  width: 150px;\n  text-align: center;\n}\n\n.review-table td:nth-child(8) {\n  padding-left: 0.55rem;\n  padding-right: 0.55rem;\n}\n\n.review-table .review-table-action-column {\n  position: sticky;\n  right: 0;\n  width: 150px;\n  min-width: 150px;\n  max-width: 150px;\n  background: #ffffff;\n  box-shadow: -8px 0 12px -8px rgba(15, 23, 42, 0.55);\n  border-left: 1px solid #cbd5e1;\n  /* Keep horizontally scrolling flow content underneath the fixed action layer. */\n  z-index: 20;\n}\n\n.review-table thead .review-table-action-column {\n  background: var(--primary);\n  color: #ffffff;\n  z-index: 30;\n}\n\n.review-table tbody tr:nth-child(even) .review-table-action-column {\n  background: #f3f4f6;\n}\n\n.review-table tbody tr:nth-child(odd) .review-table-action-column {\n  background: #ffffff;\n}\n\n.review-table tbody tr:hover .review-table-action-column {\n  background: #f7fafc;\n}\n\n.review-table th {\n  font-weight: 600;\n  font-size: 14px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.review-table tbody tr {\n  transition: background-color 0.15s;\n  cursor: pointer;\n}\n\n.review-table tbody tr:hover {\n  background: #f7fafc;\n}\n\n.review-applicant-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.review-applicant-name {\n  font-weight: 500;\n  color: var(--text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.review-contract-no {\n  white-space: nowrap;\n}\n\n.review-applicant-kana {\n  font-size: 11px;\n  color: #718096;\n}\n\n.review-property-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.review-building-name {\n  font-weight: 500;\n  color: var(--text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.review-room-address {\n  font-size: 11px;\n  color: #718096;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.review-product-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (max-width: 768px) {\n  .application-review-page {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .application-review-page .table-wrapper {\n    overflow-x: auto;\n  }\n\n  .review-table {\n    min-width: 500px;\n    width: 100%;\n    table-layout: fixed;\n  }\n\n  .review-table th:nth-child(n + 3),\n  .review-table td:nth-child(n + 3) {\n    display: none;\n  }\n\n  .review-table th:nth-child(7),\n  .review-table td:nth-child(7) {\n    display: table-cell;\n    width: 148px;\n  }\n\n  .review-table th:nth-child(8),\n  .review-table td:nth-child(8) {\n    display: table-cell;\n    width: 150px;\n    min-width: 150px;\n    max-width: 150px;\n  }\n\n  .review-table th:nth-child(1),\n  .review-table td:nth-child(1) {\n    width: 96px;\n  }\n\n  .review-table th:nth-child(2),\n  .review-table td:nth-child(2) {\n    width: auto;\n  }\n\n  .review-table th,\n  .review-table td {\n    min-width: 0;\n    overflow-wrap: anywhere;\n  }\n\n  .review-table th {\n    white-space: normal;\n  }\n\n  .review-flow-diagram {\n    grid-template-columns: minmax(0, 1fr) !important;\n    grid-template-rows: 1fr !important;\n  }\n\n  .review-flow-diagram > .review-flow-step-wrapper:not([data-active=\"true\"]),\n  .review-flow-diagram > .review-flow-connector {\n    display: none;\n  }\n\n  .review-flow-diagram > .review-flow-step-wrapper[data-active=\"true\"] {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .review-flow-diagram .review-flow-step-wrapper[data-active=\"true\"] .review-flow-step {\n    width: 100%;\n    max-width: 100%;\n    white-space: normal;\n  }\n}\n\n.review-action-buttons {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.review-action-button {\n  width: 100%;\n  min-width: 112px;\n  max-width: 128px;\n  line-height: 1.25;\n  white-space: normal;\n  word-break: keep-all;\n}\n\n.review-action-button-multiline {\n  min-height: 48px;\n}\n\n@media (max-width: 1400px) {\n  .application-review-page {\n    width: 100%;\n    margin-left: 0;\n    transform: none;\n  }\n}\n\n/* REVIEW STATUS BADGES */\n.review-status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.6rem;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.review-status-submitted {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.review-status-document-review {\n  background: #cce5ff;\n  color: #0056b3;\n}\n\n.review-status-credit-check {\n  background: #e5ccff;\n  color: #6b46c1;\n}\n\n.review-status-income-verification {\n  background: #ffcccc;\n  color: #cc0000;\n}\n\n.review-status-guarantor-review {\n  background: #ffe5cc;\n  color: #cc6600;\n}\n\n.review-status-management-review {\n  background: #ccffcc;\n  color: #00cc00;\n}\n\n.review-status-final-verification {\n  background: #ffe5e5;\n  color: #ff0000;\n}\n\n.review-status-contract-preparation {\n  background: #e5ffe5;\n  color: #008000;\n}\n\n.review-status-contract-sent {\n  background: #e5f9ff;\n  color: #0080ff;\n}\n\n.review-status-signed {\n  background: #e5f5ff;\n  color: #0066cc;\n}\n\n.review-status-payment-confirmed {\n  background: #e5ffe5;\n  color: #00aa00;\n}\n\n.review-status-completed {\n  background: #d4edda;\n  color: #155724;\n}\n\n.review-status-approved {\n  background: #d4edda;\n  color: #155724;\n}\n\n.review-status-rejected {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n/* Extended review status styles */\n.review-status-document-incomplete {\n  background: #ffe5cc;\n  color: #cc6600;\n}\n\n.review-status-preliminary-review {\n  background: #e5e5ff;\n  color: #6666cc;\n}\n\n.review-status-final-review {\n  background: #e5ffe5;\n  color: #00aa00;\n}\n\n.review-status-conditional-approval {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n.review-status-on-hold {\n  background: #f3e5f5;\n  color: #7b1fa2;\n}\n\n.review-status-cancelled {\n  background: #ffebee;\n  color: #c62828;\n}\n\n/* REVIEW DETAIL MODAL */\n.review-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.review-modal {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.review-modal-header {\n  background: var(--primary);\n  color: white;\n  padding: 1.5rem 2rem;\n  border-radius: 12px 12px 0 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.review-modal-title {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.review-modal-close {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: background 0.2s;\n}\n\n.review-modal-close:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.review-modal-content {\n  padding: 2rem;\n}\n\n.review-info-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.review-info-grid > * {\n  word-break: break-word;\n}\n\n.review-info-section {\n  background: #f7fafc;\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.review-info-section h4 {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 1rem 0;\n}\n\n.review-info-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.review-info-item:last-child {\n  border-bottom: none;\n}\n\n.review-info-label {\n  font-size: 14px;\n  color: #4a5568;\n  font-weight: 500;\n}\n\n.review-info-value {\n  font-size: 14px;\n  color: var(--text);\n  font-weight: 600;\n}\n\n/* REVIEW TIMELINE */\n.review-timeline-section {\n  margin-top: 2rem;\n}\n\n.review-timeline-section h4 {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 1.5rem 0;\n}\n\n.review-timeline {\n  position: relative;\n}\n\n.review-timeline::before {\n  content: \"\";\n  position: absolute;\n  left: 20px;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: #e2e8f0;\n}\n\n.review-timeline-item {\n  position: relative;\n  padding-left: 60px;\n  margin-bottom: 1.5rem;\n}\n\n.review-timeline-item:last-child {\n  margin-bottom: 0;\n}\n\n.review-timeline-dot {\n  position: absolute;\n  left: 10px;\n  top: 6px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 3px solid #e2e8f0;\n  background: white;\n}\n\n.review-timeline-dot.completed {\n  background: #38a169;\n  border-color: #38a169;\n}\n\n.review-timeline-dot.current {\n  background: #3182ce;\n  border-color: #3182ce;\n  animation: pulse-timeline 2s infinite;\n}\n\n.review-timeline-dot.pending {\n  background: #f7fafc;\n  border-color: #e2e8f0;\n}\n\n.review-timeline-content {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1rem;\n}\n\n.review-timeline-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text);\n  margin: 0 0 0.5rem 0;\n}\n\n.review-timeline-date {\n  font-size: 12px;\n  color: #718096;\n  margin-bottom: 0.5rem;\n}\n\n.review-timeline-comment {\n  font-size: 13px;\n  color: #4a5568;\n  margin: 0;\n}\n\n.review-timeline-updater {\n  font-size: 12px;\n  color: #718096;\n  font-style: italic;\n  margin-top: 0.25rem;\n}\n\n@keyframes pulse-timeline {\n  0% {\n    box-shadow: 0 0 0 0 rgba(49, 130, 206, 0.7);\n  }\n\n  70% {\n    box-shadow: 0 0 0 10px rgba(49, 130, 206, 0);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(49, 130, 206, 0);\n  }\n}\n\n/* RESPONSIVE */\n@media (max-width: 768px) {\n  .variable-register-page.variable-cost-register-page {\n    width: 100%;\n    margin-left: 0;\n    transform: none;\n  }\n\n  .variable-register-page.subrogation-payment-page {\n    width: 100%;\n    margin-left: 0;\n    transform: none;\n  }\n\n  .variable-cost-context-row {\n    flex-direction: column;\n  }\n\n  .subrogation-context-row {\n    flex-direction: column;\n  }\n\n  .variable-cost-month-navigation {\n    justify-content: space-between;\n  }\n\n  .subrogation-month-navigation {\n    justify-content: space-between;\n  }\n\n  .variable-cost-month-navigation .month-display {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .subrogation-month-navigation .month-display {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .subrogation-deadline-summary .subrogation-deadline-card {\n    gap: 0.375rem;\n    padding: 0.5rem 0.75rem;\n  }\n\n  .subrogation-deadline-summary .subrogation-deadline-copy {\n    gap: 0.4rem;\n  }\n\n  .subrogation-deadline-summary .deadline-label {\n    font-size: 13px;\n  }\n\n  .subrogation-deadline-summary .deadline-date {\n    font-size: 15px;\n  }\n\n  .subrogation-deadline-summary .deadline-countdown {\n    flex-shrink: 0;\n    font-size: 12px;\n    white-space: nowrap;\n  }\n\n  .subrogation-deadline-summary .deadline-countdown > span {\n    padding: 0.2rem 0.5rem;\n  }\n\n  .variable-cost-search-input {\n    width: 100%;\n    max-width: none;\n    min-width: 0;\n  }\n\n  .variable-cost-actions-section {\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n\n  .variable-cost-register-page .variable-cost-search-input {\n    flex: 1 1 100%;\n  }\n\n  .variable-cost-action-buttons {\n    width: 100%;\n    margin-left: 0;\n    flex-wrap: wrap;\n  }\n\n  .variable-cost-register-page .variable-cost-action-buttons .btn-outline,\n  .variable-cost-register-page .variable-cost-action-buttons .btn-primary {\n    flex: 1 1 140px;\n    min-width: 0;\n  }\n\n  .variable-cost-target-selector {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .variable-cost-target-entry {\n    width: 100%;\n  }\n\n  .variable-cost-target-dialog-backdrop {\n    align-items: end;\n    padding: 0.75rem;\n  }\n\n  .variable-cost-target-dialog {\n    max-height: calc(100vh - 1.5rem);\n    padding: 1rem;\n  }\n\n  .subrogation-excel-target-dialog-backdrop {\n    align-items: center;\n    padding: 0.75rem;\n  }\n\n  .subrogation-excel-target-dialog {\n    max-height: calc(100vh - 1.5rem);\n    max-height: calc(100dvh - 1.5rem);\n  }\n\n  .subrogation-excel-target-dialog .variable-cost-target-results {\n    max-height: 45vh;\n  }\n\n  .subrogation-evidence-modal-backdrop {\n    align-items: center;\n    padding: 0.75rem;\n  }\n\n  .subrogation-evidence-modal {\n    max-height: calc(100dvh - 1.5rem);\n  }\n\n  .subrogation-evidence-modal-header,\n  .subrogation-evidence-modal-body {\n    padding-right: 0.9rem;\n    padding-left: 0.9rem;\n  }\n\n  .subrogation-evidence-file-list li {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .subrogation-evidence-file-actions {\n    width: 100%;\n  }\n\n  .subrogation-evidence-file-actions .btn-small {\n    flex: 1 1 0;\n    justify-content: center;\n  }\n\n  .subrogation-evidence-file-meta {\n    white-space: normal;\n  }\n\n  .subrogation-evidence-pending-row {\n    flex-wrap: wrap;\n  }\n\n  .subrogation-evidence-pending-row > span {\n    flex-basis: calc(100% - 24px);\n  }\n\n  .subrogation-evidence-pending-row select {\n    min-width: 0;\n    max-width: none;\n    flex: 1 1 auto;\n  }\n\n  .variable-cost-target-dialog-heading,\n  .variable-cost-target-search-row {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .variable-cost-target-dialog-heading {\n    display: flex;\n  }\n\n  .variable-cost-target-search-row {\n    display: flex;\n  }\n\n  .variable-cost-target-dialog-actions {\n    flex-direction: column-reverse;\n  }\n\n  .variable-cost-target-dialog-actions .btn-primary,\n  .variable-cost-target-dialog-actions .btn-outline {\n    width: 100%;\n  }\n\n  .variable-cost-register-page .cost-table tbody .sticky-status-column {\n    z-index: 4;\n  }\n\n  .variable-cost-register-page .cost-table tbody .sticky-action-column {\n    z-index: 5;\n  }\n\n  .variable-cost-register-page .cost-table thead .sticky-status-column {\n    z-index: 6;\n  }\n\n  .variable-cost-register-page .cost-table thead .sticky-action-column {\n    z-index: 7;\n  }\n\n  .variable-cost-rejection-tooltip {\n    left: 12px !important;\n    right: auto !important;\n    width: calc(100vw - 24px) !important;\n    max-width: none !important;\n  }\n\n  .subrogation-actions-section {\n    flex-wrap: wrap;\n  }\n\n  .subrogation-payment-page .subrogation-search-input {\n    flex: 0 0 42px;\n    width: 100%;\n    max-width: none;\n    min-width: 0;\n  }\n\n  .subrogation-table-wrapper .cost-table {\n    --subrogation-action-width: 132px;\n  }\n\n  .subrogation-action-buttons {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .filter-group {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .search-input,\n  .month-picker,\n  .status-select {\n    min-width: auto;\n  }\n\n  .actions-section {\n    flex-direction: column;\n  }\n\n  .table-wrapper {\n    overflow-x: auto;\n  }\n\n  .detail-section-row {\n    grid-template-columns: 1fr;\n  }\n\n  .contract-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n  }\n\n  .detail-item {\n    grid-template-columns: 1fr;\n    gap: 0.25rem;\n  }\n\n  .status-timeline {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .status-connector {\n    display: none;\n  }\n\n  .form-row-group {\n    grid-template-columns: 1fr;\n  }\n\n  .form-actions {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .btn-submit-application {\n    width: 100%;\n  }\n\n  .review-filter-group {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .application-review-page > .flex.justify-between {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n  }\n\n  .application-review-page > .flex.justify-between > .flex.flex-col-reverse {\n    width: 100%;\n    margin-bottom: 0;\n  }\n\n  .review-search-input,\n  .status-filter-select {\n    min-width: auto;\n  }\n\n  .application-review-page .review-search-input {\n    width: 100%;\n    min-width: 0 !important;\n  }\n\n  .review-info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .review-modal {\n    width: 95%;\n    max-height: 95vh;\n  }\n\n  .review-modal-content {\n    padding: 1rem;\n  }\n}\n\n/* --- PRIVACY POLICY & ENHANCED CONSENT STYLES ---------------------- */\n\n/* Privacy Policy Section */\n.privacy-policy-section {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin: 1rem 0;\n  background: #f8fafc;\n}\n\n.privacy-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.privacy-header h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0;\n}\n\n.btn-view-policy {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: #3182ce;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.btn-view-policy:hover {\n  background: #2c5282;\n}\n\n.privacy-checkboxes {\n  margin: 1rem 0;\n}\n\n.privacy-checkboxes .form-row {\n  margin-bottom: 0.75rem;\n}\n\n.privacy-checkboxes label {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  font-size: 14px;\n  line-height: 1.5;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.privacy-checkboxes label.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.privacy-checkboxes input[type=\"checkbox\"] {\n  margin-top: 2px;\n  accent-color: #3182ce;\n}\n\n.privacy-checkboxes input[type=\"checkbox\"]:disabled {\n  cursor: not-allowed;\n}\n\n.policy-notice {\n  background: #fef5e7;\n  border: 1px solid #f6ad55;\n  border-radius: 6px;\n  padding: 0.75rem;\n  margin-top: 1rem;\n}\n\n.policy-notice p {\n  color: #c05621;\n  font-size: 13px;\n  margin: 0;\n  font-weight: 500;\n}\n\n/* Privacy Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.privacy-modal {\n  background: white;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 800px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.modal-header h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #a0aec0;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.modal-close:hover {\n  background: #f7fafc;\n  color: #4a5568;\n}\n\n.modal-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.privacy-policy-text {\n  padding: 1.5rem;\n  line-height: 1.6;\n  color: #4a5568;\n}\n\n.privacy-policy-text h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 1.5rem 0 0.75rem 0;\n}\n\n.privacy-policy-text h4:first-child {\n  margin-top: 0;\n}\n\n.privacy-policy-text p {\n  margin-bottom: 0.75rem;\n}\n\n.privacy-policy-text ul {\n  margin: 0.75rem 0 1.5rem 1.5rem;\n  padding: 0;\n}\n\n.privacy-policy-text li {\n  margin-bottom: 0.5rem;\n}\n\n.consent-summary {\n  background: #f7fafc;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-top: 2rem;\n}\n\n.consent-summary h4 {\n  color: #2d3748;\n  margin-bottom: 1rem !important;\n}\n\n.consent-items {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.consent-item {\n  padding: 1rem;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  background: white;\n}\n\n.consent-item.required {\n  border-color: #f56565;\n  background: #fef5f5;\n}\n\n.consent-item.optional {\n  border-color: #4299e1;\n  background: #f0f8ff;\n}\n\n.consent-item strong {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-size: 14px;\n}\n\n.consent-item.required strong {\n  color: #c53030;\n}\n\n.consent-item.optional strong {\n  color: var(--primary);\n}\n\n.consent-item p {\n  margin: 0;\n  font-size: 13px;\n  color: #4a5568;\n}\n\n.modal-footer {\n  padding: 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: center;\n}\n\n.modal-footer .btn {\n  padding: 0.75rem 2rem;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.modal-footer .btn-primary {\n  background: #3182ce;\n  color: white;\n  border: none;\n}\n\n.modal-footer .btn-primary:hover {\n  background: #2c5282;\n}\n\n/* Enhanced form validation styles */\n.form-input:disabled {\n  background-color: #f7fafc;\n  color: #a0aec0;\n  cursor: not-allowed;\n}\n\n/* Responsive Design for Privacy Modal */\n@media (max-width: 768px) {\n  .privacy-modal {\n    max-width: 95%;\n    max-height: 95vh;\n  }\n\n  .modal-header {\n    padding: 1rem;\n  }\n\n  .privacy-policy-text {\n    padding: 1rem;\n  }\n\n  .modal-footer {\n    padding: 1rem;\n  }\n\n  .privacy-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n  }\n\n  .btn-view-policy {\n    align-self: center;\n  }\n\n  .consent-items {\n    gap: 0.75rem;\n  }\n\n  .consent-item {\n    padding: 0.75rem;\n  }\n}\n\n/* --- APPLICATION MODIFICATION CONTROL STYLES ---------------------- */\n\n/* Modification Control Notice */\n.modification-control-notice {\n  margin-bottom: 2rem;\n}\n\n.control-status {\n  border-radius: 12px;\n  padding: 1.5rem;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 2px solid;\n}\n\n.control-status.modifiable {\n  border-color: #f59e0b;\n  background: #fefbf2;\n}\n\n.control-status.locked {\n  border-color: #ef4444;\n  background: #fef2f2;\n}\n\n.status-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.status-header h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.status-modifiable {\n  background: #f59e0b;\n  color: white;\n}\n\n.status-locked {\n  background: #ef4444;\n  color: white;\n}\n\n.status-content p {\n  margin: 0.5rem 0;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.status-content strong {\n  color: #1f2937;\n}\n\n.modifiable-notice {\n  background: #fef3c7;\n  border: 1px solid #f59e0b;\n  border-radius: 6px;\n  padding: 1rem;\n  margin-top: 1rem;\n}\n\n.modifiable-notice p {\n  color: #92400e;\n  margin: 0.25rem 0;\n  font-weight: 500;\n}\n\n.locked-notice {\n  background: #fee2e2;\n  border: 1px solid #f87171;\n  border-radius: 6px;\n  padding: 1rem;\n  margin-top: 1rem;\n}\n\n.locked-notice p {\n  color: #991b1b;\n  margin: 0.25rem 0;\n  font-weight: 500;\n}\n\n/* Test Control Actions */\n.control-test-actions {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.btn-test {\n  padding: 0.5rem 1rem;\n  border: 1px solid #6b7280;\n  border-radius: 6px;\n  background: white;\n  color: #374151;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-test:hover {\n  background: #f9fafb;\n  border-color: #4b5563;\n}\n\n/* Enhanced Submit Button States */\n.btn-submit-application.disabled {\n  background: #d1d5db !important;\n  color: #9ca3af !important;\n  cursor: not-allowed !important;\n  border-color: #d1d5db !important;\n}\n\n.btn-submit-application.disabled:hover {\n  background: #d1d5db !important;\n  color: #9ca3af !important;\n}\n\n/* Form Field Disabled State Enhancement */\n.application-form input:disabled,\n.application-form select:disabled,\n.application-form textarea:disabled {\n  background-color: #f9fafb;\n  color: #6b7280;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.application-form .form-row.disabled label {\n  color: #9ca3af;\n}\n\n/* Responsive Design for Modification Control */\n@media (max-width: 768px) {\n  .modification-control-notice {\n    margin-bottom: 1.5rem;\n  }\n\n  .control-status {\n    padding: 1rem;\n  }\n\n  .status-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n  }\n\n  .control-test-actions {\n    flex-direction: column;\n  }\n\n  .btn-test {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n/* --- INPUT AUTO-CONVERSION STYLES ---------------------------------- */\n\n/* Auto-conversion feedback */\n.form-input.auto-converted {\n  border-color: #10b981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);\n  transition: all 0.3s ease;\n}\n\n.conversion-notice {\n  background: #d1fae5;\n  border: 1px solid #10b981;\n  border-radius: 4px;\n  padding: 0.5rem;\n  margin-top: 0.5rem;\n  font-size: 12px;\n  color: #065f46;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.conversion-notice.phone-conversion {\n  background: #dbeafe;\n  border-color: #3b82f6;\n  color: #1e40af;\n}\n\n.conversion-notice.address-conversion {\n  background: #fef3c7;\n  border-color: #f59e0b;\n  color: #92400e;\n}\n\n.conversion-notice .icon {\n  font-size: 14px;\n}\n\n/* Auto-conversion help text */\n.input-help-text {\n  font-size: 11px;\n  color: #6b7280;\n  margin-top: 0.25rem;\n  line-height: 1.4;\n}\n\n.input-help-text.conversion-help {\n  color: #059669;\n  font-weight: 500;\n}\n\n/* Visual indicators for different field types */\n.form-input.phone-field {\n  position: relative;\n}\n\n.form-input.address-field {\n  position: relative;\n}\n\n.form-input.postcode-field {\n  position: relative;\n}\n\n/* Conversion animation */\n@keyframes convertFlash {\n  0% {\n    background-color: #dcfce7;\n  }\n\n  50% {\n    background-color: #bbf7d0;\n  }\n\n  100% {\n    background-color: white;\n  }\n}\n\n.form-input.converting {\n  animation: convertFlash 0.6s ease-in-out;\n}\n\n/* Enhanced placeholder text for conversion fields */\n.form-input[placeholder*=\"電話番号\"]::placeholder,\n.form-input[placeholder*=\"TEL\"]::placeholder {\n  color: #a0aec0;\n}\n\n.form-input[placeholder*=\"住所\"]::placeholder,\n.form-input[placeholder*=\"番地\"]::placeholder {\n  color: #a0aec0;\n}\n\n.form-input[placeholder*=\"郵便番号\"]::placeholder {\n  color: #a0aec0;\n}\n\n/* --- ENHANCED VARIABLE COSTS FUNCTIONALITY ----------------------- */\n\n/* Sortable header */\n.sortable-header {\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n  position: relative;\n  padding: 8px 12px;\n}\n\n/* .sortable-header:hover {\n  background-color: #f7fafc;\n} */\n\n.sort-indicator {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  margin-left: 4px;\n  min-width: 1.1em;\n  font-size: 12px;\n  font-weight: normal;\n  color: currentColor;\n  vertical-align: middle;\n  width: 1.1em;\n}\n\n/* Previous month data transfer button */\n.btn-outline.inherit-data {\n  background-color: #e6fffa;\n  border-color: #38b2ac;\n  color: #38b2ac;\n}\n\n.btn-outline.inherit-data:hover {\n  background-color: #38b2ac;\n  color: white;\n}\n\n/* 検索フィールド強化表示 */\n.search-input[placeholder*=\"管理ID\"] {\n  background-color: #fefefe;\n  border-color: #c3dafe;\n}\n\n.search-input[placeholder*=\"管理ID\"]:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Lightweight styles for performance improvement */\n.table-wrapper {\n  contain: layout style;\n  will-change: transform;\n}\n\n/* パフォーマンス通知 */\n.performance-notice {\n  background: linear-gradient(45deg, #f0f9ff, #e0f2fe);\n  border: 1px solid #0ea5e9;\n  border-radius: 6px;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 14px;\n  color: #0369a1;\n  font-weight: 500;\n}\n\n.performance-icon {\n  font-size: 16px;\n  animation: sparkle 2s ease-in-out infinite;\n}\n\n@keyframes sparkle {\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.6;\n  }\n}\n\n/* Agreement section improvements */\n.agreement-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.agreement-row label {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.btn-view-policy {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  border: none;\n  border-radius: 6px;\n  color: white;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 8px 16px;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.btn-view-policy:hover {\n  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n  transform: translateY(-1px);\n}\n\n.btn-disabled {\n  background: #e5e7eb !important;\n  color: #9ca3af !important;\n  cursor: not-allowed !important;\n}\n\n.btn-disabled:hover {\n  background: #e5e7eb !important;\n  transform: none !important;\n}\n\n/* Modal content width fix */\n.privacy-modal .modal-content {\n  max-height: 400px;\n  overflow-y: auto;\n  width: 100%;\n}\n\n.privacy-policy-text {\n  width: 100%;\n  padding: 0;\n}\n\n.privacy-policy-text h4 {\n  color: #1f2937;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 1.5rem 0 0.75rem 0;\n}\n\n.privacy-policy-text h4:first-child {\n  margin-top: 0;\n}\n\n.privacy-policy-text p {\n  color: #374151;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n}\n\n.privacy-policy-text ul {\n  color: #374151;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n  padding-left: 1.5rem;\n}\n\n.privacy-policy-text li {\n  margin-bottom: 0.5rem;\n}\n\n/* Form actions button alignment */\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.form-actions button {\n  height: 48px;\n  min-width: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.btn-back {\n  background: #f3f4f6;\n  border: 1px solid #d1d5db;\n  color: #374151;\n}\n\n.btn-back:hover {\n  background: #e5e7eb;\n}\n\n.btn-temp-save {\n  background: #fbbf24;\n  border: 1px solid #f59e0b;\n  color: #92400e;\n}\n\n.btn-temp-save:hover {\n  background: #f59e0b;\n  color: white;\n}\n\n.btn-submit-application {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  border: none;\n  color: white;\n}\n\n.btn-submit-application:hover:not(.disabled) {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-1px);\n}\n\n.btn-submit-application.disabled {\n  background: #e5e7eb !important;\n  color: #9ca3af !important;\n  cursor: not-allowed !important;\n}\n\n.btn-submit-application.disabled:hover {\n  transform: none !important;\n}\n\n/* Responsive design for form actions */\n@media (max-width: 768px) {\n  .form-actions {\n    flex-direction: column;\n  }\n\n  .form-actions button {\n    width: 100%;\n  }\n\n  .agreement-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .agreement-row label {\n    width: 100%;\n  }\n\n  .btn-view-policy {\n    align-self: flex-start;\n  }\n}\n\n/* Application Status Page Styles */\n.application-status-page {\n  padding: 24px;\n  background: #f8fafc;\n  min-height: 100vh;\n}\n\n.application-status-page h2 {\n  color: #1f2937;\n  font-size: 28px;\n  font-weight: 600;\n  margin-bottom: 32px;\n  border-bottom: 3px solid #3b82f6;\n  padding-bottom: 12px;\n}\n\n.application-status-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Status Summary Card */\n.status-summary-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n}\n\n.status-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.status-header h3 {\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.status-modifiable {\n  background: #dcfce7;\n  color: #16a34a;\n  border: 1px solid #bbf7d0;\n}\n\n.status-locked {\n  background: #fef3c7;\n  color: #d97706;\n  border: 1px solid #fed7aa;\n}\n\n.status-details {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n}\n\n.status-detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.status-detail-item label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-detail-item span {\n  font-size: 16px;\n  font-weight: 500;\n  color: #1f2937;\n}\n\n/* Review Progress Card */\n.review-progress-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n}\n\n.review-progress-card h3 {\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0 0 20px 0;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #3b82f6;\n}\n\n/* Progress Tracker in Status Page */\n.application-status-page .progress-tracker {\n  margin: 0;\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n}\n\n.application-status-page .progress-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.application-status-page .progress-step {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.application-status-page .progress-step.completed {\n  border-color: #10b981;\n  background: #f0fdf4;\n}\n\n.application-status-page .progress-step.current {\n  border-color: #3b82f6;\n  background: #eff6ff;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.application-status-page .progress-step.current .step-indicator {\n  animation: pulse 2s infinite;\n}\n\n.application-status-page .step-indicator {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.application-status-page .step-indicator.completed {\n  background: #10b981;\n  color: #fff;\n}\n\n.application-status-page .step-indicator.current {\n  background: #3b82f6;\n  color: #fff;\n}\n\n.application-status-page .step-indicator.pending {\n  background: #f3f4f6;\n  color: #6b7280;\n  border: 2px solid #d1d5db;\n}\n\n.application-status-page .step-content {\n  flex: 1;\n}\n\n.application-status-page .step-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 4px;\n}\n\n.application-status-page .step-description {\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.4;\n  margin-bottom: 6px;\n}\n\n.application-status-page .step-timing {\n  font-size: 12px;\n  font-weight: 500;\n  color: #3b82f6;\n}\n\n.application-status-page .step-content.completed .step-title {\n  color: #059669;\n}\n\n.application-status-page .step-content.current .step-title {\n  color: #2563eb;\n}\n\n/* Status Actions */\n.status-actions {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n}\n\n.modification-available,\n.modification-locked {\n  margin-bottom: 24px;\n}\n\n.modification-notice h4,\n.locked-notice h4 {\n  color: #1f2937;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n}\n\n.modification-notice p,\n.locked-notice p {\n  color: #4b5563;\n  font-size: 14px;\n  line-height: 1.6;\n  margin: 0 0 20px 0;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n/* Test Controls */\n.test-controls {\n  border-top: 1px solid #e5e7eb;\n  padding-top: 20px;\n  margin-top: 20px;\n}\n\n.test-controls h4 {\n  color: #6b7280;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* No Application Message */\n.no-application-message {\n  background: #fff;\n  border-radius: 12px;\n  padding: 48px;\n  text-align: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n}\n\n.no-application-message h3 {\n  color: #1f2937;\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n}\n\n.no-application-message p {\n  color: #6b7280;\n  font-size: 16px;\n  margin: 0 0 24px 0;\n}\n\n/* Responsive Design for Application Status */\n@media (max-width: 768px) {\n  .application-status-page {\n    padding: 16px;\n  }\n\n  .application-status-page h2 {\n    font-size: 24px;\n    margin-bottom: 24px;\n  }\n\n  .status-summary-card,\n  .review-progress-card,\n  .status-actions {\n    padding: 16px;\n  }\n\n  .status-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .status-details {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .application-status-page .progress-step {\n    padding: 12px;\n  }\n\n  .application-status-page .step-indicator {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n\n  .action-buttons {\n    flex-direction: column;\n  }\n\n  .no-application-message {\n    padding: 32px 16px;\n  }\n}\n\n/* Contract Detail Enhanced Review Status Styles */\n.review-progress-summary {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 24px;\n}\n\n.progress-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.progress-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.progress-percentage {\n  font-size: 14px;\n  font-weight: 600;\n  color: #3b82f6;\n}\n\n.progress-bar-container {\n  width: 100%;\n  height: 8px;\n  background: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #3b82f6, #1d4ed8);\n  border-radius: 4px;\n  transition: width 0.5s ease;\n}\n\n/* Detailed Status Timeline */\n.detailed-status-timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  position: relative;\n}\n\n.detailed-status-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 16px 0;\n  position: relative;\n}\n\n.detailed-status-item:last-child {\n  padding-bottom: 0;\n}\n\n.status-step-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.step-number {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  z-index: 2;\n  position: relative;\n}\n\n.step-number.completed {\n  background: #10b981;\n  color: #fff;\n}\n\n.step-number.current {\n  background: #3b82f6;\n  color: #fff;\n  animation: pulse 2s infinite;\n}\n\n.step-number.pending {\n  background: #f3f4f6;\n  color: #6b7280;\n  border: 2px solid #d1d5db;\n}\n\n.step-connector {\n  width: 2px;\n  height: 48px;\n  background: #e5e7eb;\n  margin-top: 8px;\n  margin-bottom: -12px;\n}\n\n.detailed-status-item.completed .step-connector {\n  background: #10b981;\n}\n\n.detailed-status-item.current .step-connector {\n  background: linear-gradient(to bottom, #10b981, #e5e7eb);\n}\n\n.status-step-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.step-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 6px;\n  flex-wrap: wrap;\n}\n\n.step-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.detailed-status-item.completed .step-title {\n  color: #059669;\n}\n\n.detailed-status-item.current .step-title {\n  color: #2563eb;\n}\n\n.current-step-badge {\n  background: #dbeafe;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 12px;\n}\n\n.step-date {\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.step-description {\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.5;\n  margin: 0 0 8px 0;\n}\n\n.step-details {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 6px;\n  padding: 12px;\n  margin-top: 8px;\n}\n\n.step-note {\n  font-size: 13px;\n  color: #1e40af;\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* Review Result Section */\n.review-result-section {\n  border-top: 1px solid #e5e7eb;\n  padding-top: 20px;\n  margin-top: 20px;\n}\n\n.review-result-section h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 12px 0;\n}\n\n.review-comment {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 16px;\n}\n\n.review-comment p {\n  font-size: 14px;\n  color: #374151;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Responsive Design for Enhanced Review Status */\n@media (max-width: 768px) {\n  .progress-info {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .detailed-status-item {\n    padding: 12px 0;\n  }\n\n  .step-number {\n    width: 32px;\n    height: 32px;\n    font-size: 12px;\n  }\n\n  .step-connector {\n    height: 24px;\n  }\n\n  .step-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n  }\n\n  .step-title {\n    font-size: 14px;\n  }\n\n  .step-description {\n    font-size: 13px;\n  }\n}\n\n/* Complete Review Timeline (審査状況確認モーダル内) */\n.complete-review-timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin-top: 16px;\n}\n\n.complete-timeline-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 12px 0;\n  position: relative;\n}\n\n.complete-timeline-item:last-child {\n  padding-bottom: 0;\n}\n\n.timeline-step-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.step-circle {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  z-index: 2;\n  position: relative;\n}\n\n.step-circle.completed {\n  background: #10b981;\n  color: #fff;\n}\n\n.step-circle.current {\n  background: #3b82f6;\n  color: #fff;\n  /* animation: pulse 2s infinite; */\n}\n\n.step-circle.pending {\n  background: #f3f4f6;\n  color: #6b7280;\n  border: 2px solid #d1d5db;\n}\n\n.step-line {\n  width: 2px;\n  height: 40px;\n  margin-top: 6px;\n  z-index: 1;\n}\n\n.step-line.completed {\n  background: #10b981;\n}\n\n.step-line.current {\n  background: linear-gradient(to bottom, #10b981 0%, #10b981 50%, #e5e7eb 50%, #e5e7eb 100%);\n}\n\n.step-line.pending {\n  background: #e5e7eb;\n}\n\n.timeline-step-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.step-header-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n  flex-wrap: wrap;\n}\n\n.step-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.complete-timeline-item.completed .step-name {\n  color: #059669;\n}\n\n.complete-timeline-item.current .step-name {\n  color: #2563eb;\n}\n\n.current-badge {\n  background: #dbeafe;\n  color: #1d4ed8;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 8px;\n}\n\n.step-timestamp {\n  font-size: 11px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.step-desc {\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1.4;\n  margin: 0 0 6px 0;\n}\n\n.step-comment {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  padding: 8px;\n  margin: 4px 0;\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.comment-icon {\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.comment-text {\n  font-size: 12px;\n  color: #374151;\n  line-height: 1.4;\n}\n\n.step-updater {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.updater-label {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.updater-name {\n  font-size: 11px;\n  color: #374151;\n  font-weight: 500;\n}\n\n/* Responsive Design for Complete Timeline */\n@media (max-width: 768px) {\n  .complete-timeline-item {\n    padding: 10px 0;\n  }\n\n  .step-circle {\n    width: 28px;\n    height: 28px;\n    font-size: 11px;\n  }\n\n  .step-line {\n    height: 32px;\n  }\n\n  .step-header-info {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .step-name {\n    font-size: 13px;\n  }\n\n  .step-desc {\n    font-size: 11px;\n  }\n}\n\n/* 解約登録ページ */\n.cancellation-register-page {\n  padding: 2rem;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.cancellation-register-page h2 {\n  margin-bottom: 1.5rem;\n  color: #2c5282;\n  font-size: 1.8rem;\n  border-bottom: 2px solid #e2e8f0;\n  padding-bottom: 0.5rem;\n}\n\n.page-description {\n  background-color: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 2rem;\n}\n\n.page-description p {\n  margin: 0;\n  color: #4a5568;\n  line-height: 1.6;\n}\n\n.cancellation-form {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.cancellation-form .form-section {\n  background-color: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.cancellation-form .form-section h3 {\n  margin: 0 0 1rem 0;\n  color: #2d3748;\n  font-size: 1.2rem;\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 0.5rem;\n}\n\n.cancellation-form .form-card {\n  display: grid;\n  gap: 1rem;\n}\n\n@media (max-width: 768px) {\n  .cancellation-contract-recovery-alert {\n    display: grid;\n    grid-template-columns: auto minmax(0, 1fr);\n    column-gap: 8px;\n    row-gap: 8px;\n    align-items: start;\n  }\n\n  .cancellation-contract-recovery-alert .ant-alert-icon {\n    grid-column: 1;\n    grid-row: 1;\n    margin-inline-end: 0;\n  }\n\n  .cancellation-contract-recovery-alert .ant-alert-content {\n    grid-column: 2;\n    grid-row: 1;\n  }\n\n  .cancellation-contract-recovery-alert .ant-alert-action {\n    grid-column: 2;\n    grid-row: 2;\n    margin-inline-start: 0;\n  }\n\n  .cancellation-contract-recovery-alert .ant-alert-action .ant-btn {\n    height: auto;\n    padding-inline: 0;\n    white-space: normal;\n  }\n}\n\n.cancellation-form .form-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.cancellation-form .form-row label {\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.cancellation-form .required {\n  color: #e53e3e;\n  margin-left: 4px;\n}\n\n.cancellation-form .form-input,\n.cancellation-form .form-select,\n.cancellation-form .form-textarea {\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 1rem;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.cancellation-form .form-input:focus,\n.cancellation-form .form-select:focus,\n.cancellation-form .form-textarea:focus {\n  outline: none;\n  border-color: #3182ce;\n  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);\n}\n\n.cancellation-form .form-textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  padding-top: 2rem;\n  border-top: 1px solid #e2e8f0;\n  margin-top: 2rem;\n}\n\n/* Cancellation registration confirmation items styles */\n.confirmation-section {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin: 1.5rem 0 1rem 0;\n}\n\n.confirmation-items {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.confirmation-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  line-height: 1.6;\n}\n\n.confirmation-item .bullet {\n  color: #2d3748;\n  font-weight: bold;\n  margin-top: 0.1rem;\n  flex-shrink: 0;\n}\n\n.confirmation-checkbox {\n  margin-top: 1rem;\n}\n\n.btn-primary:disabled {\n  background-color: #a0aec0;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.btn-primary:disabled:hover {\n  background-color: #a0aec0;\n}\n\n.btn-secondary {\n  background-color: #f7fafc;\n  color: #4a5568;\n  border: 1px solid #d1d5db;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-secondary:hover {\n  background-color: #edf2f7;\n  border-color: #a0aec0;\n}\n\n.btn-primary {\n  background-color: #3182ce;\n  color: white;\n  border: 1px solid #3182ce;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-primary:hover {\n  background-color: #2c5282;\n  border-color: #2c5282;\n}\n\n.btn-primary:disabled {\n  background: #e2e8f0;\n  color: #a0aec0;\n  border-color: #e2e8f0;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.guara-update-confirm-row-actions .guara-update-confirm-action-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 42px;\n  width: 42px;\n  min-width: 42px;\n  height: 28px;\n  min-height: 28px;\n  padding: 0;\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n/* レスポンシブ対応 */\n@media (max-width: 768px) {\n  .cancellation-register-page {\n    padding: 1rem;\n  }\n\n  .cancellation-form .form-section {\n    padding: 1rem;\n  }\n\n  .form-actions {\n    flex-direction: column;\n  }\n\n  .btn-secondary,\n  .btn-primary {\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .guara-update-confirm-row-actions .guara-update-confirm-action-button {\n    flex: 0 0 42px;\n    width: 42px;\n    min-width: 42px;\n  }\n}\n\n/* 月額費用セクションの強調表示 */\n.monthly-expenses-title {\n  background-color: #e53e3e;\n  color: white;\n  padding: 0.5rem 1rem;\n  margin: 1rem -1.5rem 0.5rem -1.5rem;\n  border-radius: 4px;\n}\n\n.monthly-expenses-breakdown {\n  border: 2px solid #e53e3e;\n  border-radius: 8px;\n  padding: 1rem;\n  background-color: #fef5f5;\n}\n\n.monthly-expenses-breakdown .cost-item {\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #fed7d7;\n}\n\n.monthly-expenses-breakdown .cost-item:last-child {\n  border-bottom: none;\n  font-weight: bold;\n  background-color: #fed7d7;\n  margin: 0.5rem -1rem -1rem -1rem;\n  padding: 0.75rem 1rem;\n  border-radius: 0 0 6px 6px;\n}\n\n/* 物件選択通知 */\n.property-selection-notice {\n  margin-bottom: 1.5rem;\n}\n\n.notice-box {\n  background-color: #fff5f5;\n  border: 2px solid #fed7d7;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.notice-box p {\n  margin: 0.25rem 0;\n  color: #742a2a;\n  font-size: 0.9rem;\n}\n\n.notice-box p:first-child {\n  font-weight: 600;\n}\n\n/* 一時保存機能 */\n.btn-temp-save {\n  background-color: #ed8936;\n  color: white;\n  border: 1px solid #ed8936;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-temp-save:hover {\n  background-color: #dd7724;\n  border-color: #dd7724;\n}\n\n/* Temporary save data notification */\n.temp-data-notice {\n  margin-bottom: 2rem;\n}\n\n.notice-card {\n  background-color: #fff3cd;\n  border: 2px solid #fdb750;\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.notice-header h3 {\n  margin: 0 0 1rem 0;\n  color: #996f00;\n  font-size: 1.2rem;\n}\n\n.notice-content p {\n  margin: 0.5rem 0;\n  color: #705f0c;\n}\n\n.notice-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.btn-restore {\n  background-color: #38a169;\n  color: white;\n  border: 1px solid #38a169;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-restore:hover {\n  background-color: #2f855a;\n  border-color: #2f855a;\n}\n\n.btn-clear {\n  background-color: #e53e3e;\n  color: white;\n  border: 1px solid #e53e3e;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-clear:hover {\n  background-color: #c53030;\n  border-color: #c53030;\n}\n\n/* レスポンシブ対応 */\n@media (max-width: 768px) {\n  .form-actions {\n    flex-direction: column;\n  }\n\n  .notice-actions {\n    flex-direction: column;\n  }\n\n  .btn-temp-save,\n  .btn-restore,\n  .btn-clear {\n    width: 100%;\n  }\n}\n\n/* Temporary save data display */\n.temp-application-message {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.temp-application-message h3 {\n  text-align: center;\n  margin-bottom: 2rem;\n  color: #2d3748;\n}\n\n.temp-info-card {\n  background-color: #f7fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.temp-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.temp-header h4 {\n  margin: 0;\n  color: #2d3748;\n}\n\n.temp-status-badge {\n  background-color: #ed8936;\n  color: white;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.temp-details {\n  margin: 1rem 0;\n}\n\n.temp-detail-item {\n  display: flex;\n  margin-bottom: 0.5rem;\n}\n\n.temp-detail-item label {\n  font-weight: 600;\n  color: #4a5568;\n  min-width: 100px;\n  margin-right: 1rem;\n}\n\n.temp-detail-item span {\n  color: #2d3748;\n}\n\n.temp-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  justify-content: center;\n}\n\n/* レスポンシブ対応 */\n@media (max-width: 768px) {\n  .temp-application-message {\n    padding: 1rem;\n  }\n\n  .temp-actions {\n    flex-direction: column;\n  }\n\n  .temp-detail-item {\n    flex-direction: column;\n  }\n\n  .temp-detail-item label {\n    min-width: auto;\n    margin-right: 0;\n    margin-bottom: 0.25rem;\n  }\n}\n\n/* 入居予定日編集機能 */\n.move-in-date-edit {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.move-in-date-display {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.move-in-date-input {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.form-input-small {\n  padding: 0.25rem 0.5rem;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  width: 150px;\n}\n\n.form-input-small:focus {\n  outline: none;\n  border-color: #3182ce;\n  box-shadow: 0 0 0 2px rgba(49, 130, 206, 0.1);\n}\n\n.move-in-date-actions {\n  display: flex;\n  gap: 0.25rem;\n}\n\n.btn-edit-small,\n.btn-save-small,\n.btn-cancel-small {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid;\n}\n\n.btn-edit-small {\n  background-color: #f7fafc;\n  color: #4a5568;\n  border-color: #e2e8f0;\n}\n\n.btn-edit-small:hover {\n  background-color: #edf2f7;\n  border-color: #cbd5e0;\n}\n\n.btn-save-small {\n  background-color: #38a169;\n  color: white;\n  border-color: #38a169;\n}\n\n.btn-save-small:hover {\n  background-color: #2f855a;\n  border-color: #2f855a;\n}\n\n.btn-cancel-small {\n  background-color: #e2e8f0;\n  color: #4a5568;\n  border-color: #cbd5e0;\n}\n\n.btn-cancel-small:hover {\n  background-color: #cbd5e0;\n  border-color: #a0aec0;\n}\n\n/* レスポンシブ対応 */\n@media (max-width: 768px) {\n  .move-in-date-edit {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .move-in-date-display,\n  .move-in-date-input {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n  }\n\n  .form-input-small {\n    width: 100%;\n  }\n\n  .move-in-date-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n/* --- ACTION BUTTONS FOR APPLICATION STATUS ----------------------- */\n.step-actions {\n  margin-top: 12px;\n  padding: 12px;\n  background: #f8fafc;\n  border-radius: 6px;\n  border-left: 3px solid #3b82f6;\n}\n\n.action-notice {\n  margin-bottom: 8px;\n}\n\n.action-notice p {\n  font-size: 13px;\n  color: #374151;\n  margin: 0;\n  font-weight: 500;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.btn-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  border: 1px solid;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  background: white;\n}\n\n.btn-action:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.btn-action.btn-add {\n  color: #059669;\n  border-color: #059669;\n}\n\n.btn-action.btn-add:hover {\n  background: #ecfdf5;\n  border-color: #047857;\n  color: #047857;\n}\n\n.btn-action.btn-skip {\n  color: #dc2626;\n  border-color: #dc2626;\n}\n\n.btn-action.btn-skip:hover {\n  background: #fef2f2;\n  border-color: #b91c1c;\n  color: #b91c1c;\n}\n\n.icon-plus,\n.icon-minus {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n/* Responsive adjustments for action buttons */\n@media (max-width: 768px) {\n  .action-buttons {\n    flex-direction: column;\n    gap: 6px;\n    align-items: stretch;\n  }\n\n  .btn-action {\n    justify-content: center;\n    width: 100%;\n  }\n}\n\n/* Form Label Container */\n.form-label-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n/* Identity Document Guide Link */\n.identity-guide-link {\n  background: none;\n  border: none;\n  color: #dc2626;\n  font-size: 12px;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n  font-weight: 500;\n}\n\n.identity-guide-link:hover {\n  color: #b91c1c;\n  text-decoration: none;\n}\n\n/* PDF Guide Modal Styles */\n.pdf-guide-modal {\n  background: white;\n  border-radius: 12px;\n  width: 95%;\n  max-width: 1200px;\n  max-height: 95vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n/* Contract Cost Input Styles */\n.cost-input-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 16px 20px 8px;\n  padding: 0 8px;\n}\n\n.cost-input-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.cost-input-row:last-child {\n  border-bottom: none;\n}\n\n.cost-total-row {\n  background-color: #f9fafb;\n  padding: 12px 16px;\n  margin: 8px -24px 4px;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  font-weight: 600;\n}\n\n.cost-label {\n  font-weight: 500;\n  color: #374151;\n  min-width: 120px;\n  margin-right: 16px;\n}\n\n.cost-total-label {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.cost-input-group {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.cost-input {\n  width: 120px;\n  padding: 6px 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  text-align: right;\n  font-size: 14px;\n  background-color: white;\n}\n\n.cost-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px #3b82f6;\n}\n\n.cost-unit {\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 400;\n}\n\n.cost-total-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  text-align: right;\n  min-width: 120px;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .cost-input-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .cost-label {\n    min-width: auto;\n    margin-right: 0;\n  }\n\n  .cost-input-group {\n    align-self: flex-end;\n  }\n\n  .cost-total-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .cost-total-value {\n    align-self: flex-end;\n  }\n}\n\n.pdf-guide-modal .modal-content {\n  flex: 1;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  display: flex;\n}\n\n.pdf-guide-modal iframe {\n  border-radius: 6px;\n  width: 100%;\n  height: 700px;\n  margin: 0;\n  padding: 0;\n  border: none;\n  display: block;\n}\n\n@media (max-width: 768px) {\n  .pdf-guide-modal {\n    width: 98%;\n    max-height: 98vh;\n  }\n\n  .pdf-guide-modal iframe {\n    height: 500px;\n  }\n\n  .form-label-container {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .identity-guide-link {\n    align-self: flex-end;\n    font-size: 11px;\n  }\n}\n\n/* ---------- 物件情報簡潔レイアウト ---------- */\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.form-grid:last-child {\n  margin-bottom: 0;\n}\n\n/* 軽いセクション区切り */\n.property-subsection {\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.property-subsection:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n/* Lease contract terms section styling */\n.rental-conditions-section {\n  background-color: white;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  margin-bottom: 16px;\n}\n\n.rental-conditions-section h4 {\n  color: #000;\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.rental-conditions-section .form-row {\n  border-bottom: 1px solid #e2e8f0;\n  padding: 8px 0;\n  margin-bottom: 0;\n}\n\n.rental-conditions-section .form-row:last-child {\n  border-bottom: none;\n}\n\n.monthly-costs-header {\n  background-color: #dc2626 !important;\n  color: white !important;\n  margin: 16px -20px 16px;\n  padding: 12px 20px;\n  border-radius: 0;\n  font-weight: 600;\n}\n\n.monthly-costs-section {\n  background-color: #fef2f2;\n  border: 2px solid #dc2626;\n  border-radius: 8px;\n  padding: 16px;\n  margin: 0 0 16px 0;\n}\n\n.monthly-costs-section .cost-input-row {\n  border-bottom: 1px solid #fca5a5;\n}\n\n.monthly-costs-section .cost-total-row {\n  background-color: #fee2e2;\n  border: 1px solid #dc2626;\n  border-radius: 6px;\n  margin: 8px 0 0 0;\n  padding: 12px 16px;\n  font-weight: 700;\n}\n\n.other-subsection {\n  margin-top: 8px;\n  padding-top: 0;\n  border-top: none;\n}\n\n.other-subsection-title {\n  font-weight: 700;\n  color: #991b1b;\n}\n\n.other-subsection-header {\n  padding-top: 0;\n  border-bottom: none !important;\n}\n\n.other-subsection-body {\n  padding-left: 24px;\n}\n\n.other-subsection-summary {\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n  justify-content: flex-end;\n}\n\n.other-subsection-summary-value {\n  flex: 1;\n  min-width: 0;\n  box-sizing: border-box;\n  padding-right: 8px;\n  text-align: right;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1f2937;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.other-custom-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 0 0 auto;\n  min-width: 0;\n}\n\n.other-custom-label {\n  min-width: 90px;\n  margin-right: 0;\n}\n\n/* ---------- SHOP MANAGEMENT / REGISTRATION ------------------------ */\n.shop-management-panel {\n  margin-top: 24px;\n}\n\n.shop-management-panel-header {\n  align-items: flex-start;\n  display: flex;\n  gap: 16px;\n  justify-content: space-between;\n}\n\n.shop-management-panel-header .ant-btn {\n  flex: 0 0 auto;\n}\n\n.shop-management-permission-note,\n.shop-management-error {\n  margin-bottom: 20px;\n}\n\n.shop-management-history-section {\n  border-top: 1px solid #e2e8f0;\n  margin-top: 24px;\n  padding-top: 24px;\n}\n\n.shop-management-subsection-header {\n  align-items: baseline;\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.shop-management-subsection-header h4 {\n  color: #1a202c;\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.shop-management-subsection-header span {\n  color: #718096;\n  font-size: 13px;\n}\n\n.shop-management-empty {\n  background: #f8fafc;\n  border: 1px dashed #cbd5e0;\n  border-radius: 6px;\n  color: #718096;\n  font-size: 14px;\n  padding: 20px;\n  text-align: center;\n}\n\n.shop-management-table-wrapper {\n  max-width: 100%;\n  overflow-x: auto;\n  width: 100%;\n}\n\n.shop-management-table {\n  border-collapse: collapse;\n  min-width: 720px;\n  table-layout: fixed;\n  width: 100%;\n}\n\n.shop-management-table th,\n.shop-management-table td {\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 13px;\n  padding: 11px 10px;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.shop-management-table th {\n  background: #f1f5f9;\n  color: #334155;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.shop-management-table td {\n  color: #334155;\n  overflow-wrap: anywhere;\n}\n\n.shop-management-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.shop-management-table th:nth-child(1),\n.shop-management-table td:nth-child(1) {\n  width: 24%;\n}\n\n.shop-management-table th:nth-child(2),\n.shop-management-table td:nth-child(2) {\n  width: 20%;\n}\n\n.shop-management-table th:nth-child(3),\n.shop-management-table td:nth-child(3) {\n  width: 34%;\n}\n\n.shop-management-table th:nth-child(4),\n.shop-management-table td:nth-child(4) {\n  width: 22%;\n}\n\n.shop-management-application-table {\n  min-width: 860px;\n}\n\n.shop-management-application-table th:nth-child(1),\n.shop-management-application-table td:nth-child(1) {\n  width: 100px;\n}\n\n.shop-management-application-table th:nth-child(2),\n.shop-management-application-table td:nth-child(2) {\n  width: 170px;\n}\n\n.shop-management-application-table th:nth-child(3),\n.shop-management-application-table td:nth-child(3) {\n  width: 130px;\n}\n\n.shop-management-application-table th:nth-child(4),\n.shop-management-application-table td:nth-child(4) {\n  width: 110px;\n}\n\n.shop-management-application-table th:nth-child(5),\n.shop-management-application-table td:nth-child(5) {\n  width: 250px;\n}\n\n.shop-management-application-table th:nth-child(6),\n.shop-management-application-table td:nth-child(6) {\n  width: 90px;\n}\n\n.shop-management-reason-cell {\n  max-width: 250px;\n  white-space: pre-wrap;\n}\n\n.shop-registration-status {\n  border-radius: 999px;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.4;\n  padding: 3px 9px;\n  white-space: nowrap;\n}\n\n.shop-registration-status--submitted {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.shop-registration-status--returned {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.shop-registration-status--approved {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.shop-registration-status--rejected {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.shop-registration-page {\n  margin: 0 auto;\n  max-width: 980px;\n  width: 100%;\n}\n\n.shop-registration-page-header {\n  align-items: center;\n  display: flex;\n  gap: 16px;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.shop-registration-page-header p {\n  color: #718096;\n  font-size: 13px;\n  margin: 0 0 4px;\n}\n\n.shop-registration-page-header h2 {\n  color: var(--primary);\n  font-size: 24px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.shop-registration-status-panel {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  display: flex;\n  gap: 16px;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  padding: 16px 20px;\n}\n\n.shop-registration-status-panel > div {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n}\n\n.shop-registration-status-panel-label,\n.shop-registration-status-panel-id {\n  color: #475569;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.shop-registration-status-panel-id {\n  color: #64748b;\n  font-weight: 400;\n}\n\n.shop-registration-reason-alert {\n  margin-bottom: 16px;\n}\n\n.shop-registration-history-panel {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  padding: 18px 20px;\n}\n\n.shop-registration-history-panel h3 {\n  color: #1a202c;\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0 0 12px;\n}\n\n.shop-registration-history-panel ul {\n  display: grid;\n  gap: 10px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.shop-registration-history-panel li {\n  align-items: baseline;\n  border-bottom: 1px solid #f1f5f9;\n  display: grid;\n  gap: 8px 14px;\n  grid-template-columns: 90px 180px minmax(0, 1fr);\n  padding-bottom: 10px;\n}\n\n.shop-registration-history-panel li:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.shop-registration-history-panel li > span {\n  color: #334155;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.shop-registration-history-panel time,\n.shop-registration-history-panel p {\n  color: #64748b;\n  font-size: 13px;\n  margin: 0;\n}\n\n.shop-registration-section,\n.shop-registration-review {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 24px;\n}\n\n.shop-registration-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.shop-registration-section-heading {\n  align-items: flex-start;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n  padding-bottom: 14px;\n}\n\n.shop-registration-section-number {\n  align-items: center;\n  background: var(--primary);\n  border-radius: 50%;\n  color: white;\n  display: inline-flex;\n  flex: 0 0 28px;\n  font-size: 14px;\n  font-weight: 700;\n  height: 28px;\n  justify-content: center;\n  width: 28px;\n}\n\n.shop-registration-section-heading h3 {\n  color: #1a202c;\n  font-size: 18px;\n  font-weight: 700;\n  margin: 0 0 4px;\n}\n\n.shop-registration-section-heading p,\n.shop-registration-subsection-note,\n.shop-registration-form-note p,\n.shop-registration-review-lead {\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.shop-registration-form-grid {\n  display: grid;\n  gap: 4px 18px;\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n}\n\n.shop-registration-form-grid > .ant-form-item {\n  grid-column: span 6;\n  min-width: 0;\n}\n\n.shop-registration-form-grid > .shop-registration-field--postcode {\n  grid-column: span 4;\n}\n\n.shop-registration-form-grid > .shop-registration-field--wide {\n  grid-column: 1 / -1;\n}\n\n.shop-registration-form .ant-form-item {\n  margin-bottom: 16px;\n}\n\n.shop-registration-form .ant-form-item-label > label {\n  color: #334155;\n  font-weight: 600;\n}\n\n.shop-registration-bank-fields {\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n  margin-top: 4px;\n  padding: 16px 16px 0;\n}\n\n.shop-registration-form-note {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 6px;\n  padding: 12px 16px;\n}\n\n.shop-registration-actions {\n  align-items: center;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 4px;\n  padding-top: 20px;\n}\n\n.shop-registration-review {\n  margin-top: 16px;\n}\n\n.shop-registration-review-lead {\n  margin-bottom: 18px;\n}\n\n.shop-registration-review-grid {\n  display: grid;\n  gap: 0 24px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin: 0;\n}\n\n.shop-registration-review-grid > div {\n  border-bottom: 1px solid #e2e8f0;\n  display: grid;\n  gap: 12px;\n  grid-template-columns: minmax(150px, 0.4fr) minmax(0, 1fr);\n  padding: 10px 0;\n}\n\n.shop-registration-review-grid dt {\n  color: #64748b;\n  font-size: 13px;\n}\n\n.shop-registration-review-grid dd {\n  color: #1e293b;\n  font-size: 14px;\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n.shop-registration-forbidden {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: 60vh;\n}\n\n@media (max-width: 768px) {\n  .shop-management-panel-header,\n  .shop-registration-page-header {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .shop-management-panel-header .ant-btn,\n  .shop-registration-page-header .ant-btn {\n    align-self: flex-start;\n  }\n\n  .shop-registration-section,\n  .shop-registration-review {\n    padding: 18px;\n  }\n\n  .shop-registration-form-grid {\n    display: block;\n  }\n\n  .shop-registration-form-grid > .ant-form-item,\n  .shop-registration-form-grid > .shop-registration-field--postcode,\n  .shop-registration-form-grid > .shop-registration-field--wide {\n    width: 100%;\n  }\n\n  .shop-registration-bank-fields {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  .shop-registration-status-panel {\n    align-items: flex-start;\n    flex-direction: column;\n    padding: 14px 16px;\n  }\n\n  .shop-registration-status-panel > div {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .shop-registration-history-panel li {\n    grid-template-columns: 1fr;\n  }\n\n  .shop-registration-review-grid {\n    display: block;\n  }\n\n  .shop-registration-actions {\n    justify-content: stretch;\n  }\n\n  .shop-registration-actions .ant-btn {\n    flex: 1 1 0;\n  }\n}\n\n.other-custom-row {\n  align-items: flex-start;\n}\n\n.other-custom-inputs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n  align-items: start;\n}\n\n.other-custom-inputs__label-col {\n  display: flex;\n  flex-direction: column;\n}\n\n.other-custom-inputs__label-col .other-name-input {\n  width: 100%;\n}\n\n.other-custom-inputs__amount-col {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.other-name-input {\n  width: 180px;\n  flex: 0 0 auto;\n  min-width: 0;\n  max-width: none;\n  padding: 6px 8px;\n  border: 1px solid #dc2626;\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: white;\n}\n\n.other-name-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px #3b82f6;\n}\n\n/* Cost item label style adjustment */\n.cost-label {\n  font-weight: 500;\n  color: #374151;\n  text-align: left;\n  min-width: 120px;\n  margin-right: 12px;\n}\n\n.monthly-costs-section .cost-label {\n  color: #991b1b;\n  font-weight: 600;\n}\n\n/* Amount input field style adjustment */\n.cost-input-group {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.cost-input {\n  width: 120px;\n  text-align: right;\n  font-weight: 500;\n}\n\n.monthly-costs-section .cost-input {\n  border: 1px solid #dc2626;\n  background-color: white;\n}\n\n.cost-total-value {\n  font-weight: 700;\n  color: #374151;\n  font-size: 16px;\n}\n\n.monthly-costs-section .cost-total-value {\n  color: #991b1b;\n}\n\n/* レスポンシブ対応 */\n@media (max-width: 768px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .property-subsection {\n    margin-bottom: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .cost-input-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .cost-label {\n    min-width: auto;\n    margin-right: 0;\n  }\n\n  .monthly-costs-header {\n    margin: 16px -16px 0;\n    padding: 12px 16px;\n  }\n\n  .monthly-costs-section {\n    margin: 0 -16px 16px;\n    padding: 12px;\n  }\n\n  .monthly-costs-section .cost-total-row {\n    margin: 8px -12px -12px;\n    padding: 12px;\n  }\n\n  .cost-input-row-stack-mobile {\n    align-items: stretch;\n  }\n\n  .other-subsection-body {\n    padding-left: 0;\n  }\n\n  .other-subsection-summary {\n    align-self: flex-end;\n  }\n\n  .other-custom-left {\n    width: 100%;\n  }\n\n  .other-name-input {\n    flex: 1 1 auto;\n    width: auto;\n  }\n}\n\n/* Delay status display styles */\n.delay-row {\n  background-color: #fef2f2 !important;\n  /* 薄い赤色背景 */\n}\n\n.delay-row:hover {\n  background-color: #fecaca !important;\n  /* ホバー時は少し濃い赤 */\n}\n\n.delay-status {\n  padding: 8px;\n}\n\n.delay-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.delay-months {\n  font-weight: 600;\n  color: #dc2626;\n}\n\n.delay-tag {\n  background-color: #dc2626;\n  color: white;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.delay-normal {\n  color: #059669;\n  font-weight: 600;\n}\n\n/* Search and filter UI improvements */\n.filters-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.search-input {\n  flex: 1;\n  padding: 10px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  min-width: 200px;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n.status-select {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  min-width: 120px;\n}\n\n.status-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n.search-btn {\n  padding: 10px 20px;\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.search-btn:hover {\n  background-color: #2563eb;\n}\n\n.clear-btn {\n  padding: 10px 16px;\n  background-color: #f1f5f9;\n  color: #64748b;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.clear-btn:hover {\n  background-color: #e2e8f0;\n  border-color: #94a3b8;\n}\n\n/* Cancel button for review table */\n.btn-cancel {\n  background-color: #dc2626;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  white-space: nowrap;\n}\n\n.btn-cancel:hover {\n  background-color: #b91c1c;\n}\n\n.bill-section .ant-input-affix-wrapper input.ant-input {\n  text-align: right;\n}\n\n.custom-upload .ant-upload {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.custom-upload .ant-upload-list {\n  margin-left: 2rem;\n}\n\n.custom-upload .ant-upload-list-item {\n  padding: 0;\n  background: none;\n  border: none;\n  font-size: 13px;\n  color: #2563eb;\n}\n\n.ag-horizontal-left-scroll {\n  height: 0px !important;\n  min-height: 0px !important;\n  opacity: 0 !important;\n  pointer-events: none !important;\n}\n\n/* Hide left spacer */\n.ag-horizontal-left-spacer {\n  height: 0px !important;\n  opacity: 0 !important;\n  pointer-events: none !important;\n}\n\n/* delete padding default Ag Grid */\n.no-pad-cell {\n  padding: 0 !important;\n}\n.ag-header-cell-label {\n  justify-content: center;\n}\n.ag-header-cell-text {\n  white-space: pre-wrap;\n}\n.ag-header-cell-label {\n  height: fit-content;\n}\n\n.inclusive-rooms-grid .ag-header-group-cell-label,\n.inclusive-rooms-grid .ag-header-cell-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100% !important;\n}\n\n.inclusive-rooms-grid .ag-header-group-cell,\n.inclusive-rooms-grid .ag-header-cell {\n  border-right: 1px solid #e5e7eb !important;\n  border-bottom: 1px solid #e5e7eb !important;\n}\n\n.inclusive-rooms-grid .ag-header-group-cell::after,\n.inclusive-rooms-grid .ag-header-cell::after,\n.inclusive-rooms-grid .ag-header-group-cell-resize,\n.inclusive-rooms-grid .ag-header-cell-resize {\n  display: none !important;\n}\n\n.select-error .ant-select-selector,\n.select-error .ant-select {\n  background-color: rgb(254 226 226) !important;\n}\n\n.select-40 .ant-select-selector,\n.select-40 .ant-select-selection-item,\n.select-40 .ant-select-selection-search-input {\n  height: 40px !important;\n  line-height: 40px !important;\n}\n\n.select-40 .ant-select-arrow {\n  height: 25px !important;\n  align-items: center !important;\n}\n\n.inclusive-detail-table .ant-table-thead .ant-table-cell {\n  background: var(--primary) !important;\n  color: white !important;\n}\n\n/* Keep the wide inclusive-contract table usable without moving the page itself. */\n.inclusive-detail-table {\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.inclusive-detail-table .ant-table-body {\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable both-edges;\n}\n\n.date-40 .ant-picker {\n  height: 30px !important;\n  padding: 0 12px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n/* Input text inside */\n.date-40 .ant-picker-input > input {\n  height: 30px !important;\n  line-height: 30px !important;\n}\n\n/* Icon calendar */\n.date-40 .ant-picker-suffix {\n  height: 30px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n/* custom tooltip */\n.wrap-tooltip .truncate {\n  white-space: wrap;\n}\n\n.shop-select .ant-select-selection-item {\n  max-width: 100% !important;\n  display: inline-block !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n\n.shop-select .ant-select-selector {\n  width: 500px !important;\n}\n.checkbox-custom * {\n  cursor: not-allowed !important;\n\n  input {\n    cursor: not-allowed;\n  }\n}\n\n/* inital-guarantee-fee-table */\n.received-invoice-table {\n  table-layout: fixed;\n  min-width: 1180px;\n}\n\n.received-invoice-table th,\n.received-invoice-table td,\n.inital-guarantee-fee-table th,\n.inital-guarantee-fee-table td {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.received-invoice-table .sortable-header,\n.inital-guarantee-fee-table .sortable-header {\n  white-space: nowrap;\n}\n\n.received-invoice-table th:nth-child(1),\n.received-invoice-table td:nth-child(1) {\n  width: 150px;\n}\n.received-invoice-table th:nth-child(2),\n.received-invoice-table td:nth-child(2) {\n  width: 120px;\n}\n.received-invoice-table th:nth-child(3),\n.received-invoice-table td:nth-child(3) {\n  width: 160px;\n}\n.received-invoice-table th:nth-child(4),\n.received-invoice-table td:nth-child(4) {\n  width: 260px;\n}\n.received-invoice-table th:nth-child(5),\n.received-invoice-table td:nth-child(5) {\n  width: 120px;\n}\n.received-invoice-table th:nth-child(6),\n.received-invoice-table td:nth-child(6) {\n  width: 130px;\n}\n.received-invoice-table th:nth-child(7),\n.received-invoice-table td:nth-child(7) {\n  width: 130px;\n}\n.received-invoice-table th:nth-child(8),\n.received-invoice-table td:nth-child(8) {\n  width: 110px;\n}\n\n.inital-guarantee-fee-table {\n  table-layout: fixed;\n  min-width: 1440px;\n}\n.inital-guarantee-fee-table th:nth-child(1),\n.inital-guarantee-fee-table td:nth-child(1) {\n  width: 56px;\n}\n.inital-guarantee-fee-table th:nth-child(2),\n.inital-guarantee-fee-table td:nth-child(2) {\n  width: 150px;\n}\n.inital-guarantee-fee-table th:nth-child(3),\n.inital-guarantee-fee-table td:nth-child(3) {\n  width: 130px;\n}\n.inital-guarantee-fee-table th:nth-child(4),\n.inital-guarantee-fee-table td:nth-child(4) {\n  width: 150px;\n}\n.inital-guarantee-fee-table th:nth-child(5),\n.inital-guarantee-fee-table td:nth-child(5) {\n  width: 260px;\n}\n.inital-guarantee-fee-table th:nth-child(6),\n.inital-guarantee-fee-table td:nth-child(6) {\n  width: 130px;\n}\n.inital-guarantee-fee-table th:nth-child(7),\n.inital-guarantee-fee-table td:nth-child(7) {\n  width: 130px;\n}\n.inital-guarantee-fee-table th:nth-child(8),\n.inital-guarantee-fee-table td:nth-child(8) {\n  width: 140px;\n}\n.inital-guarantee-fee-table th:nth-child(9),\n.inital-guarantee-fee-table td:nth-child(9) {\n  width: 294px;\n}\n\n/* ===============================\n   AntD Upload List (Text Mode)\n   Custom Rebuild CSS\n   =============================== */\n\n/* LIST CONTAINER */\n.custom-upload-list .ant-upload-list {\n  margin-top: 8px;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.88);\n}\n\n/* ITEM CONTAINER */\n.custom-upload-list .ant-upload-list-item-container {\n  position: relative;\n}\n\n/* ITEM */\n.custom-upload-list .ant-upload-list-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 1px 12px;\n  border-radius: 8px;\n  min-width: 0;\n  transition: background-color 0.2s ease;\n}\n\n/* HOVER BACKGROUND */\n.custom-upload-list .ant-upload-list-item:hover {\n  background-color: #f5f8ff;\n}\n\n/* ICON */\n.custom-upload-list .ant-upload-icon {\n  flex-shrink: 0;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.45);\n}\n\n/* FILE NAME */\n.custom-upload-list .ant-upload-list-item-name {\n  flex: 1;\n  min-width: 0;\n  color: rgba(0, 0, 0, 0.88);\n  cursor: pointer;\n  font-size: 12px;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* FILE NAME HOVER */\n.custom-upload-list .ant-upload-list-item:hover .ant-upload-list-item-name {\n  color: #1677ff;\n}\n\n/* ACTIONS (DELETE) */\n.custom-upload-list .ant-upload-list-item-actions {\n  flex-shrink: 0;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  font-size: 12px;\n}\n\n/* SHOW ACTION ON HOVER */\n.custom-upload-list .ant-upload-list-item:hover .ant-upload-list-item-actions {\n  opacity: 1;\n}\n\n/* SHOW ACTION WHEN REACHED BY KEYBOARD */\n.custom-upload-list .ant-upload-list-item:focus-within .ant-upload-list-item-actions {\n  opacity: 1;\n}\n\n.custom-upload-list .ant-upload-list-item-actions .ant-btn:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n/* DELETE BUTTON */\n.custom-upload-list .ant-upload-list-item-actions .ant-btn {\n  color: rgba(0, 0, 0, 0.45);\n}\n\n/* DELETE HOVER */\n.custom-upload-list .ant-upload-list-item-actions .ant-btn:hover {\n  color: #ff4d4f;\n}\n\n/* OPTIONAL: divider feeling (very AntD-like) */\n.custom-upload-list .ant-upload-list-item-container::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: 8px;\n  pointer-events: none;\n}\n\n.contract-issuance-modal .ant-modal-content {\n  overflow: hidden;\n}\n\n.contract-issuance-modal .ant-modal-body {\n  max-height: min(68vh, 620px);\n  overflow-y: auto;\n  padding: 0 4px 4px;\n}\n\n.contract-issuance-body {\n  color: #1f2937;\n}\n\n.contract-issuance-body h3 {\n  margin: 0 0 16px;\n  color: #1f2937;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.contract-issuance-info-section {\n  margin-top: 22px;\n}\n\n.contract-issuance-section {\n  margin-top: 16px;\n  border-top: 1px solid #e5e7eb;\n  padding-top: 14px;\n}\n\n.contract-issuance-section h4 {\n  margin: 0 0 10px;\n  color: #374151;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.contract-issuance-person-grid,\n.contract-issuance-bank-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 14px;\n}\n\n.contract-issuance-bank-grid {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.contract-issuance-field {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 4px;\n  color: #4b5563;\n  font-size: 12px;\n}\n\n.contract-issuance-label {\n  display: inline-flex;\n  align-items: baseline;\n  max-width: 100%;\n  white-space: nowrap;\n}\n\n.contract-issuance-radio-group {\n  display: flex;\n  min-width: 0;\n  max-width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  flex-wrap: nowrap;\n  gap: 4px 16px;\n}\n\n.contract-issuance-radio-group .ant-radio-wrapper {\n  flex: 0 0 auto;\n  margin-inline-end: 0;\n  white-space: nowrap;\n}\n\n.contract-issuance-field input {\n  min-height: 32px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  padding: 5px 8px;\n  color: #111827;\n  font-size: 13px;\n}\n\n.contract-issuance-field input:focus {\n  border-color: #1677ff;\n  outline: 2px solid rgb(22 119 255 / 15%);\n}\n\n.contract-issuance-field input:disabled {\n  background: #f3f4f6;\n  color: #374151;\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n.contract-issuance-field-error input {\n  border-color: #ff4d4f;\n}\n\n.contract-issuance-error {\n  color: #dc2626;\n  font-size: 11px;\n}\n\n.contract-issuance-rent,\n.contract-issuance-caution,\n.contract-issuance-preview-card {\n  margin-top: 16px;\n  border-radius: 4px;\n  padding: 12px;\n}\n\n.contract-issuance-rent {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: #f9fafb;\n  font-size: 13px;\n}\n\n.contract-issuance-rent .contract-issuance-radio-group {\n  align-items: center;\n}\n\n.contract-issuance-caution {\n  color: #dc2626;\n  background: #fff7ed;\n  font-size: 12px;\n}\n\n.contract-issuance-caution ul {\n  margin: 6px 0 0 18px;\n  list-style: disc;\n}\n\n.contract-issuance-preview-card {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n  background: #eff6ff;\n  color: #1e3a8a;\n  font-size: 12px;\n}\n\n.contract-issuance-hint {\n  margin: 10px 0 0;\n  color: #4b5563;\n  font-size: 12px;\n}\n\n.contract-issuance-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 0 8px 4px;\n}\n\n@media (max-width: 1100px) {\n  .contract-issuance-modal .ant-modal {\n    max-width: calc(100vw - 32px);\n  }\n\n  .contract-issuance-bank-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 700px) {\n  .contract-issuance-person-grid,\n  .contract-issuance-bank-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
